// GENERATED by tools/build/gen-icon-data.mjs (npm run gen:icon-data) from the PHP catalogs.
// NamedIcon — projection of the ~50 SHARED game catalogs (Skill/StatusEffect/DamageType/…), keyed by variable_name AND UUID. GENERATED — do not hand-edit; refresh via npm run gen:icon-data.
import type { IconMap } from '../types';

export const SHARED_CATALOG_ICONS: IconMap = {
	"0066C87E-FCD4-4FF6-BE4B-A6D22F234565": {
		"file": "mount_held_off",
		"tooltip": "Visual Mount — Held Off Hand"
	},
	"00E1B7B8-F92D-5D24-0FF0-40DC21672F47": {
		"file": "injested_poison",
		"tooltip": "Ingested Poison"
	},
	"01671C87-2DB5-B7C0-6312-FCCD4C20C128": {
		"file": "ooze",
		"tooltip": "Ooze"
	},
	"018F9A3D-E3AF-ECBE-AE14-7781C5AE849C": {
		"file": "acropolis_citadel",
		"tooltip": "Acropolis Citadel"
	},
	"01B0F693-7D8A-C588-9B34-CD1F323D8433": {
		"file": "shielded_10",
		"tooltip": "Shielded 10"
	},
	"02673CAF-5E3B-966B-24EF-A6C8883169D8": {
		"file": "temperature_warm",
		"tooltip": "Warm"
	},
	"028A33EB-3EAA-BD59-70B2-BE7F13C7F420": {
		"file": "town",
		"tooltip": "Town"
	},
	"02B6141A-3CB2-F5A2-0159-9D72121C5880": {
		"file": "smelter",
		"tooltip": "Smelter"
	},
	"02FFED44-7A58-4EF2-EF07-2FFD980A3049": {
		"file": "min_skill_tier_14",
		"tooltip": "Natural Weapon (min skill tier 14)"
	},
	"0313A4D7-C1C2-4D1B-8DD7-CC6EDBC42065": {
		"file": "dimmed",
		"tooltip": "Dimmed"
	},
	"031CE1BD-22BF-7A83-3B12-EDC30FEB8907": {
		"file": "catacomb",
		"tooltip": "Catacomb"
	},
	"0384E40E-523D-0BE4-D069-220585742363": {
		"file": "landmass",
		"tooltip": "Landmass"
	},
	"03E06BE0-F073-0D9B-E804-A9F014FAFF07": {
		"file": "infernal",
		"tooltip": "Infernal"
	},
	"04494E0F-FD0B-B2E7-3E15-94922127ADA2": {
		"file": "sun_state_sunrise",
		"tooltip": "Sun State Sunrise"
	},
	"04745434-A050-1300-ADA4-DB9C151E9A0A": {
		"file": "rapids",
		"tooltip": "Rapids"
	},
	"04C6725E-ED55-748C-DA58-3459A75D8603": {
		"file": "canyon",
		"tooltip": "Canyon"
	},
	"04C9B518-EFE2-578C-6B35-536B84538C2D": {
		"file": "blood_of_the_pyre",
		"tooltip": "Blood Of The Pyre"
	},
	"04F77A14-C227-1D47-B487-46C14A75695C": {
		"file": "barber_dentist_surgery",
		"tooltip": "Barber Dentist Surgery"
	},
	"057BA9B2-177C-40A6-8815-8063DDDC0D9B": {
		"file": "aoe_redirection",
		"tooltip": "AOE Redirection"
	},
	"05DEF6F9-8090-5240-41F9-A45ED1DA95BE": {
		"file": "prison",
		"tooltip": "Prison"
	},
	"068FC154-D699-45DE-B085-F02B23F94DB9": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Tongue"
	},
	"069D9D1E-4C1F-B438-AA1C-CA1133E67B37": {
		"file": "technology_complex",
		"tooltip": "Technology Complex"
	},
	"06BBC9AA-3BED-43A4-9EC3-96072F827C04": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Stomp"
	},
	"0700727F-6C9E-4631-1140-B57A8E442137": {
		"file": "draconic",
		"tooltip": "Draconic"
	},
	"074B01B3-D3FB-7D5D-7248-DBB0BAD7CA3B": {
		"file": "museum",
		"tooltip": "Museum"
	},
	"0811463E-C4F6-72F5-791C-E8CA97F730EE": {
		"file": "core_of_the_pyromechanist",
		"tooltip": "Core Of The Pyromechanist"
	},
	"0831E19B-EB88-2B7E-DC7E-55739032AEAF": {
		"file": "stringed_bow",
		"tooltip": "Stringed Bow"
	},
	"088D272A-90C4-738E-A49B-621FB95046CF": {
		"file": "manifestation_of_pyrokinesis",
		"tooltip": "Manifestation Of Pyrokinesis"
	},
	"08B1A969-4874-61C8-41FD-C86A39A780D6": {
		"file": "oath_of_vengeance",
		"tooltip": "Oath Of Vengeance"
	},
	"090BED9F-3D77-FD4E-114C-3CA2963C896C": {
		"file": "core_of_the_voltaic",
		"tooltip": "Core Of The Voltaic"
	},
	"091B2BEE-7F61-D7DB-0CF1-6D255F4B7663": {
		"file": "hasted",
		"tooltip": "Hasted"
	},
	"091CBC18-FF1D-6072-3190-90EFAEDDE6F5": {
		"file": "greater_powerful",
		"tooltip": "Greater Powerful"
	},
	"095BC6BC-06F6-74E0-2B8A-FC1F32AF809B": {
		"file": "sleeping",
		"tooltip": "Sleeping"
	},
	"09FC38BC-6060-4B67-A33F-EF7D448F71F1": {
		"file": "burning",
		"tooltip": "Burning"
	},
	"0A29E071-0E93-3368-2391-0EEAE4445485": {
		"file": "embassy",
		"tooltip": "Embassy"
	},
	"0A68ECAB-D224-CF73-DB51-761BCFD663FA": {
		"file": "smithing",
		"tooltip": "Smithing"
	},
	"0A9A7DD9-6446-41B4-959E-82C3F965E6F5": {
		"file": "training_in_juggernaut",
		"tooltip": "Training In Juggernaut"
	},
	"0ACC97BD-521B-E6AD-BCC7-C2AB1256C384": {
		"file": "barracks",
		"tooltip": "Barracks"
	},
	"0AE91E6D-A890-D3A2-FE54-F6CBEF86A19B": {
		"file": "storage_house",
		"tooltip": "Storage House"
	},
	"0B279A55-5102-D704-8A57-0C1FF4989DFA": {
		"file": "armor",
		"tooltip": "Armor"
	},
	"0B3A4002-A031-7DCB-6E61-0F604311B485": {
		"file": "conclave_of_the_bounty_hunter",
		"tooltip": "Conclave Of The Bounty Hunter"
	},
	"0B64D4D7-5D04-FEB6-D098-3EB925AC516B": {
		"file": "injury_poison",
		"tooltip": "Injury Poison"
	},
	"0B856F82-037C-730C-A36F-E2889CAB2678": {
		"file": "asylum",
		"tooltip": "Asylum"
	},
	"0BACFBA4-0921-41CB-B586-2B68D5BF391B": {
		"file": "mount_worn",
		"tooltip": "Visual Mount — Worn"
	},
	"0BB1AF70-531F-5635-DB98-79FF1B815AC8": {
		"file": "memorial_war_memorial",
		"tooltip": "Memorial War Memorial"
	},
	"0BCF6373-E9E3-AD11-90B8-7D44FBC2AA62": {
		"file": "shard_of_the_glass_mage",
		"tooltip": "Shard of the Glass Mage"
	},
	"0C28BA28-6CE7-96E1-2817-CED702C122D4": {
		"file": "aqueduct",
		"tooltip": "Aqueduct"
	},
	"0C2A8037-B0BC-8300-C818-198881B00E7D": {
		"file": "grappled",
		"tooltip": "Grappled"
	},
	"0C528CF8-1B5A-453C-9BDE-73CBBC239A2A": {
		"file": "bludgeoning",
		"tooltip": "Bludgeoning"
	},
	"0C569B27-1F4C-AE8D-F3C6-19F4241557CD": {
		"file": "craftsman_tanner",
		"tooltip": "Craftsman Tanner"
	},
	"0CC8A592-CF4C-7BE4-DD0C-17A41D690A05": {
		"file": "bright_light",
		"tooltip": "Bright Light"
	},
	"0D180E23-D233-0522-4393-D513DF5C39F8": {
		"file": "island",
		"tooltip": "Island"
	},
	"0D629F19-23AC-18BE-B79C-73CB52703F66": {
		"file": "male",
		"tooltip": "Male"
	},
	"0D7FEDA8-DC2A-6048-5C13-73219F1F0B4F": {
		"file": "monstrosity",
		"tooltip": "Monstrosity"
	},
	"0DBBBB72-BEAF-DD44-7903-8D37BE097B12": {
		"file": "hill_location",
		"tooltip": "Hill Location"
	},
	"0DBFA54E-F921-4835-B159-2A4AEFA62408": {
		"file": "cube",
		"tooltip": "Cube"
	},
	"0DFDEEF9-B497-2E86-F425-C772528B1ED7": {
		"file": "blade_of_the_vanishing_edge",
		"tooltip": "Blade Of The Vanishing Edge"
	},
	"0E37C3D2-CFA6-A1B2-F352-D2121868C425": {
		"file": "spider_stance",
		"tooltip": "Spider Stance"
	},
	"0E819470-A8D6-FB8F-F1AE-74AFB05BC777": {
		"file": "core_of_the_graviturge",
		"tooltip": "Core Of The Graviturge"
	},
	"0E85B423-C980-04E1-D7BE-B3F87A8934F2": {
		"file": "patron_of_chance",
		"tooltip": "Patron Of Chance"
	},
	"0F7BF513-E0CF-822A-C0ED-12F4ECC03F47": {
		"file": "grassland",
		"tooltip": "Grassland"
	},
	"0FEF0148-6B62-4601-A8A1-A5A1A22905D8": {
		"file": "cone",
		"tooltip": "Cone"
	},
	"10278E95-5320-A57E-471F-C3E7AEFA70BA": {
		"file": "bolstered",
		"tooltip": "Bolstered"
	},
	"10341BAB-04C6-8829-EC7A-F647487F6317": {
		"file": "palace",
		"tooltip": "Palace"
	},
	"103C97E3-AEBE-4964-788E-45E35FF246A6": {
		"file": "nebula",
		"tooltip": "Nebula"
	},
	"10657AA2-E10A-4C86-A814-B3A24B0CB252": {
		"file": "gamesmanship",
		"tooltip": "Gamesmanship"
	},
	"107529B3-B41B-1595-A83B-4A2F981819AE": {
		"file": "blade_of_the_eidolon",
		"tooltip": "Blade Of The Eidolon"
	},
	"107CF709-348E-4234-B92C-D7BA6F5579CB": {
		"file": "off_hand",
		"tooltip": "Grip Training"
	},
	"109D10A8-1E25-82E0-A6D4-AE628732BD2B": {
		"file": "planetary_ring",
		"tooltip": "Planetary Ring"
	},
	"10C28483-A0E9-467F-993B-CBC440546A52": {
		"file": "received_prayer_of_healing",
		"tooltip": "Received Prayer of Healing"
	},
	"114E1810-D8A6-72C2-54B8-7EDBC5D43A57": {
		"file": "skinning",
		"tooltip": "Skinning"
	},
	"11797B93-B552-807F-C1D7-B75DAB51EC34": {
		"file": "abyssal",
		"tooltip": "Abyssal"
	},
	"1194F357-C419-2931-27B4-3B56F26BFBA7": {
		"file": "invulnerable",
		"tooltip": "Invulnerable"
	},
	"11A12BCF-4538-89D2-3888-9A03790072C4": {
		"file": "garden",
		"tooltip": "Garden"
	},
	"11CFEA10-2B51-15D7-C40D-2B985A50A921": {
		"file": "blade_of_the_grimoire",
		"tooltip": "Blade Of The Grimoire"
	},
	"11DCFC7B-887A-7FD3-8423-DFC5B16AD336": {
		"file": "song_of_the_celestial_choir",
		"tooltip": "Song Of The Celestial Choir"
	},
	"11E3CC41-2645-4423-8841-8F4B531C4920": {
		"file": "mount_worn_torso",
		"tooltip": "Visual Mount — Worn: Torso"
	},
	"1214C099-5021-24B5-5D8D-608B832CE70A": {
		"file": "female",
		"tooltip": "Female"
	},
	"126B1B2D-5ED1-1DA4-AE38-34301FAEF2C2": {
		"file": "temperature_cool",
		"tooltip": "Cool"
	},
	"12D25118-B86A-80A5-01BC-C9427BD83D17": {
		"file": "quarterstaffs",
		"tooltip": "Quarterstaffs"
	},
	"1306C042-A7D0-1C4D-2AE7-3E614450712C": {
		"file": "missile_cavalry",
		"tooltip": "Missile Cavalry"
	},
	"130E2C92-D278-DEDE-3317-EB81F6EEAC78": {
		"file": "archipelago",
		"tooltip": "Archipelago"
	},
	"13456FEC-A2EE-DB46-5829-0EB2F627E1B7": {
		"file": "tiny",
		"tooltip": "Tiny"
	},
	"13511E61-2267-7485-0BC9-E618025D352A": {
		"file": "capital",
		"tooltip": "Capital"
	},
	"135EB0F1-BBAD-F5D3-28C1-9C4E6D019051": {
		"file": "specialist_in_assassination",
		"tooltip": "Specialist In Assassination"
	},
	"1364260D-E37C-4257-AD16-5E745107811A": {
		"file": "melee_weapon_type",
		"tooltip": "Melee Weapon Type"
	},
	"139AFF5A-528C-A922-5436-5A2852C82F90": {
		"file": "house_large",
		"tooltip": "House Large"
	},
	"13C64193-606F-CA6E-2148-C899AB761ED7": {
		"file": "zithers",
		"tooltip": "Zithers"
	},
	"1425763D-BEB3-7626-9B00-8B08AA74BCEE": {
		"file": "water_pump",
		"tooltip": "Water Pump"
	},
	"1489C64C-AA0E-BF03-A01B-E60E07B8B2E8": {
		"file": "tundra",
		"tooltip": "Tundra"
	},
	"14B166A9-668E-204D-A675-B76B0979442D": {
		"file": "study_of_time",
		"tooltip": "Study Of Time"
	},
	"156DBFAC-2D11-5257-0AD1-619760D890CD": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 7+)"
	},
	"15DE60F1-65E9-E3DC-E47C-41C53D0BFD79": {
		"file": "taiga",
		"tooltip": "Taiga"
	},
	"15F48526-5526-FD30-8C4B-38E916A66918": {
		"file": "large_town",
		"tooltip": "Large Town"
	},
	"16333E5C-F1C9-163E-B688-05A05BE0B099": {
		"file": "urban",
		"tooltip": "Urban"
	},
	"166EBD0E-7FC0-7351-5F82-C84F9B48565D": {
		"file": "arrow",
		"tooltip": "Arrows"
	},
	"16A53E58-027B-DF11-6AC5-72CA13B6583A": {
		"file": "orcish",
		"tooltip": "Orcish"
	},
	"16ABAE95-5D18-474D-ADFF-8C20FC2439F1": {
		"file": "tail",
		"tooltip": "Tail"
	},
	"16DE3886-A2B7-4957-A751-AE08F048BADD": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Tentacle"
	},
	"16E69F5F-9D8C-4C81-F492-5008E7CCA0A5": {
		"file": "patron_of_secrets",
		"tooltip": "Patron Of Secrets"
	},
	"16F6B377-200C-3FBC-966B-6E9B957A2110": {
		"file": "gnomish",
		"tooltip": "Gnomish"
	},
	"16F6B377-200C-3FBC-966B-6E9B957A2119": {
		"file": "dwarvish",
		"tooltip": "Dwarvish"
	},
	"1710A01B-FAF1-4684-5050-A10386685D35": {
		"file": "inverted",
		"tooltip": "Inverted"
	},
	"1794E87A-4330-59B0-ED7D-F3BBDE99FBF4": {
		"file": "tower_water",
		"tooltip": "Tower Water"
	},
	"181DA10F-9C6F-3365-63C3-C466258620D6": {
		"file": "opera_house",
		"tooltip": "Opera House"
	},
	"182CA00C-D9E4-C2AA-A243-B4EB4B8977B7": {
		"file": "stringed_plucked",
		"tooltip": "Stringed, Plucked Skill"
	},
	"185D46F5-09E2-1921-F721-FDD0A2AB3EFC": {
		"file": "possessed",
		"tooltip": "Possessed"
	},
	"19817552-D32A-4B97-B404-745927E1B764": {
		"file": "mountain",
		"tooltip": "Mountain"
	},
	"19BCE18F-E1DC-D359-48A0-3B789741E058": {
		"file": "underwater",
		"tooltip": "Underwater"
	},
	"1A3033B2-1FA4-485A-9D0A-1CD0BC92C961": {
		"file": "throwable_weapon_skill",
		"tooltip": "Throwable Weapon Skill"
	},
	"1A36EA86-18D3-C5DE-3C77-240EDFFAB432": {
		"file": "summit",
		"tooltip": "Summit"
	},
	"1A485B48-C8F4-DF38-BB69-4FE828FDC8A5": {
		"file": "dust_storm",
		"tooltip": "Dust Storm"
	},
	"1A7C5177-77E3-F1A5-0423-D09C137CA2A4": {
		"file": "forest",
		"tooltip": "Forest"
	},
	"1ADB2848-6D7C-16F5-6681-234232DC13EC": {
		"file": "trail_of_the_artillerist",
		"tooltip": "Trail Of The Artillerist"
	},
	"1AEA950E-A57E-6059-448A-E4A6FCED97A3": {
		"file": "shield_encumbered",
		"tooltip": "Shield Encumbered"
	},
	"1B08D135-FE7B-4180-6F38-A1FEEF733355": {
		"file": "battleaxes",
		"tooltip": "Battleaxes"
	},
	"1B619AAA-2B41-1F33-DD39-BC6B7CFF6D3A": {
		"file": "forest_boreal_coniferous",
		"tooltip": "Forest Boreal Coniferous"
	},
	"1B8B2014-FFFD-F7EF-BC80-B9A495B50DD2": {
		"file": "vessel_of_spirits",
		"tooltip": "Vessel Of Spirits"
	},
	"1B912A78-2334-D265-2674-7AD764534D56": {
		"file": "blighted_2",
		"tooltip": "Blighted 2"
	},
	"1BA5473E-6218-6688-1C68-DCA4FEF00A97": {
		"file": "sneaking",
		"tooltip": "Sneaking"
	},
	"1BD82D6B-729B-D0A9-7B65-A1C96711C05A": {
		"file": "firearms_mortar_shell",
		"tooltip": "Firearms Mortar Shells"
	},
	"1C0133E8-0EF9-CA41-6A34-5160ACDA8B11": {
		"file": "galactic_sector",
		"tooltip": "Galactic Sector"
	},
	"1C3122FE-AFA6-4FB1-9E36-AACAC3FB19A7": {
		"file": "conclave_of_the_dragon",
		"tooltip": "Conclave Of The Dragon"
	},
	"1C4D81BB-FB79-68AD-E881-28D874927FD2": {
		"file": "disenchanting",
		"tooltip": "Disenchanting"
	},
	"1C5AB5E5-45E3-D088-375C-6206CE3A26BB": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 5+)"
	},
	"1CE8960D-FD6A-6E6F-C963-01C0CAC1AC71": {
		"file": "cavalry_shields",
		"tooltip": "Cavalry Shields"
	},
	"1D1BFF8B-39AC-4C8A-BD50-136A141E6A44": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Ram"
	},
	"1D2EB61A-67FB-4F6D-FC1B-B5C36357CA6E": {
		"file": "planes",
		"tooltip": "Planes"
	},
	"1D54B02A-B9BF-B47F-A22B-25182CE551F0": {
		"file": "stringed_bow",
		"tooltip": "Stringed, Bow Skill"
	},
	"1D87F5A3-6B42-4C19-8E75-34A9D1B6C2F8": {
		"file": "sphere_locked_arcane",
		"tooltip": "Arcane Sphere Locked"
	},
	"1DA56AF8-0D7A-4137-BE12-1142CC7BB78A": {
		"file": "song_of_the_dancer",
		"tooltip": "Song Of The Dancer"
	},
	"1DAED3A6-061B-E97C-666C-E7052D35D795": {
		"file": "cymbals",
		"tooltip": "Cymbals"
	},
	"1DB53BE8-AB8F-CEB7-57E9-A3162F2AE4B3": {
		"file": "flutes",
		"tooltip": "Flutes Skill"
	},
	"1DC3B3DE-BD4C-B77A-429D-12C7F2B2439D": {
		"file": "host",
		"tooltip": "Overrun"
	},
	"1DEE12B6-D23A-7470-812E-CE4C77AAD395": {
		"file": "maimed_8",
		"tooltip": "Maimed 8"
	},
	"1DF25B9D-33A7-CDA5-9EB4-9A98C3407241": {
		"file": "observatory_telescope",
		"tooltip": "Observatory Telescope"
	},
	"1E05A4A2-6B1C-1F0D-1A65-17E83C04EBBC": {
		"file": "core_of_the_venomworks",
		"tooltip": "Core Of The Venomworks"
	},
	"1E8008FA-B68A-8DE8-48CE-0EB121008FEB": {
		"file": "drowning",
		"tooltip": "Drowning"
	},
	"1E875D11-8C3F-53D6-5256-7FF5363FB1E4": {
		"file": "locks",
		"tooltip": "Locks"
	},
	"1EBE0C5D-4D59-F08A-B118-13286A198ED5": {
		"file": "weapon_attack_roll_assistance_roll",
		"tooltip": "Weapon Attack Roll Assistance Roll"
	},
	"1F14D30F-8083-2DCC-C6E2-BF1D35ACD56A": {
		"file": "butchery",
		"tooltip": "Butchery"
	},
	"1F4E1F50-6ED2-BE4D-5BD9-25BDD5BDB5DF": {
		"file": "retirement_home",
		"tooltip": "Retirement Home"
	},
	"1F557F3F-B61E-7672-9368-9F320BF09158": {
		"file": "lake",
		"tooltip": "Lake"
	},
	"1F7C8699-5708-6D6A-4FD7-F69D28777AED": {
		"file": "blowgun_needle",
		"tooltip": "Blowgun Needles"
	},
	"203017D9-9617-1DE3-9FD6-2C0E0BD965BE": {
		"file": "meadow",
		"tooltip": "Meadow"
	},
	"2035E00A-331D-4B24-8C5E-E768E6753456": {
		"file": "mount_back_shield",
		"tooltip": "Visual Mount — Back Shield"
	},
	"2050C757-11AC-12E0-BCFC-E921ABBC499E": {
		"file": "song_of_color",
		"tooltip": "Song Of Color"
	},
	"207C31FE-ABEE-96F1-2EA6-B98635F7D730": {
		"file": "longbows",
		"tooltip": "Longbows"
	},
	"208CF3F2-DE5C-77BC-21D5-3654094FE435": {
		"file": "fiend",
		"tooltip": "Fiend"
	},
	"208E59A5-37B5-4DA3-97BE-8A1F540C94CD": {
		"file": "cymbals",
		"tooltip": "Cymbals Skill"
	},
	"209D3374-7C85-97DF-7010-ED1B83B656D9": {
		"file": "portal",
		"tooltip": "Portal"
	},
	"20F461C2-67CC-BEF6-E02A-4E9A464EC397": {
		"file": "arcane_fatigue_3",
		"tooltip": "Arcane Fatigue 3"
	},
	"2113FCC8-3025-372F-E254-9B850D7F417F": {
		"file": "metropolis",
		"tooltip": "Metropolis"
	},
	"2122A0BD-C175-EF9A-D84D-750D301BD4F4": {
		"file": "faith_in_life",
		"tooltip": "Faith In Life"
	},
	"212A0039-0A7C-436D-BC59-C87C41C5B567": {
		"file": "yun_stance",
		"tooltip": "Yun Stance"
	},
	"21322959-44EA-0157-CBC8-91A7EDE778C6": {
		"file": "forest_cloud_water_subtropical",
		"tooltip": "Forest Cloud Water Subtropical"
	},
	"2189DD55-92A3-B8FE-DAF7-DBE01D9AF9D7": {
		"file": "chasm_underwater",
		"tooltip": "Chasm Underwater"
	},
	"21CB6BFF-BCCA-98A1-816E-29D96A867ECA": {
		"file": "shopping_mall_commercial_complex",
		"tooltip": "Shopping Mall Commercial Complex"
	},
	"21DE8157-5C1E-33F2-7E52-B27A97C551B8": {
		"file": "kite_shields",
		"tooltip": "Kite Shields"
	},
	"21F13AF0-6DD9-E792-E115-DD6A4E54A7B9": {
		"file": "oath_of_the_spellbreaker",
		"tooltip": "Oath Of The Spellbreaker"
	},
	"22037F8C-242B-243B-B299-F5D3735021FF": {
		"file": "world",
		"tooltip": "World"
	},
	"2257ADAA-6B83-4DAF-7D99-5D2AEA180562": {
		"file": "patron_of_the_void",
		"tooltip": "Patron Of The Void"
	},
	"225A6BFB-98F3-08CD-EA80-A8ABB6473365": {
		"file": "study_of_illusion",
		"tooltip": "Study Of Illusion"
	},
	"2269DB7C-237E-6EC0-7B80-DA7CE0AC67B6": {
		"file": "missile_launch_facility",
		"tooltip": "Missile Launch Facility"
	},
	"2274AD74-E2F8-47AA-8FD1-7DE4713695B9": {
		"file": "sanguine",
		"tooltip": "Sanguine"
	},
	"22918408-67CC-4093-80E8-BF6FA8915C21": {
		"file": "body",
		"tooltip": "Body"
	},
	"22CC3970-0458-63CA-3D69-82A746B9A5CD": {
		"file": "nagh",
		"tooltip": "Nagh"
	},
	"22E33A8E-DF5D-2596-8E2D-0E8A8528E47C": {
		"file": "moderate_bleeding",
		"tooltip": "Moderate Bleeding"
	},
	"2303C056-CA49-6F72-D682-8C8ADE33432D": {
		"file": "neighborhood",
		"tooltip": "Neighborhood"
	},
	"2371CC7D-0BAD-DA78-7067-32361F5DDDBC": {
		"file": "regress_grapple_restrain",
		"tooltip": "Regress Grapple: Restrain"
	},
	"23805AB3-9F2D-29EF-A7FD-A446638C8ED2": {
		"file": "warehouse_granary",
		"tooltip": "Warehouse Granary"
	},
	"242858C1-C334-3A4C-7C5C-9706495750DD": {
		"file": "cloudy",
		"tooltip": "Cloudy"
	},
	"24493929-317B-30CE-398D-23030C0586DD": {
		"file": "refinery_industrial_complex",
		"tooltip": "Refinery Industrial Complex"
	},
	"24495AD8-8EB9-488E-B816-5513E0A3DAA8": {
		"file": "medium_armor_skill",
		"tooltip": "Medium Armor Skill"
	},
	"246C5FEC-3852-73BA-08C4-2C6BA3D0AFEE": {
		"file": "tower_mage",
		"tooltip": "Tower Mage"
	},
	"24C07918-39D5-4317-A958-BDF68B633A21": {
		"file": "fortitude",
		"tooltip": "Fortitude"
	},
	"24D859C0-AA57-D265-2FAF-212BD790A8CD": {
		"file": "stadium",
		"tooltip": "Stadium"
	},
	"24F22A9C-6623-B7AE-F039-E9BF41DB1AE4": {
		"file": "firearms_50_caliber_bullet",
		"tooltip": "Firearms 50 Caliber Bullets"
	},
	"24F413F7-B170-CD44-E6DA-7C1ECB6171ED": {
		"file": "bunker",
		"tooltip": "Bunker"
	},
	"2533E837-2DF5-29F7-2E08-5F287D8A1A6C": {
		"file": "atoll_underwater",
		"tooltip": "Atoll Underwater"
	},
	"256BCFFB-B0BF-7C7A-B238-3126CA2AC20C": {
		"file": "powerful",
		"tooltip": "Powerful"
	},
	"258BD584-26FB-F656-D15F-566BE8984551": {
		"file": "linguistics",
		"tooltip": "Linguistics"
	},
	"25C71284-9FE1-4FB5-982A-941913327B4A": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Tusk"
	},
	"25F9052F-B963-43CB-991E-EB315E08A549": {
		"file": "force",
		"tooltip": "Force"
	},
	"2611657A-9C0A-4680-AB51-62235A6D8D79": {
		"file": "desiccating",
		"tooltip": "Desiccating"
	},
	"26239004-79F7-DF41-C6AD-B3D9AA565B6C": {
		"file": "trail_of_the_berserker",
		"tooltip": "Trail Of The Berserker"
	},
	"26A48978-7629-F0D3-BA6F-23DEBB429055": {
		"file": "cunning",
		"tooltip": "Cunning"
	},
	"26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0": {
		"file": "double_bladed_scimitars",
		"tooltip": "Double Bladed Scimitars"
	},
	"270CFFA3-E469-16BD-0B3D-7FD416B249FC": {
		"file": "asteroid",
		"tooltip": "Asteroid"
	},
	"271C80EB-50B8-A067-A07B-5B8D89248F60": {
		"file": "vessel_of_restoration",
		"tooltip": "Vessel Of Restoration"
	},
	"2779D40C-19AE-4F1D-39B6-9134E67A268E": {
		"file": "pocket_universe",
		"tooltip": "Pocket Universe"
	},
	"279B83E1-99A0-B23D-804B-62DB1DEFF888": {
		"file": "office",
		"tooltip": "Office"
	},
	"27B5484B-ACFC-87A7-B2B4-E549E405B506": {
		"file": "cabin_lodge",
		"tooltip": "Cabin Lodge"
	},
	"27C6E09D-9CD0-41E5-B765-18F096CD8781": {
		"file": "architecture",
		"tooltip": "Architecture"
	},
	"281738CB-A6F8-5C43-FA15-464DEC6030C2": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 14+)"
	},
	"2840646C-3F3C-D38C-DE73-39ED914B01BF": {
		"file": "specialist_in_the_war_jester",
		"tooltip": "Specialist In The War Jester"
	},
	"2858158E-5E6A-491B-9824-290DE8D692D8": {
		"file": "shadowform",
		"tooltip": "Shadowform"
	},
	"287DFA0C-FD83-4305-A41E-D26CE7CE1CCC": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Spine"
	},
	"28A29340-0491-F2E2-229E-757B0412DF51": {
		"file": "manifestation_of_clairvoyance",
		"tooltip": "Manifestation Of Clairvoyance"
	},
	"28B4E29C-5D8D-57CC-7634-761CEBD01190": {
		"file": "reduce_damage_roll",
		"tooltip": "Reduce Damage Roll"
	},
	"28E0D03E-86B3-FDF4-E03A-8DFA1043FE3E": {
		"file": "inspection",
		"tooltip": "Inspection"
	},
	"294AB63D-0E01-A8C4-D936-30A0FC055F36": {
		"file": "tao_of_the_cloudrunner",
		"tooltip": "Tao Of The Cloudrunner"
	},
	"298BE1DD-2917-476E-D79C-92CF8C598926": {
		"file": "well_bloodied",
		"tooltip": "Well Bloodied"
	},
	"29A40478-B83D-89DD-A758-C50BEB866530": {
		"file": "plateau",
		"tooltip": "Plateau"
	},
	"29B47648-35D9-2051-3CF8-5E5FA1CD2B72": {
		"file": "caravanserai",
		"tooltip": "Caravanserai"
	},
	"29D3FFBA-3DB6-15C1-F88C-B72CFADAE907": {
		"file": "gale",
		"tooltip": "Gale"
	},
	"2A16EE98-E160-89CD-4AC0-529BF36194D2": {
		"file": "archery_weapon_skill",
		"tooltip": "Archery Weapon Skill"
	},
	"2A20ACDF-3BC6-B964-8FBD-F8E1AC581AA5": {
		"file": "suffocating",
		"tooltip": "Suffocating"
	},
	"2A2845CD-949F-06E2-E6B2-98CFD5603241": {
		"file": "ethereal",
		"tooltip": "Ethereal"
	},
	"2A63EC91-E5B1-17B4-DFB0-199F9E2084A5": {
		"file": "shielded_9",
		"tooltip": "Shielded 9"
	},
	"2A64D1E8-7C3B-4F92-B5A8-E19D64C72F35": {
		"file": "circle_locked_abjuration",
		"tooltip": "Abjuration Locked"
	},
	"2AC81DE7-B375-9903-CABB-72BAFF74589B": {
		"file": "orcish",
		"tooltip": "Orcish"
	},
	"2ACBDDE4-1700-E444-A0BF-226D58FF254A": {
		"file": "badlands",
		"tooltip": "Badlands"
	},
	"2B130403-B088-8FF5-B202-8922759BABDD": {
		"file": "graveyard",
		"tooltip": "Graveyard"
	},
	"2B7928A2-E96F-E4BC-1E08-A74529225264": {
		"file": "garage",
		"tooltip": "Garage"
	},
	"2BBC1E4E-5A42-41A4-8392-2C755D7A3C7C": {
		"file": "ranged_weapon_type",
		"tooltip": "Ranged Weapon Type"
	},
	"2BCE19F7-76A3-EE20-3EA3-C2B8ADA88878": {
		"file": "_deathbringer",
		"tooltip": "Deathbringer"
	},
	"2BCF5CBC-1E87-E654-8310-E56EC051E559": {
		"file": "_wizard",
		"tooltip": "Wizard"
	},
	"2C0178B2-6D28-CFA7-729C-9C774BEF8D45": {
		"file": "faith_in_the_storm",
		"tooltip": "Faith In The Storm"
	},
	"2C02D1AA-5FBD-470C-8154-B5304BE28D13": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Hurl"
	},
	"2C96B6CF-0B79-1C4D-A414-FEA6A7BEC8AB": {
		"file": "mountain_location",
		"tooltip": "Mountain Location"
	},
	"2CB279E7-CD79-1A21-9F32-89184886D7FC": {
		"file": "primordial",
		"tooltip": "Primordial"
	},
	"2CDC463C-5582-FDF2-F04B-9192674F3DAC": {
		"file": "keep",
		"tooltip": "Keep"
	},
	"2D67C292-177A-C7C1-8278-275AACE6DC3D": {
		"file": "trail_of_the_takedown",
		"tooltip": "Trail Of The Takedown"
	},
	"2D69106B-82C5-D88E-AEFD-A88B6D3F0E3B": {
		"file": "coast_shore",
		"tooltip": "Coast Shore"
	},
	"2D6F5A13-0863-F61D-9239-54FF344C0DAD": {
		"file": "wetland",
		"tooltip": "Wetland"
	},
	"2D837940-0143-4636-9871-406BF89DCB1D": {
		"file": "gunlances",
		"tooltip": "Gunlances"
	},
	"2D894B13-AC1A-4BCD-8914-92EB4BDACC18": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Bite"
	},
	"2D9328A2-9707-F14F-33E5-2C99BBA29AFA": {
		"file": "spring_location",
		"tooltip": "Spring Location"
	},
	"2DB5900E-FF79-9BDA-ADA1-BE4DD50BCFE6": {
		"file": "shizen_stance",
		"tooltip": "Shizen Stance"
	},
	"2DDC4440-C14A-2F83-F418-5B85B96348E8": {
		"file": "ship",
		"tooltip": "Ship"
	},
	"2E902352-952D-7E5C-8607-5DC99C9DDD21": {
		"file": "estuary",
		"tooltip": "Estuary"
	},
	"2EAAA2E8-1B9C-196D-3E58-C29C09FF8492": {
		"file": "dying_state_2",
		"tooltip": "Dying State 2"
	},
	"2F238366-80B8-2BCF-EC81-387CE1A5D4DF": {
		"file": "rapiers",
		"tooltip": "Rapiers"
	},
	"2F81920D-CDB8-8183-E3BC-C6DA16337C60": {
		"file": "manifestation_of_metamorphosis",
		"tooltip": "Manifestation Of Metamorphosis"
	},
	"2FB5E21A-7A0A-E4B8-604D-3A0A60A34172": {
		"file": "javelins",
		"tooltip": "Javelins"
	},
	"2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B": {
		"file": "no_bending_powers",
		"tooltip": "No Bending Powers"
	},
	"2FD990D9-55CE-AEC0-0D7E-ACF21BB9D332": {
		"file": "sewers",
		"tooltip": "Sewers"
	},
	"2FE8DFB7-FE61-4862-AF71-3523262350A0": {
		"file": "weapon_melee_attack_roll",
		"tooltip": "Weapon Melee Attack Roll"
	},
	"305B9EAE-E108-C9EE-D31A-475F75AA3380": {
		"file": "primordial",
		"tooltip": "Primordial"
	},
	"306CD53D-AD03-DD13-FDDF-34D9120613CD": {
		"file": "encumbered",
		"tooltip": "Encumbered"
	},
	"30735770-7440-0C26-5FDF-86C452C0C91D": {
		"file": "frighten",
		"tooltip": "Frighten"
	},
	"3090FD9D-D14C-555E-19A2-D18E6A4A692D": {
		"file": "university_educational_complex",
		"tooltip": "University Educational Complex"
	},
	"3098C163-7B26-7757-24F1-129C467D5BDB": {
		"file": "gnomish",
		"tooltip": "Gnomish"
	},
	"30BD0A8F-DC53-4B80-B5C4-8FBB04F9F9C1": {
		"file": "gift",
		"tooltip": "Gift"
	},
	"31130EAF-53BA-6D61-3744-872DE27F5BC3": {
		"file": "planet",
		"tooltip": "Planet"
	},
	"313B4B34-2D4D-7632-9BF3-05D91298AF59": {
		"file": "grove_of_the_swamp",
		"tooltip": "Grove Of The Swamp"
	},
	"3188FB3B-C860-43D4-9BA0-40364C460385": {
		"file": "resting",
		"tooltip": "Resting"
	},
	"321DA526-E48E-F202-10FC-D3A2B03485F2": {
		"file": "frightened",
		"tooltip": "Frightened"
	},
	"3238A6F9-05EA-32E1-F19A-B7EF1B667788": {
		"file": "great_hall",
		"tooltip": "Great Hall"
	},
	"32442427-714D-66F7-DFA4-7C5D80356FF5": {
		"file": "military_camp",
		"tooltip": "Military Camp"
	},
	"327BD65F-5AE8-F70F-4FFE-5FB3D50EB858": {
		"file": "training_in_the_dragoon",
		"tooltip": "Training In The Dragoon"
	},
	"32C6C141-FBDB-45AF-85EA-7232284EBEC0": {
		"file": "trail_of_the_shatterguard",
		"tooltip": "Trail Of The Shatterguard"
	},
	"32E190D7-0A38-4071-81F7-0EC82089CCD4": {
		"file": "qini",
		"tooltip": "Qini"
	},
	"32F40024-F4CF-4395-A1F9-2606CBDFE7EE": {
		"file": "blood_of_the_shadow",
		"tooltip": "Blood Of The Shadow"
	},
	"331C8511-F8A7-4626-AF17-48FAF062FE50": {
		"file": "fate_card_suit_love",
		"tooltip": "Fate Card Suit Love"
	},
	"333C4F19-2FD9-80EE-9DC2-565685AE7D50": {
		"file": "farm",
		"tooltip": "Farm"
	},
	"337317A4-1CEB-37C7-699F-1A0A02A31709": {
		"file": "armor_type",
		"tooltip": "Natural Armors"
	},
	"338C4063-2F1E-6A9D-5451-8E6ED3266353": {
		"file": "unspecified_gender",
		"tooltip": "Unspecified Gender"
	},
	"33AD66E3-BD6B-A262-27AE-8DA825477576": {
		"file": "reservoir",
		"tooltip": "Reservoir"
	},
	"346EBE03-C187-65AD-E939-AF55FF5B24B2": {
		"file": "shard_of_the_glass_warrior",
		"tooltip": "Shard of the Glass Warrior"
	},
	"34987D5C-BB13-7633-E28A-C3DA4BD458A7": {
		"file": "fate_card_suit_prosperity",
		"tooltip": "Fate Card Suit Prosperity"
	},
	"34CEB0D1-1DE2-03F7-BB8A-834BF8F3565A": {
		"file": "min_skill_tier_9",
		"tooltip": "Natural Weapon (min skill tier 9)"
	},
	"34D0A902-F9A4-406A-A29E-61E55BE0F338": {
		"file": "mount_worn_head",
		"tooltip": "Visual Mount — Worn: Head"
	},
	"3503983E-A71B-6529-4002-67CEBF961607": {
		"file": "coral_reef_platform",
		"tooltip": "Coral Reef Platform"
	},
	"3510737A-8101-7904-89B3-C0BCF1101601": {
		"file": "conurbation",
		"tooltip": "Conurbation"
	},
	"351702BB-5901-87AF-85EC-C8A6FBB7ECF9": {
		"file": "hazy",
		"tooltip": "Hazy"
	},
	"354B23D4-782A-3984-5562-69358E77D5E4": {
		"file": "rock_formation",
		"tooltip": "Rock Formation"
	},
	"35A212B5-98D0-FEA4-CC56-B7CF90BD1087": {
		"file": "power_plant",
		"tooltip": "Power Plant"
	},
	"35EDCE49-85F9-A36E-4407-547E0153DA05": {
		"file": "_summoner",
		"tooltip": "Summoner"
	},
	"36B68995-C875-199D-20E8-1A1098F846B0": {
		"file": "blighted_6",
		"tooltip": "Blighted 6"
	},
	"36C061BF-E480-4334-961C-26500150E3C4": {
		"file": "integrated_object",
		"tooltip": "Integrated Object"
	},
	"36D59FF4-6778-96ED-8664-F5D63638C77B": {
		"file": "range_reach",
		"tooltip": "Reach"
	},
	"36DA5B89-CA08-3940-E798-FCAE6BE775D5": {
		"file": "shielded_2",
		"tooltip": "Shielded 2"
	},
	"36F16EF2-FC9D-57DD-DE24-D44469C1CBAC": {
		"file": "hospitality_motel",
		"tooltip": "Hospitality Motel"
	},
	"37C34B4D-6DB6-EE95-0128-3D40D3DEC5CE": {
		"file": "swampland",
		"tooltip": "Swampland"
	},
	"3805BDD7-3461-DDDB-F445-922A5A992987": {
		"file": "head",
		"tooltip": "Head"
	},
	"381EED2E-EECF-F30B-53C9-BB6BD121A652": {
		"file": "cave_system",
		"tooltip": "Cave System"
	},
	"382D2E23-8E52-D2C6-894B-63C03C83B380": {
		"file": "hybrid_cavalry",
		"tooltip": "Hybrid Cavalry"
	},
	"38FB8933-47F6-4A79-60CF-14E80BCF9BF5": {
		"file": "underground",
		"tooltip": "Underground"
	},
	"390CA9BA-6324-BA20-7224-C0897297FFFD": {
		"file": "house",
		"tooltip": "House"
	},
	"397C35B1-76DB-4A45-1468-E53CF797A1A3": {
		"file": "empathy",
		"tooltip": "Empathy"
	},
	"398DD6E8-AFAE-EA0D-6FE9-C22842D53775": {
		"file": "doffing",
		"tooltip": "Doffing"
	},
	"39B22A7F-144F-EB84-BF1D-DDE45C9BAC6B": {
		"file": "hamlet",
		"tooltip": "Hamlet"
	},
	"39BFCB73-8610-A7A8-869E-7BD8D746FC6F": {
		"file": "large_city",
		"tooltip": "Large City"
	},
	"39DE636C-8087-E69F-D7A4-DC220D772AD2": {
		"file": "magical_realm",
		"tooltip": "Magical Realm"
	},
	"39E2635A-195A-B8B9-F7DD-1DA4E0EC53F6": {
		"file": "faith_in_heresy",
		"tooltip": "Faith In Heresy"
	},
	"39EBAEF7-1ED7-5AAF-E88B-8C50B96B5ED8": {
		"file": "min_skill_tier_5",
		"tooltip": "Natural Weapon (min skill tier 5)"
	},
	"39F1A03D-A7C7-4E90-98FD-14F508074BC5": {
		"file": "unimpeded",
		"tooltip": "Unimpeded"
	},
	"3A28EC64-DA47-09A0-AD1B-31B32627094F": {
		"file": "humanoid",
		"tooltip": "Humanoid"
	},
	"3A2FD2B0-28A9-62D3-CB13-A22974618CDB": {
		"file": "partial_cover",
		"tooltip": "Partial Cover"
	},
	"3A3F9742-5876-C5A1-C1ED-EBF9EFEB025C": {
		"file": "galaxy",
		"tooltip": "Galaxy"
	},
	"3A92ACA4-46BF-BEE1-C112-8B7B41AABC96": {
		"file": "subcontinent",
		"tooltip": "Subcontinent"
	},
	"3AC99772-BF88-6507-8360-EE3EAFC7540F": {
		"file": "warhammers",
		"tooltip": "Warhammers"
	},
	"3AD27E05-55EB-4B79-83F6-FC88ADEBD342": {
		"file": "exposed",
		"tooltip": "Exposed"
	},
	"3AD8CEE8-D487-68B1-33F0-CFE04336F9B8": {
		"file": "ring",
		"tooltip": "Ring"
	},
	"3B42EAFA-8DD1-CCF6-7CD3-6E19C57C0A4B": {
		"file": "blade_of_the_spellbreaker",
		"tooltip": "Blade Of The Spellbreaker"
	},
	"3B58A8C2-F310-42FB-A71C-904904089303": {
		"file": "nightsight",
		"tooltip": "Nightsight"
	},
	"3B5FFB0D-26EF-B237-1F54-63CFF4004E02": {
		"file": "keyboards",
		"tooltip": "Keyboards Skill"
	},
	"3B96E4A7-2F51-4D38-9C82-46A1E7D3F925": {
		"file": "circle_locked_illusion",
		"tooltip": "Illusion Locked"
	},
	"3B98A7F7-1A94-4E3F-A85F-25BDC8430874": {
		"file": "release_grapple",
		"tooltip": "Release Grapple"
	},
	"3BBEE883-286A-4A08-3CCB-52F283348345": {
		"file": "muskets",
		"tooltip": "Muskets"
	},
	"3BDE75C8-41C3-6DE0-8CDC-388ED5D89670": {
		"file": "elvish",
		"tooltip": "Elvish"
	},
	"3BE713AB-37D7-630B-C1F8-9470784BA33E": {
		"file": "bleeding",
		"tooltip": "Bleeding"
	},
	"3BE9E979-BA75-6B17-783B-41E7BC0E7E96": {
		"file": "solar_system",
		"tooltip": "Solar System"
	},
	"3C038AB7-2684-A787-1809-6C8224DBB285": {
		"file": "extreme_photosensitive_eye_strain",
		"tooltip": "Extreme Photosensitive Eye Strain"
	},
	"3C0D5144-0BE8-6159-948D-E8E978AC4E19": {
		"file": "puppet_stance",
		"tooltip": "Puppet Stance"
	},
	"3C23B69F-1A55-4665-B708-8F07398611AF": {
		"file": "mount_hip_right",
		"tooltip": "Visual Mount — Right Hip"
	},
	"3C5D9464-C206-44E7-015F-77A700D9BD9B": {
		"file": "harps",
		"tooltip": "Harps Skill"
	},
	"3C96DE74-D9E6-4173-8671-989209A0BF97": {
		"file": "teleport",
		"tooltip": "Teleport"
	},
	"3CA73C13-5DC3-0DDF-CAD8-98D1CF573844": {
		"file": "armor_type",
		"tooltip": "Natural Armor"
	},
	"3CAA3182-3DA6-F348-CEE3-09803F221466": {
		"file": "clothing",
		"tooltip": "Clothing"
	},
	"3D3D1A72-6A1D-002D-1ED0-04ED18F3D3CA": {
		"file": "windmill",
		"tooltip": "Windmill"
	},
	"3D7A96C2-A736-A722-5C4A-49D77B205563": {
		"file": "jungle",
		"tooltip": "Jungle"
	},
	"3D83726F-7B34-9CB9-142B-C52E818117A3": {
		"file": "shrine",
		"tooltip": "Shrine"
	},
	"3D86CCB6-1E36-1588-7CA5-8C0DE846849A": {
		"file": "faith_in_karma",
		"tooltip": "Faith In Karma"
	},
	"3DB34758-2756-C99A-CC8D-7F9ABA230161": {
		"file": "faith_in_self_sacrifice",
		"tooltip": "Faith In Self Sacrifice"
	},
	"3E053858-D7C1-4E36-91A7-AF05EF5D0C62": {
		"file": "photosensitive_eye_strain",
		"tooltip": "Photosensitive Eye Strain"
	},
	"3E3B74C8-AF60-F5F1-A316-E4D3B1501D72": {
		"file": "lava_river",
		"tooltip": "Lava River"
	},
	"3E3F2F87-5740-AA09-79C1-CD0A0599BEA4": {
		"file": "patron_of_the_deep",
		"tooltip": "Patron Of The Deep"
	},
	"3E9BD118-C5FB-2C0A-01CF-72DC2C4ED0E8": {
		"file": "challenged",
		"tooltip": "Challenged"
	},
	"3F14BF23-09A6-4C05-AFD9-EE0CCD2596A3": {
		"file": "square",
		"tooltip": "Square"
	},
	"3F171782-CC56-32DF-81B4-8C0ED89F47F4": {
		"file": "gathering",
		"tooltip": "Gathering"
	},
	"3F5E1288-D9E3-4B24-8985-333404AF172D": {
		"file": "grove_of_the_skinwalker",
		"tooltip": "Grove Of The Skinwalker"
	},
	"3F85CA97-F9B2-A83A-FDE8-E523FD99346C": {
		"file": "weapon_ranged_attack_roll",
		"tooltip": "Weapon Ranged Attack Roll"
	},
	"3FAE421C-80F8-4A96-5DDC-A461C7506FF3": {
		"file": "woods",
		"tooltip": "Woods"
	},
	"3FB72788-E5FE-2B64-2D1F-2A14BCC6284E": {
		"file": "nagh",
		"tooltip": "Nagh"
	},
	"3FD5CB9B-0194-9D42-CCBF-BBFC2E80044E": {
		"file": "store",
		"tooltip": "Store"
	},
	"3FEEDE53-20B7-DEE8-C64B-8D0738E667A9": {
		"file": "undead",
		"tooltip": "Undead"
	},
	"40664291-C6E9-01A6-2D3D-8FD1861AA940": {
		"file": "moor",
		"tooltip": "Moor"
	},
	"407B4AC5-27C4-60AD-FD56-9189FCDC8AE6": {
		"file": "temperature_frigid",
		"tooltip": "Frigid"
	},
	"40DDC931-6479-B773-293E-CE570E99B975": {
		"file": "bladed_umbrellas",
		"tooltip": "Bladed Umbrellas"
	},
	"40E0CACB-0625-3162-EE26-5A18BD63838E": {
		"file": "mind_of_the_hallucinarch",
		"tooltip": "Mind Of The Hallucinarch"
	},
	"410CC547-393F-0922-9C58-48F618A27742": {
		"file": "campaign_difficulty_normal",
		"tooltip": "Campaign Difficulty Normal"
	},
	"414E3282-1E29-44B5-95C9-7DA1D55EFCCB": {
		"file": "advance_grapple_restrain",
		"tooltip": "Advance Grapple: Restrain"
	},
	"4172601E-FA34-6702-01F6-42BBE5EACCD1": {
		"file": "theatre_concert_hall",
		"tooltip": "Theatre Concert Hall"
	},
	"4191B743-01A5-4E81-806C-E77E0478A2F5": {
		"file": "patron_of_death",
		"tooltip": "Patron Of Death"
	},
	"4199249B-B7F9-CAAA-01A5-1394E3E3FC2E": {
		"file": "shard_of_aurelion",
		"tooltip": "Shard of Aurelion"
	},
	"41F03902-005B-8110-850D-B95DC7A01CB3": {
		"file": "temperature_hot",
		"tooltip": "Hot"
	},
	"41FF250E-4146-C8C2-1324-DD6911BDB372": {
		"file": "custom_quick_ability",
		"tooltip": "Custom Quick Ability"
	},
	"422B9C6D-9558-47CD-AC21-1FB3B45EF33E": {
		"file": "slashing",
		"tooltip": "Slashing"
	},
	"422E4A30-0ECD-77A3-095F-B8F3972F3689": {
		"file": "racing_track_hippodrome",
		"tooltip": "Racing Track Hippodrome"
	},
	"426C7E0B-EF44-498C-10B2-B50A9E28E45C": {
		"file": "training",
		"tooltip": "Training"
	},
	"42728623-5523-5986-672E-9A9FE5DD35B5": {
		"file": "elvish",
		"tooltip": "Elvish"
	},
	"42A38751-5549-CDE7-528E-AED309A2B07D": {
		"file": "extra_weapon_damage_roll",
		"tooltip": "Extra Weapon Damage Roll"
	},
	"42D2DDEC-9C0C-E111-BE72-F556B47EDBFE": {
		"file": "herbalism",
		"tooltip": "Herbalism"
	},
	"42DDFA6E-43FE-E320-5FAB-999FADF4BA84": {
		"file": "galaxy_supercluster",
		"tooltip": "Galaxy Supercluster"
	},
	"430F1BE4-6522-4468-8E27-426B23D003BF": {
		"file": "judgement_1",
		"tooltip": "Judgement 1"
	},
	"432DBB43-005F-88D9-4F25-B5745D5C08D2": {
		"file": "civics",
		"tooltip": "Civics"
	},
	"432EF6B0-0DF5-5EA9-33A6-F1BE691772D0": {
		"file": "astronomy",
		"tooltip": "Astronomy"
	},
	"4350D01A-56C5-CA6F-BCC1-32D6C2117F46": {
		"file": "jeweler_building",
		"tooltip": "Jeweler Building"
	},
	"43BDB501-B32B-144B-28E6-812AF56C6E7A": {
		"file": "seaport",
		"tooltip": "Seaport"
	},
	"44223199-712F-A11F-BADD-EC10813AFBF7": {
		"file": "_machinist",
		"tooltip": "Machinist"
	},
	"445E960B-817E-EDBB-995C-44EDFBB7B65D": {
		"file": "vessel_of_cataclysm",
		"tooltip": "Vessel Of Cataclysm"
	},
	"4476C212-A776-CF84-67A6-5E79C77CB381": {
		"file": "buck_creature",
		"tooltip": "Buck Riders"
	},
	"44A52695-9CD1-804C-9ABA-178B70704D59": {
		"file": "mauls",
		"tooltip": "Mauls"
	},
	"44B8792E-632E-2651-C666-67DFD181E92A": {
		"file": "bloodied",
		"tooltip": "Bloodied"
	},
	"44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4": {
		"file": "maimed_7",
		"tooltip": "Maimed 7"
	},
	"44D45637-FCFE-FC95-BE32-DD47FCAEC116": {
		"file": "weapon",
		"tooltip": "Weapon Size: Titantic"
	},
	"44F9404E-77AC-1F60-68A4-4CD6AE071161": {
		"file": "light_armor_skill",
		"tooltip": "Light Armor Skill"
	},
	"45122975-6514-4CE0-9484-A874CE211016": {
		"file": "concentration",
		"tooltip": "Double Concentration"
	},
	"452C9F80-57B0-2DF2-ABD9-F333E2796D25": {
		"file": "archive",
		"tooltip": "Archive"
	},
	"457ADEAA-1D5D-9AB4-EFC9-2B7120C78BAA": {
		"file": "petrified",
		"tooltip": "Petrified"
	},
	"458DF854-358B-41BE-53C1-F51A0EF0055C": {
		"file": "harbinger_of_the_soulforge",
		"tooltip": "Harbinger of the Soulforge"
	},
	"459A0C3F-3089-2CC8-1BAB-0B05E66D7A96": {
		"file": "blood_of_the_fey",
		"tooltip": "Blood Of The Fey"
	},
	"45C4332F-7E72-DDB0-22FD-01B1BAEFC819": {
		"file": "salt_flat",
		"tooltip": "Salt Flat"
	},
	"45DE7B42-D548-498A-B7AB-C3DC1C660E57": {
		"file": "natural_weapon_skill",
		"tooltip": "Natural Weapon Skill"
	},
	"4634635E-4E82-DFB3-8411-27A6BFB8CF0F": {
		"file": "temporary_vitality_regeneration_roll",
		"tooltip": "Temporary Vitality Regeneration Roll"
	},
	"4638F1B5-48F9-4E81-95B7-E0325F40B5EF": {
		"file": "diseased",
		"tooltip": "Diseased"
	},
	"4659B268-8213-6C36-81DB-39877F546282": {
		"file": "manifestation_of_telekinesis",
		"tooltip": "Manifestation Of Telekinesis"
	},
	"466374FE-D89C-DB77-1809-7249A831015D": {
		"file": "armor_encumbered",
		"tooltip": "Armor Encumbered"
	},
	"467B3256-C3F2-3426-217D-A8A779ED62FB": {
		"file": "winter",
		"tooltip": "Winter"
	},
	"467E5469-87A2-44DE-7203-8B3C58D49044": {
		"file": "fort",
		"tooltip": "Fort"
	},
	"46A29A8A-8AC2-8381-B670-73BB1190A326": {
		"file": "plaza",
		"tooltip": "Plaza"
	},
	"46F27428-2B73-50F7-6F0C-D4FAFDB753ED": {
		"file": "maimed_3",
		"tooltip": "Maimed 3"
	},
	"4744C91C-51DC-4C36-8C6E-DB801410FF61": {
		"file": "blighted",
		"tooltip": "Blighted"
	},
	"47667406-1B72-9D60-310B-D8CF6BFE397D": {
		"file": "hidden",
		"tooltip": "Hidden"
	},
	"4767BD78-9829-6FC9-BD4A-5855F322CEB7": {
		"file": "ignan",
		"tooltip": "Ignan"
	},
	"477A7977-60D2-4B9C-96B0-6ED4BFD6437E": {
		"file": "locked",
		"tooltip": "Locked"
	},
	"479A4B5C-43F3-3559-979B-5BDA8A379F07": {
		"file": "mirror_image_3",
		"tooltip": "Mirror Image 3"
	},
	"48655553-071F-29AC-071F-E7E9E4D53235": {
		"file": "enochian",
		"tooltip": "Enochian"
	},
	"488EE738-F198-9F9E-4F9F-FE26B06BA64F": {
		"file": "nets",
		"tooltip": "Nets"
	},
	"48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768": {
		"file": "sickles",
		"tooltip": "Sickles"
	},
	"48EA5564-7ACE-BB0C-B756-9E2BBC730AB6": {
		"file": "cracked_planet",
		"tooltip": "Cracked Planet"
	},
	"492112D6-F574-43B2-9DFE-C37FE82A0763": {
		"file": "fey",
		"tooltip": "Fey"
	},
	"493D1395-4A04-4F3C-8398-2DBF56960FF8": {
		"file": "mount_hip_left",
		"tooltip": "Visual Mount — Left Hip"
	},
	"4992C4FD-7882-DBB9-BE7C-0BA4157A438A": {
		"file": "study_of_abjuration",
		"tooltip": "Study Of Abjuration"
	},
	"49D4B149-CC35-B607-AFB2-70BB7EEE196B": {
		"file": "fjord",
		"tooltip": "Fjord"
	},
	"49F87D1B-3878-789E-D52E-65BA7F2F4218": {
		"file": "heavily_encumbered",
		"tooltip": "Heavily Encumbered"
	},
	"4A5172E6-6D97-3958-C65B-F0792A660B85": {
		"file": "enochian",
		"tooltip": "Enochian"
	},
	"4A5F251A-EADE-4E22-AA84-28B796B84121": {
		"file": "trail_of_the_untamed",
		"tooltip": "Trail Of The Untamed"
	},
	"4AEF8F40-B779-C0AD-4455-2DABE7B1D14B": {
		"file": "maimed_9",
		"tooltip": "Maimed 9"
	},
	"4B74DA87-EABF-7EBA-D283-C5A1FEF483C9": {
		"file": "sightless",
		"tooltip": "Sightless"
	},
	"4B808990-16EB-52F5-0E88-EF0809F4C299": {
		"file": "_barbarian",
		"tooltip": "Barbarian"
	},
	"4BC81F0D-4C96-44B0-AD91-422E0A6E5259": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Hoof"
	},
	"4C10C158-5474-4B43-AE85-058806DF3017": {
		"file": "conclave_of_the_marksman",
		"tooltip": "Conclave Of The Marksman"
	},
	"4C1CBB1D-E4DD-FB2E-A784-3A2BF80D232C": {
		"file": "stables",
		"tooltip": "Stables"
	},
	"4C33FD22-5382-15DA-1C46-F57F14378AFD": {
		"file": "titanic",
		"tooltip": "Titanic"
	},
	"4C3F9C1F-37AF-DE4D-B6F5-BD0558513DA2": {
		"file": "slum",
		"tooltip": "Slum"
	},
	"4C4FE4AE-E485-495B-8ED2-F22A35DA30E8": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Beak"
	},
	"4C543268-FEF1-23FE-4AFF-5A01A4F81953": {
		"file": "temperature_temperate",
		"tooltip": "Temperate"
	},
	"4C761395-2532-3F23-7CBA-CA81AF5C0855": {
		"file": "range_close",
		"tooltip": "Close (30)"
	},
	"4C7C35F9-F948-581F-0F2D-11BAFC476122": {
		"file": "weapon",
		"tooltip": "Weapon Size: Gargantuan"
	},
	"4D0FF632-CAC9-4714-64B8-43978DD90A7E": {
		"file": "religion",
		"tooltip": "Religion"
	},
	"4D27433B-6F72-47BB-9A60-B80493F22D65": {
		"file": "maimed_4",
		"tooltip": "Maimed 4"
	},
	"4D752252-071F-8ACD-B8D3-9DF91AF5D58F": {
		"file": "workshop",
		"tooltip": "Workshop"
	},
	"4D7CFE7B-DBD0-9DBC-7933-D04E9A04C389": {
		"file": "specialist_in_the_astral_grift",
		"tooltip": "Specialist In The Astral Grift"
	},
	"4DAC1B4A-2324-BF69-C00C-DF6575D47041": {
		"file": "rolling_hills",
		"tooltip": "Rolling Hills"
	},
	"4DDA161E-31D6-9894-58C7-CD34B21734BD": {
		"file": "_warlock",
		"tooltip": "Warlock"
	},
	"4DF9E59E-1BE3-105A-277D-E7A87EE79C5D": {
		"file": "training_in_fey_archery",
		"tooltip": "Training In Fey Archery"
	},
	"4E0E0C0F-3AC5-62E5-2ADD-3A7B0E1D9691": {
		"file": "cafe_tearoom",
		"tooltip": "Cafe Tearoom"
	},
	"4E16C1F0-A18A-39AF-6B8E-46C59C7A72ED": {
		"file": "vale",
		"tooltip": "Vale"
	},
	"4E601894-014E-32FB-E138-2A261969B7B2": {
		"file": "hunter",
		"tooltip": "Hunter Summon"
	},
	"4EBFF986-A4AA-4709-BE68-E97D29B66D18": {
		"file": "poison",
		"tooltip": "Poison"
	},
	"4EC766F1-258D-0BED-F7F6-5C51307F688C": {
		"file": "cave",
		"tooltip": "Cave"
	},
	"4F37A8D1-9B62-4A15-C783-28E91B5F4D76": {
		"file": "circle_locked_divination",
		"tooltip": "Divination Locked"
	},
	"4FB12CDC-6812-18FA-95E4-044A9EE66F50": {
		"file": "shop_tailor",
		"tooltip": "Shop Tailor"
	},
	"4FB7452A-F130-40C3-83E6-5E92C329D7B2": {
		"file": "healing_roll",
		"tooltip": "Healing Roll"
	},
	"4FF85144-67EC-9D87-AE28-15137A1A2481": {
		"file": "off_hand",
		"tooltip": "Off Hand"
	},
	"4FF85609-6DA6-429E-8CA0-BCE6844D2EAD": {
		"file": "arcology",
		"tooltip": "Arcology"
	},
	"50740150-28E8-FB76-88BD-216B02569D3F": {
		"file": "daggers",
		"tooltip": "Daggers"
	},
	"5169158E-D7ED-A3E6-7627-A934EBBD9CAD": {
		"file": "celestial",
		"tooltip": "Celestial"
	},
	"51EFBF8C-672F-F1F8-543A-6B079320572C": {
		"file": "fiendsight",
		"tooltip": "Fiendsight"
	},
	"522C7991-484B-DDFC-F50C-B1B520E07E70": {
		"file": "harbinger_of_corrosion",
		"tooltip": "Harbinger of Corrosion"
	},
	"52949AF2-7C18-4BA3-754E-4BF898A67AFD": {
		"file": "recharge_ability_roll",
		"tooltip": "Recharge Ability Roll"
	},
	"52FC742A-34E9-CB4A-8DEF-68A27759D258": {
		"file": "foundry",
		"tooltip": "Foundry"
	},
	"52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": {
		"file": "large",
		"tooltip": "Large"
	},
	"530DDF73-26CF-9A06-32D4-6724A13CE661": {
		"file": "outpost",
		"tooltip": "Outpost"
	},
	"5310DE5D-1453-5468-EBBA-B1132AB19394": {
		"file": "hand_mortars",
		"tooltip": "Hand Mortars"
	},
	"53D2F0E7-F84E-D678-8239-768DE86083CA": {
		"file": "post_office",
		"tooltip": "Post Office"
	},
	"54058786-9840-7A02-90F6-36151FA0A3F2": {
		"file": "circle_of_charm",
		"tooltip": "Circle of Charm"
	},
	"544506F5-85D7-A84A-40E9-4E15544F5BCB": {
		"file": "multiverse",
		"tooltip": "Multiverse"
	},
	"545EB766-1371-C2E2-2664-0C191EAC9C3F": {
		"file": "lances",
		"tooltip": "Lances"
	},
	"5479CD63-381D-321E-8FCF-894691D324F0": {
		"file": "manifestation_of_telepathy",
		"tooltip": "Manifestation Of Telepathy"
	},
	"54D69C32-CE87-25D7-A8B9-D3FF8008CE06": {
		"file": "grove_of_the_waterway",
		"tooltip": "Grove Of The Waterway"
	},
	"54DC30E0-923C-4BBF-A8CC-570B0068E8A2": {
		"file": "crafting_roll",
		"tooltip": "Crafting Roll"
	},
	"551A7082-B43B-6302-DA50-330AE0401B05": {
		"file": "market_square",
		"tooltip": "Market Square"
	},
	"5522DAD4-54BB-496D-D97E-01B25891EEC9": {
		"file": "blade_of_the_witcher",
		"tooltip": "Blade Of The Witcher"
	},
	"553334AB-7F90-FAA4-3BB1-61F072A01ECD": {
		"file": "caravan",
		"tooltip": "Caravan"
	},
	"553734EC-33D3-4527-AB2E-EF48ACED8DF0": {
		"file": "recovery_state_1",
		"tooltip": "Recovery State 1"
	},
	"553AF1FD-6292-BB80-598A-6207E656551A": {
		"file": "well",
		"tooltip": "Well"
	},
	"55565C71-B55B-3D10-9DFB-7C45D95BC724": {
		"file": "weaving",
		"tooltip": "Weaving"
	},
	"5569DDAD-4BFE-6406-E3D0-D95FE4F44E05": {
		"file": "spaceport",
		"tooltip": "Spaceport"
	},
	"55C4EEFF-1638-18E4-662F-E028BD91E853": {
		"file": "plane_of_existence",
		"tooltip": "Plane Of Existence"
	},
	"55CE51A8-D8A4-A2FE-2B93-D5C3B1C43884": {
		"file": "blood_of_the_artifical_soul",
		"tooltip": "Blood Of The Artifical Soul"
	},
	"5603C5F8-4610-2227-20C3-422104EA74E2": {
		"file": "star",
		"tooltip": "Star"
	},
	"5672B433-B59D-561E-B4C6-79565C46B3CA": {
		"file": "hungry",
		"tooltip": "Hungry"
	},
	"56D1C490-B589-4B17-889A-59D866E38D54": {
		"file": "line",
		"tooltip": "Line"
	},
	"56D7BA20-D044-F330-026F-1FB555C42C59": {
		"file": "hangar",
		"tooltip": "Hangar"
	},
	"5740CA49-006E-A7A0-B46B-6DDED6CD546C": {
		"file": "spell_melee_attack_roll",
		"tooltip": "Spell Melee Attack Roll"
	},
	"57414350-DAC7-AD98-83CA-2C455D92007E": {
		"file": "mind_of_the_metamorph",
		"tooltip": "Mind Of The Metamorph"
	},
	"57A4EE67-0F3F-C4F2-CA4B-F81D896F4975": {
		"file": "coral_reef_atoll",
		"tooltip": "Coral Reef Atoll"
	},
	"57B8F98F-460E-7D39-C495-D2E26439391C": {
		"file": "shortswords",
		"tooltip": "Shortswords"
	},
	"57D8FB10-DD22-A7D3-210D-01AADFE03373": {
		"file": "brute_role",
		"tooltip": "Brute Role"
	},
	"57DAF94A-7C3A-4C5B-A7A9-22729D06355F": {
		"file": "telepathy",
		"tooltip": "Telepathy"
	},
	"57E18214-3561-D675-C8A8-60A20FA09BC7": {
		"file": "oath_of_revolution",
		"tooltip": "Oath Of Revolution"
	},
	"57F117E8-6659-4F2D-AED2-82D6005492B9": {
		"file": "divine",
		"tooltip": "Divine Sphere of Magic"
	},
	"582DB613-DDBA-458F-20D0-298BB278854A": {
		"file": "faith_in_light",
		"tooltip": "Faith In Light"
	},
	"5833A733-D277-0A60-3A94-A0F355A79A80": {
		"file": "casting_ritual_spell",
		"tooltip": "Casting Ritual Spell"
	},
	"583D47A6-9E33-1DB7-1305-2969E875122F": {
		"file": "soldier_role",
		"tooltip": "Soldier Role"
	},
	"5850D66F-70E8-467D-9A5C-93464A5A12C4": {
		"file": "radiant",
		"tooltip": "Radiant"
	},
	"5886822F-FA79-E5CA-C255-DCC7D375CB52": {
		"file": "circle_of_divination",
		"tooltip": "Circle of Divination"
	},
	"58A62523-2588-452B-876B-61D8ACF3CCED": {
		"file": "psyche",
		"tooltip": "Psyche"
	},
	"58B3E565-2DAB-C967-766E-7D815EF1429B": {
		"file": "history",
		"tooltip": "History"
	},
	"59691E2F-1807-5582-91E4-D65E5E6EA167": {
		"file": "volcano_underwater",
		"tooltip": "Volcano Underwater"
	},
	"59B5B7EA-38B8-28C7-B74F-182906B4E3D7": {
		"file": "fishing",
		"tooltip": "Fishing"
	},
	"59C08B6D-F8D4-F9DB-81D9-0FD592094C73": {
		"file": "balance",
		"tooltip": "Balance"
	},
	"59F12E46-1F98-1352-1A13-BE202196C347": {
		"file": "melody",
		"tooltip": "Melody"
	},
	"5A62FC7D-79E4-A7B0-244F-18D865FD5679": {
		"file": "coral_reef_barrier",
		"tooltip": "Coral Reef Barrier"
	},
	"5AA76DEE-CE52-E021-67CD-8C701DA0E56F": {
		"file": "awake",
		"tooltip": "Awake"
	},
	"5ADA1900-D1AD-198D-A299-EB7EC01ADCBD": {
		"file": "snowing",
		"tooltip": "Snowing"
	},
	"5AE6E8F3-89E6-5D5C-DE25-D30B573B08C3": {
		"file": "tao_of_the_southern_star",
		"tooltip": "Tao Of The Southern Star"
	},
	"5B36A87C-F464-647D-7DCD-499CA499528D": {
		"file": "hideout",
		"tooltip": "Hideout"
	},
	"5B41F7E5-5D43-7137-114B-A2EFF22D996D": {
		"file": "guildhall",
		"tooltip": "Guildhall"
	},
	"5B518ED7-4CEF-72BE-F20B-912598267714": {
		"file": "search_for_hidden_inventory",
		"tooltip": "Search for Hidden Inventory"
	},
	"5B8E8F69-AB95-617A-5E82-8F9C4D2C2485": {
		"file": "halberds",
		"tooltip": "Halberds"
	},
	"5C17EFAF-2F94-E2E4-02A2-791F241BD52B": {
		"file": "bladed_fans",
		"tooltip": "Bladed Fans"
	},
	"5C346F0F-D58D-2859-92EB-A347FA56899E": {
		"file": "dwarvish",
		"tooltip": "Dwarvish"
	},
	"5C557D5A-B85F-DF45-3CF6-6739D2BD70EC": {
		"file": "maimed_6",
		"tooltip": "Maimed 6"
	},
	"5C8FA3FC-A936-3350-9B2C-AE771839F8E0": {
		"file": "firearms_300_caliber_bullet",
		"tooltip": "Firearms 300 Caliber Bullets"
	},
	"5CB84B6E-E636-B4A3-3864-910DBD3B63B4": {
		"file": "blighted_1",
		"tooltip": "Blighted 1"
	},
	"5D19BA1F-975B-4CB8-457C-0ECE28B72BF8": {
		"file": "animated_summon",
		"tooltip": "Animated Summon"
	},
	"5D590449-A397-5839-0666-035D487D8C2B": {
		"file": "harbinger_of_the_artifact",
		"tooltip": "Harbinger of the Artifact"
	},
	"5D90B5B1-5AF4-4365-6468-2697BE57BFD2": {
		"file": "song_of_the_sea",
		"tooltip": "Song Of The Sea"
	},
	"5D939B6E-B9BC-7AC5-5143-4F00F4189EA3": {
		"file": "casting",
		"tooltip": "Casting"
	},
	"5DAAF4FA-800F-491D-A79D-D8610EA58023": {
		"file": "mount_thigh_left",
		"tooltip": "Visual Mount — Left Thigh"
	},
	"5DF3C480-7754-4872-302E-63CC3C4A9F03": {
		"file": "raining",
		"tooltip": "Raining"
	},
	"5DFD335C-B12A-4B3C-9FF6-560E12D9045F": {
		"file": "dying_stratum_roll",
		"tooltip": "Dying Stratum Roll"
	},
	"5E0B1C69-8936-4621-A2AE-9648E13384CB": {
		"file": "mount_worn_feet",
		"tooltip": "Visual Mount — Worn: Feet"
	},
	"5E22CB3D-7815-16A0-C9EB-D28DA5D6B263": {
		"file": "crater",
		"tooltip": "Crater"
	},
	"5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591": {
		"file": "temporary_vitality_roll",
		"tooltip": "Temporary Vitality Roll"
	},
	"5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3": {
		"file": "maces",
		"tooltip": "Maces"
	},
	"5E63B1C4-8A27-4D95-A348-91C6E2F7D8B3": {
		"file": "circle_locked_transmutation",
		"tooltip": "Transmutation Locked"
	},
	"5E805770-2DD5-4D6B-BC6D-8463D291C177": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Horn"
	},
	"5EDE9876-ED2B-3B93-C683-34428B5FDA5B": {
		"file": "neck",
		"tooltip": "Neck"
	},
	"5EEA5A21-4FCC-884C-ED46-370AFE880209": {
		"file": "study_of_conjuration",
		"tooltip": "Study Of Conjuration"
	},
	"5F2B5D56-CA98-B407-B99E-131460AA2F0C": {
		"file": "mail_shirt_armors",
		"tooltip": "Mail Shirt Armors"
	},
	"5F6620B5-F321-98FB-DC2B-DFD71B3D2750": {
		"file": "savannah",
		"tooltip": "Savannah"
	},
	"5F87B80F-A8E4-A3BE-6FC6-3B5BC0A669E9": {
		"file": "arcane_fatigue_8",
		"tooltip": "Arcane Fatigue 8"
	},
	"5FC40097-3C6E-53ED-0947-486FCC6DE627": {
		"file": "mana_drain_roll",
		"tooltip": "Mana Drain Roll"
	},
	"5FF2F49A-7667-D686-2BC6-32623375A091": {
		"file": "aether",
		"tooltip": "Aether"
	},
	"5FF654D1-19D8-4055-B1AB-06F5A0044806": {
		"file": "song_of_the_vocalist",
		"tooltip": "Song Of The Vocalist"
	},
	"60217EE8-AC0D-5023-9C5C-17581D35D4B8": {
		"file": "universe",
		"tooltip": "Universe"
	},
	"60509B0C-A1BB-B005-C834-98E5ACE40BAB": {
		"file": "pistols",
		"tooltip": "Pistols"
	},
	"606FA106-BCBC-4533-A454-081F0D9E7ECB": {
		"file": "slaughterhouse",
		"tooltip": "Slaughterhouse"
	},
	"60912827-B1B3-E9D7-6FBF-1FE976DDD04E": {
		"file": "shelled",
		"tooltip": "Shelled"
	},
	"60ED1493-67CD-6715-BE15-FE74DEE26DCE": {
		"file": "apothecary_building",
		"tooltip": "Apothecary Building"
	},
	"611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64": {
		"file": "recovery_state",
		"tooltip": "Recovery State"
	},
	"614DED75-B621-26A9-D7A7-8C6EF3140249": {
		"file": "starbase",
		"tooltip": "Starbase"
	},
	"61C890AE-1120-24BA-481D-B19875C9EB92": {
		"file": "tao_of_the_ten_thousand_limbs",
		"tooltip": "Tao Of The Ten Thousand Limbs"
	},
	"61D1498F-9175-6906-4B26-8356C28B28C1": {
		"file": "dim_light",
		"tooltip": "Dim Light"
	},
	"61FD588C-4A17-4190-999B-7832820C44BA": {
		"file": "tremorsense",
		"tooltip": "Tremorsense"
	},
	"6203F9AE-6699-AB57-B3C7-92864A79520C": {
		"file": "cloak",
		"tooltip": "Cloak"
	},
	"621BEEDA-119E-5B7B-54A9-186C926C615D": {
		"file": "blood_of_the_angel",
		"tooltip": "Blood Of The Angel"
	},
	"622AEA0A-D1A6-FB1C-83B4-FC67807D9197": {
		"file": "war_picks",
		"tooltip": "War Picks"
	},
	"62471733-E4AA-40FB-551B-1AD623740861": {
		"file": "blade_of_the_chronoknight",
		"tooltip": "Blade Of The Chronoknight"
	},
	"6260383B-E837-84F5-4C75-F44310D6654A": {
		"file": "void",
		"tooltip": "Void"
	},
	"6284CE8F-C929-7161-EC43-923DE40F4968": {
		"file": "clubs",
		"tooltip": "Clubs"
	},
	"62A2EE7E-B093-6F94-598E-1823912C2286": {
		"file": "statue",
		"tooltip": "Statue"
	},
	"62BB03C9-7E47-DBB6-FD7D-B0A026172182": {
		"file": "arcane_circle",
		"tooltip": "Arcane Circle"
	},
	"62DCCEE7-C228-2081-F171-F49FA62120D2": {
		"file": "sylvan",
		"tooltip": "Sylvan"
	},
	"62E83DEB-4569-AE3A-F671-FF514C508FD2": {
		"file": "rotting",
		"tooltip": "Rotting"
	},
	"62ED7394-9C33-D41A-C426-1BC6723C999A": {
		"file": "crafting",
		"tooltip": "Crafting"
	},
	"63056B34-DBA2-E711-1456-ED5E032A058C": {
		"file": "_druid",
		"tooltip": "Druid"
	},
	"631AAD91-F6A5-879D-5BD6-B7F885AA7FC9": {
		"file": "shielded_7",
		"tooltip": "Shielded 7"
	},
	"633EA7B5-E49A-4DD5-9834-DEE5BCDF8AB7": {
		"file": "mount_worn_neck",
		"tooltip": "Visual Mount — Worn: Neck"
	},
	"6372D1C5-6BB9-41A5-BFD0-885C852005F4": {
		"file": "tao_of_senjing_ganrao",
		"tooltip": "Tao Of Senjing Ganrao"
	},
	"63ABC96E-3804-4E1F-B38D-AABA3237B2D8": {
		"file": "mind",
		"tooltip": "Mind"
	},
	"641E712F-1B60-C633-14BF-C4EE0DDD4AF4": {
		"file": "qini",
		"tooltip": "Qini"
	},
	"64311343-FA0E-EB48-E091-CFD2FAD68EF4": {
		"file": "village",
		"tooltip": "Village"
	},
	"64318AE9-0187-4C71-9163-084694BCE180": {
		"file": "sluggish",
		"tooltip": "Sluggish"
	},
	"64493E62-BCAF-27F1-2B6A-EC84DE328F66": {
		"file": "sneak",
		"tooltip": "Sneak"
	},
	"64958272-483E-EEA4-EE07-A945F2A8F62A": {
		"file": "shop_magic",
		"tooltip": "Shop Magic"
	},
	"64C7938A-010C-1527-6890-A4BC39362807": {
		"file": "armor",
		"tooltip": "Armor Size: Tiny"
	},
	"64E8A3F8-45B0-7D29-0F43-BFB208F654FF": {
		"file": "ghost_train",
		"tooltip": "Ghost Train"
	},
	"652CFE6D-20D4-76FD-421C-F8C2BEA49E90": {
		"file": "casino",
		"tooltip": "Casino"
	},
	"65532C69-CC39-2614-CABC-C4D5EB9ACE48": {
		"file": "armor",
		"tooltip": "Armor Size: Gargantuan"
	},
	"655383C0-8B0C-3B33-694D-26404400626D": {
		"file": "blighted_5",
		"tooltip": "Blighted 5"
	},
	"658483AA-34DE-74E5-C974-E3E202C31CC7": {
		"file": "barely_wounded",
		"tooltip": "Barely Wounded"
	},
	"658B4D83-322B-42FA-82AB-49D3BAD33590": {
		"file": "ageless",
		"tooltip": "Ageless"
	},
	"65A6036B-F6A6-811B-F85E-86F512B74EA2": {
		"file": "vessel_of_stars",
		"tooltip": "Vessel Of Stars"
	},
	"65D8750E-69AD-D583-0FB1-84B1E6476479": {
		"file": "shu_stance",
		"tooltip": "Shu Stance"
	},
	"660E3133-44D8-E79F-C0ED-A26CE31D6E32": {
		"file": "recovery_state_3",
		"tooltip": "Recovery State 3"
	},
	"6746D551-BCB2-5D05-FF18-675F0C6CAF8C": {
		"file": "quarter",
		"tooltip": "Quarter"
	},
	"67B41E3F-5BF3-33A0-B459-7B8768B71933": {
		"file": "training_roll",
		"tooltip": "Training Roll"
	},
	"67B9CAB7-1C48-41E0-AEAF-2F4A352075C1": {
		"file": "drunk",
		"tooltip": "Drunk"
	},
	"67EBE476-52BE-E493-A8B8-A972DBC506D2": {
		"file": "timberyard",
		"tooltip": "Timberyard"
	},
	"67EFA62C-3A5C-9FEE-D54D-EF7615C063F4": {
		"file": "hammers_light",
		"tooltip": "Light Hammers"
	},
	"67F42B5B-E3D1-0818-0197-1F36B20FC630": {
		"file": "magical_darkness",
		"tooltip": "Magical Darkness"
	},
	"68022F7B-B788-2B4F-FE21-367F0ABB6EBA": {
		"file": "planetary_orbit",
		"tooltip": "Planetary Orbit"
	},
	"680B2C74-6995-6E9C-9C72-1122B3221691": {
		"file": "world_wonder",
		"tooltip": "World Wonder"
	},
	"680EFB9E-3CFB-491F-A620-5BABF800131C": {
		"file": "mounted",
		"tooltip": "Mounted"
	},
	"683632D7-756C-0165-9E94-27EA95A53A53": {
		"file": "arcane_fatigue_6",
		"tooltip": "Arcane Fatigue 6"
	},
	"68781B19-86F0-8233-4F14-F1DE713BE79A": {
		"file": "trail_of_the_reaver",
		"tooltip": "Trail Of The Reaver"
	},
	"68B30308-92E2-38A9-E73B-5CA95EBFD424": {
		"file": "beast",
		"tooltip": "Beast"
	},
	"68F4DF94-3345-74AF-EC27-4CCA564D4333": {
		"file": "grove_of_the_infestation",
		"tooltip": "Grove Of The Infestation"
	},
	"69C3F7FB-2FE5-21A1-04DE-636C9B3387D1": {
		"file": "hospitality_resort",
		"tooltip": "Hospitality Resort"
	},
	"69DDD63C-1DEF-A3C2-DF5C-D022747821CA": {
		"file": "autumn",
		"tooltip": "Autumn"
	},
	"69E469E1-0DF4-4F9B-9B41-D7BB5CB70A33": {
		"file": "mount_hidden",
		"tooltip": "Visual Mount — Hidden"
	},
	"6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D": {
		"file": "fate_card_suit_change",
		"tooltip": "Fate Card Suit Change"
	},
	"6A43A001-E717-DE2A-E533-944C20F70C77": {
		"file": "plate_armors",
		"tooltip": "Plate Armors"
	},
	"6A72E939-402C-DA16-C2EB-AAA95BCC17E3": {
		"file": "general_store",
		"tooltip": "General Store"
	},
	"6A8183E1-349E-3960-B465-6C863097E193": {
		"file": "psi",
		"tooltip": "Psi"
	},
	"6AB76ADB-22BC-904A-7D72-43FDCA112DD1": {
		"file": "grel",
		"tooltip": "Grel"
	},
	"6ADDE9C0-261B-C011-826F-E8B6522414A3": {
		"file": "grove_of_the_desert",
		"tooltip": "Grove Of The Desert"
	},
	"6B3F3EA7-DF1A-7F16-38D2-12542984DBD7": {
		"file": "hail",
		"tooltip": "Hail"
	},
	"6B8E5648-B589-5F6A-DFAA-84F7E646B062": {
		"file": "spellsight",
		"tooltip": "Spellsight"
	},
	"6BB72BB2-74A1-B2F6-D856-D4A7561C87A6": {
		"file": "wind_still",
		"tooltip": "Still"
	},
	"6BE03831-B72C-6FE3-7E4E-48EB6DC9B511": {
		"file": "brigandine_armors",
		"tooltip": "Brigandine Armors"
	},
	"6BE8B58B-B97B-45B8-A34C-891EAAEB387D": {
		"file": "mount_back_primary",
		"tooltip": "Visual Mount — Back Primary"
	},
	"6C2A5A2A-75C9-A2F2-A277-8122404F15B5": {
		"file": "tattoo_parlor",
		"tooltip": "Tattoo Parlor"
	},
	"6C3E6964-F138-CA3F-DB99-4BFC7AF3E4FB": {
		"file": "masoning",
		"tooltip": "Masoning"
	},
	"6C82F394-1A5D-4E76-8B34-D29E75A1C648": {
		"file": "circle_locked_conjuration",
		"tooltip": "Conjuration Locked"
	},
	"6C92300B-B840-9E37-BF4D-46A166407E7B": {
		"file": "shortbows",
		"tooltip": "Shortbows"
	},
	"6CCB9287-4420-962A-2952-7469394A5C7A": {
		"file": "backlash",
		"tooltip": "Backlash"
	},
	"6D060053-343F-A8F8-D3B5-6317D7222BE6": {
		"file": "waterfall",
		"tooltip": "Waterfall"
	},
	"6E1A31A4-2D30-096B-BEA4-E2A1DC93A583": {
		"file": "initiative",
		"tooltip": "Initiative"
	},
	"6E4C0D81-46B8-BFF4-2D31-827EC8ACF3A7": {
		"file": "_champion",
		"tooltip": "Champion"
	},
	"6E7D0306-0C35-B0EB-D135-6FBCD50017C5": {
		"file": "bookstore",
		"tooltip": "Bookstore"
	},
	"6EEF7655-4FC7-F5F4-0AB8-C31C31FEEDCD": {
		"file": "domir",
		"tooltip": "Domir"
	},
	"6EFBE105-7632-4C64-BC04-206CEAF663E6": {
		"file": "frozen",
		"tooltip": "Frozen"
	},
	"6F78A7FF-2A5E-727A-3904-02F282811EA9": {
		"file": "shed",
		"tooltip": "Shed"
	},
	"6F92C3D7-1E85-4A64-B237-58D1A9F4E6C3": {
		"file": "sphere_locked_primal",
		"tooltip": "Primal Sphere Locked"
	},
	"6FAF0CD0-26E2-60A3-0608-A3C8E1828027": {
		"file": "thirsty",
		"tooltip": "Thirsty"
	},
	"6FD9898C-F2F7-0D60-6E80-2CE855ABD6A7": {
		"file": "training_in_bushido",
		"tooltip": "Training In Bushido"
	},
	"6FF37FE6-A877-9DD5-F9AB-D87B4C7C7469": {
		"file": "arena",
		"tooltip": "Arena"
	},
	"7037C56E-B09E-02E2-E53F-7233EF1591CA": {
		"file": "harbinger_of_permafrost",
		"tooltip": "Harbinger of Permafrost"
	},
	"70863B88-1DB2-4464-AF5C-542B251E6013": {
		"file": "tao_of_ninjitsu",
		"tooltip": "Tao Of Ninjitsu"
	},
	"70A2ABCA-C777-3887-9A7D-2B77EF757EC4": {
		"file": "help",
		"tooltip": "Help"
	},
	"70C050DA-232C-B766-3F88-82538AA8B812": {
		"file": "star_system",
		"tooltip": "Star System"
	},
	"7134B17B-8B7E-2EF2-B33B-14DAE18514F4": {
		"file": "vessel_of_aegis",
		"tooltip": "Vessel Of Aegis"
	},
	"718E7C4E-3E8A-F95E-5CAF-932984CCF213": {
		"file": "desert_ice",
		"tooltip": "Desert Ice"
	},
	"71C75E03-B9EA-0F1B-226E-0D0139966268": {
		"file": "song_of_discord",
		"tooltip": "Song Of Discord"
	},
	"71CBD568-8072-66E8-37BD-D981A572B835": {
		"file": "hospital",
		"tooltip": "Hospital"
	},
	"71E4E5C5-7AF6-9B16-90BF-8D9D6CCFD9DC": {
		"file": "natural_armor_skill",
		"tooltip": "Natural Armor Skill"
	},
	"7205CA73-B3EC-4C17-B346-7A8CD381DEF9": {
		"file": "patron_of_the_artifact",
		"tooltip": "Patron Of The Artifact"
	},
	"7229802A-2169-DDD4-6CCB-E755CCFAEB51": {
		"file": "cooking",
		"tooltip": "Cooking"
	},
	"7257525A-37A8-9DCE-1656-C7449FF2C305": {
		"file": "crossbows_heavy",
		"tooltip": "Heavy Crossbows"
	},
	"72D05502-08AA-159C-AA98-D6548840F964": {
		"file": "ashfall",
		"tooltip": "Ashfall"
	},
	"72F93730-134F-4CA2-8FC4-F2915F20CAC6": {
		"file": "soul",
		"tooltip": "Soul"
	},
	"7359FA1C-9C72-A490-A7BA-D9AA25CEB1EC": {
		"file": "dimensional_pocket",
		"tooltip": "Dimensional Pocket"
	},
	"735EC3B3-8E5E-B806-706B-B43FE340757C": {
		"file": "prepare_spells",
		"tooltip": "Quick Study"
	},
	"73786439-62A8-4226-99CB-419E32D119C0": {
		"file": "blood_of_the_oracle",
		"tooltip": "Blood Of The Oracle"
	},
	"73BB4DD3-386E-B2D0-B172-49968B3F3769": {
		"file": "training_in_precision",
		"tooltip": "Training In Precision"
	},
	"73ECB998-6C8E-1854-FBBB-EF02AC2AC0EE": {
		"file": "skill_roll_retracting_roll",
		"tooltip": "Skill Roll Retracting Roll"
	},
	"742A06CA-5870-FA3B-603A-AEE94F5102F5": {
		"file": "whips",
		"tooltip": "Whips"
	},
	"7449B08F-F68C-0003-239C-BB821BD485D7": {
		"file": "study_of_transmutation",
		"tooltip": "Study Of Transmutation"
	},
	"7497DA6C-402A-212C-A1A3-CFE30C1906BD": {
		"file": "light_cavalry",
		"tooltip": "Light Cavalry"
	},
	"74D15961-05FC-1D0C-DDF6-F518F026F22B": {
		"file": "_monk",
		"tooltip": "Monk"
	},
	"7554CE49-B27C-11F1-8C29-61872DCF8F69": {
		"file": "gulf_lagoon",
		"tooltip": "Gulf Lagoon"
	},
	"75682F12-AB67-401B-97D7-F1B7354333CA": {
		"file": "squeezed",
		"tooltip": "Squeezed"
	},
	"75B1C2F6-8E21-0ED0-32AD-C49B68804CCC": {
		"file": "rushed",
		"tooltip": "Rushed"
	},
	"75F431B7-2E3C-988E-29F1-A927118BE424": {
		"file": "leather_jerkin_armors",
		"tooltip": "Leather Jerkin Armors"
	},
	"76066F6C-B169-3025-E3C0-9DEA1A55CDA4": {
		"file": "monument_statue_large",
		"tooltip": "Monument Statue Large"
	},
	"76095EE6-F532-2D76-57BA-7981B07294BE": {
		"file": "fortress",
		"tooltip": "Fortress"
	},
	"761600DE-35EB-7B14-5980-F2430FFF85AB": {
		"file": "medicine",
		"tooltip": "Medicine"
	},
	"761A327D-78B6-9F7D-6473-1D992072CBF2": {
		"file": "clinic",
		"tooltip": "Clinic"
	},
	"7650DB9F-465F-DDA6-9D7E-E064F4BC910F": {
		"file": "sun_state_day",
		"tooltip": "Sun State Day"
	},
	"768F7512-7D3E-6E90-8E91-72DC66A0089B": {
		"file": "forest_temperate_seasonal",
		"tooltip": "Forest Temperate Seasonal"
	},
	"77371A15-CD6D-8215-2B47-F7DA63CE291D": {
		"file": "tower_wall",
		"tooltip": "Tower Wall"
	},
	"7780B669-28AA-680E-D28D-397B05A15FC6": {
		"file": "starving",
		"tooltip": "Starving"
	},
	"77A044B7-7041-CA96-3C63-BB718B15A364": {
		"file": "damage_over_time_roll",
		"tooltip": "Damage Over Time Roll"
	},
	"77AC72F7-688C-093D-1E29-067C8ECDC548": {
		"file": "aquan",
		"tooltip": "Aquan"
	},
	"77D5AFC0-C991-B98A-2AD9-6922ED094BF7": {
		"file": "half_plate_armors",
		"tooltip": "Half Plate Armors"
	},
	"782A92F2-93B6-DA4A-0419-D1124317BABB": {
		"file": "dojo",
		"tooltip": "Dojo"
	},
	"78C51D2D-5178-551C-1249-B5DDA4083098": {
		"file": "trapped",
		"tooltip": "Trapped"
	},
	"78C6CC42-BCCE-4F22-9FC5-41F8D7E70944": {
		"file": "dying_state",
		"tooltip": "Dying State"
	},
	"7926555F-184A-4E33-9630-A845D4C9335C": {
		"file": "rite",
		"tooltip": "Rite"
	},
	"798563E1-EB82-4ECE-CB48-9E459B509F92": {
		"file": "lamellar_armors",
		"tooltip": "Lamellar Armors"
	},
	"799A2ACC-2532-DBDC-6458-7F487CD8EE60": {
		"file": "blood_of_the_dragon",
		"tooltip": "Blood Of The Dragon"
	},
	"799B512F-C685-9655-0AF0-8CFBE0349130": {
		"file": "truthsayer",
		"tooltip": "Truthsayer"
	},
	"79A20201-5CF1-C9F3-A5CE-34B8578FD498": {
		"file": "lighthouse",
		"tooltip": "Lighthouse"
	},
	"79A4423C-9B40-08F4-DC89-C170AB2B8808": {
		"file": "market_stall",
		"tooltip": "Market Stall"
	},
	"7A265D17-07A1-C59C-46EC-EEB72C6A723F": {
		"file": "dam",
		"tooltip": "Dam"
	},
	"7A45D2B9-6C18-4F63-B591-82D4F6A3E1C7": {
		"file": "circle_locked_necromancy",
		"tooltip": "Necromancy Locked"
	},
	"7A725B38-BA68-7651-4746-5D34B5690203": {
		"file": "ether",
		"tooltip": "Ether"
	},
	"7A93E220-3578-5912-3856-B0160E9A0856": {
		"file": "bank_treasury",
		"tooltip": "Bank Treasury"
	},
	"7A9EB5DD-3EAE-DCCA-3518-8D4EBFD6131C": {
		"file": "region",
		"tooltip": "Region"
	},
	"7AAA3989-0233-88C9-5A1A-3F89923B6192": {
		"file": "planetoid_moon",
		"tooltip": "Planetoid Moon"
	},
	"7B044913-E45E-04C9-F25C-5FB8B8C503F4": {
		"file": "surprised",
		"tooltip": "Surprised"
	},
	"7B3E9C4A-1D62-4F08-A5D7-3E90C1B84F26": {
		"file": "excavation_found",
		"tooltip": "Excavation Found"
	},
	"7B7E8F97-6843-57CF-422C-5930CFA98B06": {
		"file": "luck",
		"tooltip": "Luck"
	},
	"7B8D5960-B94E-CCEA-3283-A07F70EA2677": {
		"file": "field",
		"tooltip": "Field"
	},
	"7BA5009E-B362-AE2F-ABB6-D06D54D306EA": {
		"file": "sun_state_sunset",
		"tooltip": "Sun State Sunset"
	},
	"7BAF9F56-B8FF-4FBE-886F-30F055A568B3": {
		"file": "faith_in_fate",
		"tooltip": "Faith In Fate"
	},
	"7BB6F92D-9C9F-D3D1-80FF-BBDBA3D06017": {
		"file": "one_handed_melee_weapon_skill",
		"tooltip": "One-Handed Melee Weapon Skill"
	},
	"7BE97A94-7FC0-642C-379E-788DCDA7B293": {
		"file": "volcano",
		"tooltip": "Volcano"
	},
	"7C078D1C-6763-AB35-356C-7B3B38158541": {
		"file": "blade_of_the_shade",
		"tooltip": "Blade Of The Shade"
	},
	"7C0A9429-D170-041B-727B-5D3762D9CFC5": {
		"file": "armor",
		"tooltip": "Armor Size: Colossal"
	},
	"7C5A5192-D827-5005-004E-FC522CEA06C0": {
		"file": "factory",
		"tooltip": "Factory"
	},
	"7C713184-C2B3-2270-2ADA-1B3C47CF2FFE": {
		"file": "abolian",
		"tooltip": "Abolian"
	},
	"7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5": {
		"file": "spears",
		"tooltip": "Spears"
	},
	"7D2FFF31-8526-6AC0-42A7-BBCEBA432DBE": {
		"file": "horns",
		"tooltip": "Horns Skill"
	},
	"7D3A1294-4F49-A284-C8BF-7AE38A5ED33A": {
		"file": "quarry",
		"tooltip": "Quarry"
	},
	"7D77CBED-1030-882D-64D9-C53F8BD7CD18": {
		"file": "core_of_the_dissolver",
		"tooltip": "Core Of The Dissolver"
	},
	"7DBEB6D4-D147-703A-022E-05B290BB95C3": {
		"file": "friend",
		"tooltip": "Friend"
	},
	"7DF71D1B-2794-00E9-C672-3A95E279E521": {
		"file": "partly_cloudy",
		"tooltip": "Partly Cloudy"
	},
	"7E0421DF-EA86-90AA-E95D-30145B3F43BD": {
		"file": "min_skill_tier_1",
		"tooltip": "Natural Weapon (min skill tier 1)"
	},
	"7E615545-1179-6F6A-9729-0AFFCD588B31": {
		"file": "range_object",
		"tooltip": "Object Range"
	},
	"7E94D181-2193-B1ED-988B-2C497AD6EAE5": {
		"file": "underground_vault",
		"tooltip": "Underground Vault"
	},
	"7EA716CF-ABCE-CD3C-0B9E-2310BB8C9DD8": {
		"file": "desert",
		"tooltip": "Desert"
	},
	"7EBB7791-77C4-4C77-851D-9CCFAAAB3961": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Lash"
	},
	"7F03B43E-A5CA-E4DA-0E74-957AAE7EF494": {
		"file": "well_large",
		"tooltip": "Well Large"
	},
	"7F372EFE-7AEA-6E06-9748-B8F815748CA9": {
		"file": "study_of_divination",
		"tooltip": "Study Of Divination"
	},
	"7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D": {
		"file": "blunderbusses",
		"tooltip": "Blunderbusses"
	},
	"7F640E10-E070-C716-5ED1-A5AA5D2C6971": {
		"file": "grove_of_the_void",
		"tooltip": "Grove Of The Void"
	},
	"7F6E7D26-77CE-801A-51F7-1CEE17153C70": {
		"file": "min_skill_tier_3",
		"tooltip": "Natural Weapon (min skill tier 3)"
	},
	"7F938839-F44A-FA43-05FA-BAAF79B7A05B": {
		"file": "blighted_3",
		"tooltip": "Blighted 3"
	},
	"7FA88F1A-084A-4A05-1B5D-27B56EDDED6F": {
		"file": "greataxes",
		"tooltip": "Greataxes"
	},
	"7FB0DB3C-F52E-EBBD-D3C6-AC2B1BF528D0": {
		"file": "dance_club",
		"tooltip": "Dance Club"
	},
	"80585488-CC4B-4A80-8ECE-CB1CE83F2407": {
		"file": "fully_rested",
		"tooltip": "Fully Rested"
	},
	"80591D2E-F992-6BE5-094E-2C9D60726DA5": {
		"file": "wasteland",
		"tooltip": "Wasteland"
	},
	"80770BB4-26D3-C637-DA35-3E549B61F096": {
		"file": "isthmus",
		"tooltip": "Isthmus"
	},
	"80C0326D-4585-60A8-5708-033FAE0EC680": {
		"file": "artillery_role",
		"tooltip": "Artillery Role"
	},
	"814E499E-5294-679B-65B4-B4A8D5DAA5C0": {
		"file": "oath_of_honor",
		"tooltip": "Oath Of Honor"
	},
	"81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3": {
		"file": "rope_darts",
		"tooltip": "Rope Darts"
	},
	"81DADED4-7909-482A-BE32-76887642C172": {
		"file": "common",
		"tooltip": "Common"
	},
	"8209208D-478B-C896-B674-E52D34497C9C": {
		"file": "conclave_of_the_construct",
		"tooltip": "Conclave Of The Construct"
	},
	"820AB0A3-F21A-3135-DB75-89DCDF09A9D0": {
		"file": "aquan",
		"tooltip": "Aquan"
	},
	"82788F70-EBEF-44C4-80E7-6622AD20DD60": {
		"file": "invigorated",
		"tooltip": "Invigorated"
	},
	"828845FB-4210-2C7A-23CE-4223EDAD52D5": {
		"file": "cloudy_lightning",
		"tooltip": "Thunderstorm"
	},
	"82A55683-3171-458E-ABCC-27739151D606": {
		"file": "firearms_weapon_skill",
		"tooltip": "Firearms"
	},
	"82BBB3B6-4646-48E8-A5A2-8DC0947A91D0": {
		"file": "damage_roll",
		"tooltip": "Damage Roll"
	},
	"83234E69-6C06-3392-256B-CB3796C180A7": {
		"file": "incorporeal",
		"tooltip": "Incorporeal"
	},
	"8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368": {
		"file": "shielded_3",
		"tooltip": "Shielded 3"
	},
	"83A8060B-5DD5-9D56-77A4-D47624EA5F9E": {
		"file": "cove",
		"tooltip": "Cove"
	},
	"83CA2730-7598-44D6-BDA2-CDE4B040E73B": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Other"
	},
	"83D21DE1-B6D9-877E-9B6E-56734C400643": {
		"file": "armor",
		"tooltip": "Armor Size: Large"
	},
	"83E39FC7-66BB-B09B-7990-71437A0493C6": {
		"file": "mind_of_the_pyrokinetic",
		"tooltip": "Mind Of The Pyrokinetic"
	},
	"83EAD975-053D-1DDA-4474-F2128633500E": {
		"file": "withering",
		"tooltip": "Withering"
	},
	"84B91EEB-2FA6-D1CB-1347-75BFBDA2A6DD": {
		"file": "invisible",
		"tooltip": "Invisible"
	},
	"84CD1B4A-0D7C-9385-8128-D91339F269BF": {
		"file": "freezing",
		"tooltip": "Freezing"
	},
	"84CDEE1D-44C2-AE0C-B5AF-BF79CF08D91F": {
		"file": "tao_of_the_blooming_fang",
		"tooltip": "Tao Of The Blooming Fang"
	},
	"850BDFE9-D36A-46AF-AD28-E1C533E140E3": {
		"file": "firearms_weapon_skill",
		"tooltip": "Firearms Weapon Skill"
	},
	"859394A9-EE4A-BD9A-C5A9-7FCD150E7344": {
		"file": "handaxes",
		"tooltip": "Handaxes"
	},
	"85F756FF-CC55-B50E-A749-A13FAAA8982E": {
		"file": "cuirass_armors",
		"tooltip": "Cuirass Armors"
	},
	"864FC3D6-0B39-7F59-0274-09B98850A41F": {
		"file": "glaives",
		"tooltip": "Glaives"
	},
	"86792A8B-2070-4144-9C81-0D85706131DF": {
		"file": "spirit",
		"tooltip": "Spirit"
	},
	"86BD9ED9-4768-239D-E755-BC198290FDBE": {
		"file": "alchemy",
		"tooltip": "Alchemy"
	},
	"877C16B3-96E9-25BD-D12D-10F51A1CAFC0": {
		"file": "gatehouse",
		"tooltip": "Gatehouse"
	},
	"879F020A-9FC3-B6A4-6D5E-3E0C9D722662": {
		"file": "cottage",
		"tooltip": "Cottage"
	},
	"87B3915B-F40A-C2A9-678B-1D1508ACBCED": {
		"file": "blade_of_the_valkyrie",
		"tooltip": "Blade Of The Valkyrie"
	},
	"87C01352-EAA6-E667-8C9E-DE24D563320F": {
		"file": "planetoid_rogue",
		"tooltip": "Planetoid Rogue"
	},
	"88B5DA41-090D-4528-8A11-761851166F0F": {
		"file": "brewery_winery",
		"tooltip": "Brewery Winery"
	},
	"88D96DCB-894B-F4B2-7EEE-4306D63566F2": {
		"file": "dragon",
		"tooltip": "Dragon"
	},
	"88F0C54B-9B37-9B57-7F5D-D117B73E70BA": {
		"file": "lake_dry",
		"tooltip": "Lake Dry"
	},
	"88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC": {
		"file": "hunger_and_thirst_tick",
		"tooltip": "Hunger and Thirst Tick"
	},
	"8912E655-C826-4CF6-8F3C-B036AC710CE3": {
		"file": "resistant",
		"tooltip": "Resistant"
	},
	"8A3B8D76-ED7A-560A-166D-73093DE6F4E9": {
		"file": "blighted_9",
		"tooltip": "Blighted 9"
	},
	"8A6575CF-BCA9-2E70-5ECB-21FE529FCAB6": {
		"file": "soul_breaker",
		"tooltip": "Soul Breaker"
	},
	"8A81EE5E-5185-A6AB-29A1-E69F0B2D4B20": {
		"file": "mine",
		"tooltip": "Mine"
	},
	"8AC31F16-0DC8-7FEB-FBE6-8139CBC59FE7": {
		"file": "tao_of_the_dragon_warrior",
		"tooltip": "Tao Of The Dragon Warrior"
	},
	"8AE129AF-52D8-CCE8-706A-85767DB52740": {
		"file": "dying",
		"tooltip": "Dying"
	},
	"8B08E0D0-BB18-6B35-32B6-A563A345D1E1": {
		"file": "patron_of_war",
		"tooltip": "Patron Of War"
	},
	"8BBE01F6-13CC-727F-4431-9B66CD3BB7BA": {
		"file": "patron_of_the_fey",
		"tooltip": "Patron Of The Fey"
	},
	"8C25C0CD-AF02-6648-A158-87F4DEBB8651": {
		"file": "crossbows_light",
		"tooltip": "Light Crossbows"
	},
	"8C455214-9F98-43C7-B9BC-1C74EE60805D": {
		"file": "cold",
		"tooltip": "Cold"
	},
	"8C5E6FE2-A769-097B-42DF-C704A99FA567": {
		"file": "tower_telecomms",
		"tooltip": "Tower Telecomms"
	},
	"8C6BC8F9-F7E3-6F7D-22DD-06D3760366A6": {
		"file": "oath_of_love",
		"tooltip": "Oath Of Love"
	},
	"8C9782A8-5EBF-C04F-CA3D-DF89B1C9EA18": {
		"file": "stalk",
		"tooltip": "Stalk"
	},
	"8CE8E265-7E44-D78D-1C89-5B08D78EA794": {
		"file": "continent",
		"tooltip": "Continent"
	},
	"8CF73E8B-507E-62B5-03F6-A8139E21FAB9": {
		"file": "flying_cavalry",
		"tooltip": "Flying Cavalry"
	},
	"8D0D4656-28B2-9160-43AA-BF379D5F5369": {
		"file": "vessel_of_evolution",
		"tooltip": "Vessel Of Evolution"
	},
	"8D21C6F5-4E93-4B27-A164-73F8D2E9B5A4": {
		"file": "circle_locked_evocation",
		"tooltip": "Evocation Locked"
	},
	"8D31485E-8590-7829-2918-2BEA0F1C125C": {
		"file": "spring",
		"tooltip": "Spring"
	},
	"8D97DB1D-E7A4-BC55-4C5B-9FF0CC90AD4D": {
		"file": "ecumenopolis",
		"tooltip": "Ecumenopolis"
	},
	"8D9F3FF2-306B-D569-A651-EE1C89A87860": {
		"file": "military_base",
		"tooltip": "Military Base"
	},
	"8ED7DCC2-2A9D-B650-2188-17504321E60B": {
		"file": "steppe",
		"tooltip": "Steppe"
	},
	"8F94D454-48C2-A031-AED0-943ED5B609AF": {
		"file": "two_handed_melee_weapon_skill",
		"tooltip": "Two-Handed Melee Weapon Skill"
	},
	"901C6A86-F359-A99F-1D63-4CDA0F040210": {
		"file": "apartment_building_tenement",
		"tooltip": "Apartment Building Tenement"
	},
	"901FFAAE-98A6-46C5-B4B6-D04F135BA9BF": {
		"file": "shard_of_caelix",
		"tooltip": "Shard of Caelix"
	},
	"90474F60-446A-A55D-9B1F-9F974AD13D87": {
		"file": "_shaman",
		"tooltip": "Shaman"
	},
	"905613F5-A045-BC0A-3686-CD1EC15060C5": {
		"file": "reduce_mana_roll",
		"tooltip": "Reduce Mana Roll"
	},
	"90D143BD-9CC9-06F7-F339-03F50C27D958": {
		"file": "blighted_8",
		"tooltip": "Blighted 8"
	},
	"90D15611-2833-46D6-A72E-04C16C87972F": {
		"file": "hindered",
		"tooltip": "Hindered"
	},
	"90FB0BFB-6186-5E01-FD8B-0315D6DFB809": {
		"file": "judgement_3",
		"tooltip": "Judgement 3"
	},
	"9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B": {
		"file": "maimed_2",
		"tooltip": "Maimed 2"
	},
	"91B071D9-E775-FA05-2847-5E5FF739C27B": {
		"file": "spire",
		"tooltip": "Spire"
	},
	"91B65E7C-D87A-349E-21EA-9BFB53533D2B": {
		"file": "orphanage",
		"tooltip": "Orphanage"
	},
	"921C4897-40E4-6336-A171-DA1FDA6A40AF": {
		"file": "ward",
		"tooltip": "Ward"
	},
	"922C5882-54DE-42D0-A5C8-8118AA1C858E": {
		"file": "willpower",
		"tooltip": "Willpower"
	},
	"92303965-8EFD-8D5E-C18F-B4FF3A38CA72": {
		"file": "_sorcerer",
		"tooltip": "Sorcerer"
	},
	"92546C78-D18D-C83F-EFBF-A5D8EBB5A83F": {
		"file": "courthouse",
		"tooltip": "Courthouse"
	},
	"927A5B4C-0320-13B9-D710-25F635BF001B": {
		"file": "chapel",
		"tooltip": "Chapel"
	},
	"9283858C-98CD-FA04-72FC-5D2B9166A9D8": {
		"file": "windy",
		"tooltip": "Strong Wind"
	},
	"928612AF-D88D-4197-3AAB-BC362BE5F8E0": {
		"file": "megalopolis",
		"tooltip": "Megalopolis"
	},
	"92CB1BB5-DF5F-CD84-A2AF-4EE1B85781B5": {
		"file": "song_of_knowledge",
		"tooltip": "Song Of Knowledge"
	},
	"937A5402-E933-4F87-8CAE-93427F47894A": {
		"file": "heavy_armor_skill",
		"tooltip": "Heavy Armor Skill"
	},
	"937D4758-2CD8-1DA4-E47D-7E0DFD4E9C06": {
		"file": "pipes",
		"tooltip": "Pipes Skill"
	},
	"9399856B-2132-7574-1684-91139A2831DD": {
		"file": "enemy",
		"tooltip": "Enemy"
	},
	"93B18FB2-ACF0-0C13-439D-17490C2C2BF3": {
		"file": "orbital_station",
		"tooltip": "Orbital Station"
	},
	"940FD768-1845-24CA-216B-498AA1B2395A": {
		"file": "inhaled_poison",
		"tooltip": "Inhaled Poison"
	},
	"941C9CE1-2262-0D92-4448-0C309A0440DB": {
		"file": "conclave_of_the_ooze",
		"tooltip": "Conclave Of The Ooze"
	},
	"9437F344-1461-B4C0-E196-6BA1A34ADC94": {
		"file": "maimed_1",
		"tooltip": "Maimed 1"
	},
	"9441BB9E-7252-51FD-4385-835709322AC3": {
		"file": "training_in_the_duelist",
		"tooltip": "Training In The Duelist"
	},
	"944306E6-2D20-5D23-E5E3-6F1984285E34": {
		"file": "orrery",
		"tooltip": "Orrery"
	},
	"944EC0D7-3320-42B1-B28D-68980DAA9719": {
		"file": "lightning",
		"tooltip": "Lightning"
	},
	"94805078-0B0F-FD3F-77E4-AA6EE4D2E44D": {
		"file": "feet",
		"tooltip": "Feet"
	},
	"9490C429-4FDA-E669-390C-C6798696F312": {
		"file": "train",
		"tooltip": "Train"
	},
	"94D1A00F-4795-B1DD-6981-6CE3364AF1B3": {
		"file": "druidic",
		"tooltip": "Druidic"
	},
	"9529EEA7-63A9-C572-ECA9-F523E87C58A8": {
		"file": "deafened",
		"tooltip": "Deafened"
	},
	"952D01EA-8A43-3DEF-BB12-E4F6DD69FD45": {
		"file": "hydroponics_agricultural_complex",
		"tooltip": "Hydroponics Agricultural Complex"
	},
	"95968E76-2744-E42F-8FC5-026EDF34249A": {
		"file": "patron_of_the_devil",
		"tooltip": "Patron Of The Devil"
	},
	"95D01E12-0C33-928F-4DE8-570AD806D10B": {
		"file": "sunny",
		"tooltip": "Clear"
	},
	"964A6407-E371-E6FA-A3FC-4ECDAD3615B7": {
		"file": "hunting",
		"tooltip": "Hunting"
	},
	"96DC27AA-0BBA-D76C-BA6E-C9DDAD103069": {
		"file": "temperature_scorching",
		"tooltip": "Scorching"
	},
	"96E272A4-8DDE-443C-0FCF-3A24ECFFB7C2": {
		"file": "arcane",
		"tooltip": "Arcane Sphere of Magic"
	},
	"972AD871-F294-5894-9BAB-2A3B12A6646B": {
		"file": "patron_of_the_angel",
		"tooltip": "Patron Of The Angel"
	},
	"9758A401-365F-8AD2-329C-B124B000C8E2": {
		"file": "hospitality_hotel",
		"tooltip": "Hospitality Hotel"
	},
	"9760E476-0F8E-8874-B9FC-BC89A5CA79AF": {
		"file": "transportation_station",
		"tooltip": "Transportation Station"
	},
	"97914953-9682-C3BC-7BEE-A02846D689F9": {
		"file": "underground_subterranean",
		"tooltip": "Underground Subterranean"
	},
	"97A88B52-CFA1-A67F-A2FF-60FD5475BBBE": {
		"file": "oasis",
		"tooltip": "Oasis"
	},
	"981032B8-4F0B-43C9-8D98-67C693E4DB42": {
		"file": "sphere",
		"tooltip": "Sphere"
	},
	"981477BF-20AC-B5B0-A9A9-A5CB4459884C": {
		"file": "challenge_roll_assistance_roll",
		"tooltip": "Challenge Roll Assistance Roll"
	},
	"9853CC89-CE34-4077-5453-59605542265C": {
		"file": "staggered",
		"tooltip": "Staggered"
	},
	"9878714A-27C3-D737-88B3-E8C1EE63A20F": {
		"file": "extra_damage_roll",
		"tooltip": "Extra Damage Roll"
	},
	"98BE66E8-2F3D-DFEF-B4CD-DBE1EAA9ED4D": {
		"file": "regress_grapple_escape",
		"tooltip": "Regress Grapple: Escape"
	},
	"98FEA101-0910-41AE-9E20-E126C8B73AFC": {
		"file": "protected",
		"tooltip": "Protected"
	},
	"9909BE44-99AE-8780-BB12-BD99BA6E672E": {
		"file": "regeneration_roll",
		"tooltip": "Regeneration Roll"
	},
	"9931FE30-8ACF-40E2-8E69-EB78925364DF": {
		"file": "circle_of_conjuration",
		"tooltip": "Circle of Conjuration"
	},
	"996886D6-67F7-2A7D-0336-9324C877CAA6": {
		"file": "melting",
		"tooltip": "Melting"
	},
	"99951E6E-9801-4E3E-A684-4D111F2D6624": {
		"file": "chilled",
		"tooltip": "Chilled"
	},
	"99C862B9-D6AE-4E18-7803-A6F9B42A88E1": {
		"file": "crippled",
		"tooltip": "Crippled"
	},
	"99D3E371-AC3F-7839-28E7-770FE50D24C1": {
		"file": "pitch_black",
		"tooltip": "Pitch Black"
	},
	"99DC3B29-702D-08D0-346E-AA4359EA1D82": {
		"file": "extra_damage_roll_taken",
		"tooltip": "Extra Damage Taken Roll"
	},
	"9AA7588A-4575-9550-343D-6ADB0C74C17F": {
		"file": "recovery_state_2",
		"tooltip": "Recovery State 2"
	},
	"9ACC3705-F8A5-1ED2-22BA-308C52D94DEF": {
		"file": "inn",
		"tooltip": "Inn"
	},
	"9B9D7A42-A55A-96AE-435B-549ACE26DD7E": {
		"file": "territory",
		"tooltip": "Territory"
	},
	"9C1B45F3-ADA7-3471-CF66-E05E88716574": {
		"file": "henge",
		"tooltip": "Henge"
	},
	"9C34A6E1-5D78-4B26-A493-67F2E8D5B1A9": {
		"file": "sphere_locked_divine",
		"tooltip": "Divine Sphere Locked"
	},
	"9C4D3940-9EC8-EEFC-C417-1ECBCABE793D": {
		"file": "harbinger_of_undeath",
		"tooltip": "Harbinger of Undeath"
	},
	"9C58554D-BA6C-BE4C-30A0-B8A384DC5C38": {
		"file": "grove_of_the_heavens",
		"tooltip": "Grove Of The Heavens"
	},
	"9C752002-0C85-40D8-8DC0-D43AECBB2207": {
		"file": "armor_bending_roll",
		"tooltip": "Armor Bending Roll"
	},
	"9CA1E148-712D-322B-DBFC-3EF6F18A300D": {
		"file": "tao_of_the_painted_shell",
		"tooltip": "Tao Of The Painted Shell"
	},
	"9CC50F9B-B8AD-B180-79BE-C309F1563800": {
		"file": "art",
		"tooltip": "Art"
	},
	"9CE184D4-669F-C2FC-1FA3-F6D3E55561A0": {
		"file": "common",
		"tooltip": "Common"
	},
	"9D7BAB5B-5197-318A-4D96-EF05580BC8AF": {
		"file": "planar_sphere_grouping",
		"tooltip": "Planar Sphere Grouping"
	},
	"9DDD6B5D-BAE3-3989-1DF6-D2060DCD1B8F": {
		"file": "faith_in_the_spirits",
		"tooltip": "Faith In The Spirits"
	},
	"9DF0BF22-2C59-D288-6E7A-E0708737BCD3": {
		"file": "trail_of_the_painbearer",
		"tooltip": "Trail Of The Painbearer"
	},
	"9DF8FF4C-33E8-8095-4876-ED3DBCD50B79": {
		"file": "spell_locked",
		"tooltip": "Spell Locked"
	},
	"9E15B7A2-3D48-4C61-A927-F84B21D6E593": {
		"file": "circle_locked_charm",
		"tooltip": "Charm Locked"
	},
	"9E928A19-47B8-E96B-CB0E-491778C60EF6": {
		"file": "trade_post",
		"tooltip": "Trade Post"
	},
	"9EC53644-1E56-43AC-B43C-C922FF6DD725": {
		"file": "mount_held_main",
		"tooltip": "Visual Mount — Held Main Hand"
	},
	"9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58": {
		"file": "judgement_2",
		"tooltip": "Judgement 2"
	},
	"9F177F51-CDAC-0012-A574-DE1B8B17A55F": {
		"file": "excavating",
		"tooltip": "Excavating"
	},
	"9F33304D-BEB8-86B5-3928-A4D98293DF97": {
		"file": "darts",
		"tooltip": "Darts"
	},
	"9F34BE02-A199-4A9C-A2C4-531CD8A1DD58": {
		"file": "truesight",
		"tooltip": "Truesight"
	},
	"9FD8A4D0-B09B-C068-D475-7EAB358D1A1E": {
		"file": "hamstrung",
		"tooltip": "Hamstrung"
	},
	"9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA": {
		"file": "dead",
		"tooltip": "Dead"
	},
	"A063F21A-02D9-BA39-9C71-09C8E8122693": {
		"file": "essence_roll",
		"tooltip": "Essence Roll"
	},
	"A0BC86C5-403E-1034-B759-1292FA2403A8": {
		"file": "coral_reef_fringing",
		"tooltip": "Coral Reef Fringing"
	},
	"A0DC40FE-BA7A-89FC-CA10-1C15BBAD6EDF": {
		"file": "armor",
		"tooltip": "Armor Size: Titantic"
	},
	"A126C1D6-FE3E-5578-DCC6-CBBF8742E9C1": {
		"file": "full_cover",
		"tooltip": "Full Cover"
	},
	"A13061B6-2390-14E8-34E0-366C0E0CDE34": {
		"file": "water_walk_effect",
		"tooltip": "Water Walk Effect"
	},
	"A176161E-3825-86D8-7BE7-C1524A5B19D4": {
		"file": "food_poisoning",
		"tooltip": "Food Poisoning"
	},
	"A17E1321-2CCD-7C70-9F00-DA261C138F0F": {
		"file": "desert_location",
		"tooltip": "Desert Location"
	},
	"A18765B6-F35A-47E2-F112-DF1582C37B37": {
		"file": "full_caster",
		"tooltip": "Full Caster"
	},
	"A1ECE347-CF64-8454-67CF-9CA8BDEBFD7D": {
		"file": "thieves_cant",
		"tooltip": "Thieves Cant"
	},
	"A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12": {
		"file": "piloting",
		"tooltip": "Piloting"
	},
	"A230F5E6-B6AD-8091-4F59-5E454776B4FA": {
		"file": "maimed_10",
		"tooltip": "Maimed 10"
	},
	"A28D2D20-BCE9-1CE0-4371-7F42231E9C43": {
		"file": "circle_of_evocation",
		"tooltip": "Circle of Evocation"
	},
	"A311574A-3513-44AB-8C70-3C3006F6CC40": {
		"file": "consecrated",
		"tooltip": "Consecrated"
	},
	"A3C4F184-2339-FE0B-D804-56316B7F0CA1": {
		"file": "bay",
		"tooltip": "Bay"
	},
	"A3DCD286-9228-40C7-7ABF-3955559C3D56": {
		"file": "dragon_stance",
		"tooltip": "Dragon Stance"
	},
	"A41E445E-9884-958E-BE93-87F33A1F44F8": {
		"file": "patron_of_the_djinn",
		"tooltip": "Patron Of The Djinn"
	},
	"A4A9688B-1C46-4A04-BDFE-552CF774547E": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Gore"
	},
	"A56D1DBB-C93E-4D84-83CF-BEE1701FD058": {
		"file": "mount_thigh_right",
		"tooltip": "Visual Mount — Right Thigh"
	},
	"A5B19883-CBDA-EC46-A859-96FF01651278": {
		"file": "abolian",
		"tooltip": "Abolian"
	},
	"A5CDC77C-D224-DD5F-291B-EF8DF2EA443D": {
		"file": "maimed",
		"tooltip": "Maimed"
	},
	"A64E346E-F58C-5FB7-BE30-71232C06897C": {
		"file": "slightly_drunk",
		"tooltip": "Slightly Drunk"
	},
	"A67BE9E8-392C-FAD1-4C84-8C9C8ECAB0CB": {
		"file": "oath_of_the_stars",
		"tooltip": "Oath Of The Stars"
	},
	"A707303F-CE4F-26D8-8846-B5178D3F1DB2": {
		"file": "nondetection_effect",
		"tooltip": "Nondetection Effect"
	},
	"A773884A-CAD6-76CB-5DCE-F025A6D91931": {
		"file": "shop_cobbler",
		"tooltip": "Shop Cobbler"
	},
	"A7D57843-FAB7-F534-A9ED-DAFD5AF188C6": {
		"file": "library",
		"tooltip": "Library"
	},
	"A8084E61-46B9-FDB5-83CD-59482BA5B8D3": {
		"file": "menace",
		"tooltip": "Menace"
	},
	"A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A": {
		"file": "shielded_6",
		"tooltip": "Shielded 6"
	},
	"A8469481-849E-4BBA-986E-7C418DCA06A1": {
		"file": "fire",
		"tooltip": "Fire"
	},
	"A85D289B-C245-12B3-B5E8-B862B0372AE2": {
		"file": "star_system_sector",
		"tooltip": "Star System Sector"
	},
	"A8FAE765-7F06-7AF6-C452-6D80086C1B6D": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 9+)"
	},
	"A922EFAA-2C01-88B9-6CF3-06D8C177AB05": {
		"file": "pain_stance",
		"tooltip": "Pain Stance"
	},
	"A945F345-4B0B-3943-8851-B51BB7DFDFA4": {
		"file": "black_hole",
		"tooltip": "Black Hole"
	},
	"A95F219A-6288-6B17-6DB7-03DE4B97AE96": {
		"file": "range_near",
		"tooltip": "Near (60)"
	},
	"A9678CB1-11D3-55A3-E3C9-F342B2E40980": {
		"file": "dying_state_3",
		"tooltip": "Dying State 3"
	},
	"A99C15BA-7990-3449-DD73-1B3FE43531B8": {
		"file": "shard_of_irvatha",
		"tooltip": "Shard of Irvatha"
	},
	"AA0DDA05-58FF-D6F8-5958-E2F5424EC65C": {
		"file": "headland",
		"tooltip": "Headland"
	},
	"AAC1F466-7A8B-C593-1ADC-FC402B8909D7": {
		"file": "small",
		"tooltip": "Small"
	},
	"AB7AE7EE-C8DD-264F-6115-8B75F6B13CD1": {
		"file": "huo_stance",
		"tooltip": "Huo Stance"
	},
	"AB7DEAAE-62BF-4996-A510-5F2B192F8F14": {
		"file": "natural_weapons",
		"tooltip": "Natural Weapons"
	},
	"ABAA9AC7-0274-E299-16A7-E5136837CF2E": {
		"file": "heavy_shields",
		"tooltip": "Heavy Shields"
	},
	"ABAE4F65-1A42-DEFC-21C8-11EBF883A484": {
		"file": "umbral",
		"tooltip": "Umbral"
	},
	"ABE36CBD-1142-9809-FA05-C7DC4263B43C": {
		"file": "magic",
		"tooltip": "Magic"
	},
	"ABF66E1E-DA79-4329-31FA-70D981032C06": {
		"file": "skill_roll",
		"tooltip": "Skill Roll"
	},
	"AC7B499B-0F30-B16D-D924-183E9473BDE0": {
		"file": "terran",
		"tooltip": "Terran"
	},
	"ACA3E968-C358-FCC5-0EBA-42E2068C200F": {
		"file": "shop_generic",
		"tooltip": "Shop Generic"
	},
	"ACFB413D-15A8-835B-C821-9E101B6C4F60": {
		"file": "speed_burrowing",
		"tooltip": "Burrowing Speed"
	},
	"AD5FD492-F4B8-B30F-1AEC-B83B99DF40AF": {
		"file": "galactic_nebula",
		"tooltip": "Galactic Nebula"
	},
	"AD80D31D-898B-66CE-0894-1335D11B1529": {
		"file": "contesting_roll",
		"tooltip": "Contesting Roll"
	},
	"AD81DE70-D93B-FCCC-042A-379B252246E1": {
		"file": "specialist_in_thievery",
		"tooltip": "Specialist In Thievery"
	},
	"AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5": {
		"file": "morningstars",
		"tooltip": "Morningstars"
	},
	"ADD9FA87-2436-482D-8FDC-B5FB7AD9A3A5": {
		"file": "mount_waist",
		"tooltip": "Visual Mount — Waist Belt"
	},
	"AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139": {
		"file": "mirror_image_2",
		"tooltip": "Mirror Image 2"
	},
	"AE3F2A46-7143-18E2-F8DB-42A765DF46B3": {
		"file": "sling_bullet",
		"tooltip": "Sling Bullets"
	},
	"AE49A833-AD4C-3715-6155-BEA0EBA374DC": {
		"file": "drunken_stance",
		"tooltip": "Drunken Stance"
	},
	"AE73EEDF-AC07-4330-B957-B10CFE4CD2E0": {
		"file": "mount_hip_auto",
		"tooltip": "Visual Mount — Either Hip"
	},
	"AE7D4EB3-DC36-BD47-978F-1DBCFE2B616A": {
		"file": "speed_hovering",
		"tooltip": "Hovering Speed"
	},
	"AE967694-B94B-F0FF-B680-829FDE6E8D58": {
		"file": "searching",
		"tooltip": "Searching"
	},
	"AEB8F842-8D30-D028-4B0C-48847C497BB4": {
		"file": "withdraw",
		"tooltip": "Withdraw"
	},
	"AEFB6B35-A12E-7BAD-1D40-67A8169176E7": {
		"file": "crypt",
		"tooltip": "Crypt"
	},
	"AF3FA968-2776-CF37-AAB8-7B7E4BAC555B": {
		"file": "patron_of_the_lich",
		"tooltip": "Patron Of The Lich"
	},
	"AF43D701-0755-C7E2-D26F-44E6F64AC3E2": {
		"file": "legs",
		"tooltip": "Legs"
	},
	"AF821625-3E60-79DB-28E2-67AAEB68189F": {
		"file": "specialist_in_espionage",
		"tooltip": "Specialist In Espionage"
	},
	"AF8EA876-DA09-2032-DF5C-3C950DBF7CB2": {
		"file": "bucklers",
		"tooltip": "Bucklers"
	},
	"AFCABD67-8AAE-194F-AEEC-5AF60A654087": {
		"file": "art_gallery",
		"tooltip": "Art Gallery"
	},
	"AFD61488-049C-C7FC-2B72-26CBE7EAEAFD": {
		"file": "jewelling",
		"tooltip": "Jewelling"
	},
	"AFF19B47-5E29-B9EA-1CEF-D017C9F440C3": {
		"file": "biology",
		"tooltip": "Biology"
	},
	"AFF257FE-DA6E-02E3-86FA-E06FF598180A": {
		"file": "heavy_rain",
		"tooltip": "Heavy Rain"
	},
	"AFFA2CC1-0468-ABBC-2FA3-40597B8B374D": {
		"file": "scimitars",
		"tooltip": "Scimitars"
	},
	"B068A115-A99F-30E5-8B43-A74C1DA8B6A4": {
		"file": "study_of_charm",
		"tooltip": "Study Of Charm"
	},
	"B0768EB7-8EE7-500F-628D-336163307C17": {
		"file": "manor_house_meeting_hall",
		"tooltip": "Manor House Meeting Hall"
	},
	"B1004AD8-7CBB-9DFD-428C-721538BBBAB3": {
		"file": "cathedral_great_temple",
		"tooltip": "Cathedral Great Temple"
	},
	"B12431F6-BB7A-8079-002F-111914B9E65A": {
		"file": "colossal_melee_weapons",
		"tooltip": "Colossal Melee Weapons"
	},
	"B12FE4D0-480A-239A-DAF0-704850F5162D": {
		"file": "abyssal",
		"tooltip": "Abyssal"
	},
	"B1B5365D-2DE0-AA53-A729-AC28BF8C8D52": {
		"file": "auran",
		"tooltip": "Auran"
	},
	"B1B7CD9F-E9B8-B333-5988-D3C0057FE04A": {
		"file": "gym",
		"tooltip": "Gym"
	},
	"B25E2BCC-76E5-992F-BDAA-B550A8B3127E": {
		"file": "state",
		"tooltip": "State"
	},
	"B27AC929-722C-685E-E93E-CE38F49FF9BE": {
		"file": "glassblowing",
		"tooltip": "Glassblowing"
	},
	"B2A59EE2-7D38-D406-0C34-51F1E59DEF6A": {
		"file": "courtesan_stance",
		"tooltip": "Courtesan Stance"
	},
	"B2D3417B-2700-11CB-E17D-38DECAF66F1A": {
		"file": "spot_hidden_creatures",
		"tooltip": "Spot Hidden Creatures"
	},
	"B37046C6-F143-867D-D7CA-991F34572968": {
		"file": "transportation_hub",
		"tooltip": "Transportation Hub"
	},
	"B37A90CE-A8F4-4635-BBE2-82D651BFB955": {
		"file": "mind_of_the_clairvoyant",
		"tooltip": "Mind Of The Clairvoyant"
	},
	"B3856A19-34AD-D33A-14F1-BBBE79A67DA5": {
		"file": "farming",
		"tooltip": "Farming"
	},
	"B404E7CA-C073-473E-A799-A71601A22DE5": {
		"file": "dazed",
		"tooltip": "Dazed"
	},
	"B45813FE-321A-EC7F-F008-12B8FD33B524": {
		"file": "very_squeezed",
		"tooltip": "Very Squeezed"
	},
	"B49068EF-8A0A-0002-3476-E214504C3570": {
		"file": "weakened",
		"tooltip": "Weakened"
	},
	"B4AABF46-DBBA-F625-C2D1-FF5DD7176B8F": {
		"file": "galaxy_cluster",
		"tooltip": "Galaxy Cluster"
	},
	"B4D1AA5E-3B7B-4CE6-BA1E-DC43A5EEBF38": {
		"file": "primal",
		"tooltip": "Primal Sphere of Magic"
	},
	"B516E119-A619-2C08-813B-49F9DF7FCA60": {
		"file": "faith_in_fire",
		"tooltip": "Faith In Fire"
	},
	"B52059C5-526B-3F8C-E906-0D40FA23A593": {
		"file": "waist",
		"tooltip": "Waist"
	},
	"B53BC269-EB0D-725A-C7F4-5D58C717F04A": {
		"file": "study_of_evocation",
		"tooltip": "Study Of Evocation"
	},
	"B56929A7-6BB8-81FA-BFF8-2CE4B0812030": {
		"file": "mastery",
		"tooltip": "Mastery"
	},
	"B5E6379E-5869-4B82-3EB4-9ACB48D2F82A": {
		"file": "feebleminded",
		"tooltip": "Feebleminded"
	},
	"B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2": {
		"file": "greatclubs",
		"tooltip": "Greatclubs"
	},
	"B6005F12-E943-618E-BE29-1E047FC1D1E8": {
		"file": "pipes",
		"tooltip": "Pipes"
	},
	"B614B04E-2AB9-6FB2-56D4-84B8675B074E": {
		"file": "tower_shields",
		"tooltip": "Tower Shields"
	},
	"B61FDA44-4707-4539-B39B-54FA1FCBAA71": {
		"file": "psychic",
		"tooltip": "Psychic"
	},
	"B6232175-C357-9A97-0ACA-7ECC67563635": {
		"file": "greater_invisible",
		"tooltip": "Greater Invisible"
	},
	"B66B3311-4A62-5531-D446-CE4A565FD181": {
		"file": "colossal_ranged_weapons",
		"tooltip": "Colossal Ranged Weapons"
	},
	"B69522BE-88B1-058C-BABB-656071158414": {
		"file": "study_of_gravity",
		"tooltip": "Study Of Gravity"
	},
	"B6A69701-483A-55CF-7AAB-292237A0C10E": {
		"file": "brothel_whorehouse",
		"tooltip": "Brothel Whorehouse"
	},
	"B6B008F2-5805-C31F-842F-ED0C16D34484": {
		"file": "mining",
		"tooltip": "Mining"
	},
	"B7006465-D7D9-57FF-83A5-83AE70D09F25": {
		"file": "vessel_of_enhancement",
		"tooltip": "Vessel Of Enhancement"
	},
	"B71C82DA-CC53-C15E-9DC9-052AF2734E5F": {
		"file": "laboratory_magical",
		"tooltip": "Laboratory Magical"
	},
	"B7312FF1-9F2F-49BF-81E2-BC601D582541": {
		"file": "medium_shields",
		"tooltip": "Medium Shields"
	},
	"B789A689-BF68-FD5B-4AB4-A62CB0982AA4": {
		"file": "harps",
		"tooltip": "Harps"
	},
	"B818235F-3B74-E875-54F3-57BBA5D60E9D": {
		"file": "faith_in_the_mask",
		"tooltip": "Faith In The Mask"
	},
	"B82D8A08-18AC-CB5A-91DA-CB7CDD03EE3C": {
		"file": "south_stance",
		"tooltip": "South Stance"
	},
	"B8324075-E65F-455C-BD40-B09C95B02812": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Constrict"
	},
	"B846648B-EC46-DBEE-2788-516A55DD7F12": {
		"file": "river",
		"tooltip": "River"
	},
	"B84EBE3F-B385-4CEF-9C69-648086C4CB7D": {
		"file": "summon_tag",
		"tooltip": "Summon Tag"
	},
	"B8F4138E-2663-9767-998E-0FA2EAC3196F": {
		"file": "gorge_rift",
		"tooltip": "Gorge Rift"
	},
	"B96061AE-3369-7E7A-B6A2-C7C8FBF2A23F": {
		"file": "speed_jumping",
		"tooltip": "Jumping Speed"
	},
	"B9693027-E65E-DAFF-B2C5-7CF31927184D": {
		"file": "flanked",
		"tooltip": "Flanked"
	},
	"B992A172-D3D1-4BF4-A9FB-19448D14D2D2": {
		"file": "kiosk_small_store",
		"tooltip": "Kiosk Small Store"
	},
	"B997BBBB-DC3F-4F8C-AB8E-A63C80AF133B": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Rake"
	},
	"B9DC5478-8F86-29F7-15D8-1C8CE8171F12": {
		"file": "spider_climb_effect",
		"tooltip": "Spider Climb Effect"
	},
	"B9E74EDE-8D63-B137-F094-46054EF61512": {
		"file": "_hunter",
		"tooltip": "Hunter"
	},
	"BA7A3107-1B40-D50C-A147-E3DC90E45022": {
		"file": "college_academy",
		"tooltip": "College Academy"
	},
	"BA8ECBF1-2746-BF91-4BF1-03FBF4B09911": {
		"file": "blood_of_the_glacier",
		"tooltip": "Blood Of The Glacier"
	},
	"BAAA237B-1AA7-0409-5BC7-1A6720573069": {
		"file": "severe_bleeding",
		"tooltip": "Severe Bleeding"
	},
	"BAF03D85-934E-4781-7C5F-26EE18BC8614": {
		"file": "construct",
		"tooltip": "Construct"
	},
	"BAF467C4-1BC3-70BB-55E4-96D8413908D5": {
		"file": "vessel_of_dispersion",
		"tooltip": "Vessel Of Dispersion"
	},
	"BAFCF694-703D-6D90-C6FD-62F0B55E06E4": {
		"file": "tower_guard",
		"tooltip": "Tower Guard"
	},
	"BB134EEF-09DC-8A8F-DAED-1762CE9ECC7C": {
		"file": "arsenal",
		"tooltip": "Arsenal"
	},
	"BB47D2E8-FFFD-8A04-FC6C-FC02583750ED": {
		"file": "range_unlimited",
		"tooltip": "Unlimited"
	},
	"BB578862-6480-D244-0C6A-2543AA6C29AA": {
		"file": "harbinger_of_the_spellbane",
		"tooltip": "Harbinger of the Spellbane"
	},
	"BBF5D6A6-FB9B-E07D-0497-B60EC68D2EBD": {
		"file": "neutral",
		"tooltip": "Neutral"
	},
	"BC6671F6-DEDF-9C1B-C459-226E7388A00C": {
		"file": "slowed",
		"tooltip": "Slowed"
	},
	"BC71C175-ED2C-4BD2-87D4-C853CAE47D56": {
		"file": "oath_of_mercy",
		"tooltip": "Oath Of Mercy"
	},
	"BC829CD7-69F4-4A90-89AC-9DE78C740FE5": {
		"file": "mount_worn_cloak",
		"tooltip": "Visual Mount — Worn: Cloak"
	},
	"BCC74411-8516-A30B-B79A-1DBED89C61A6": {
		"file": "pepperboxes",
		"tooltip": "Pepperboxes"
	},
	"BCC91DAF-AF10-497E-241D-ACD1BEC9E80E": {
		"file": "silenced",
		"tooltip": "Silenced"
	},
	"BCFE1123-F449-4A98-A4C5-1A3EEB9DF3C5": {
		"file": "grove_of_the_forest",
		"tooltip": "Grove Of The Forest"
	},
	"BD02A97E-8EB3-445A-8758-B01E089FFE03": {
		"file": "weapon",
		"tooltip": "Weapon Size: Large"
	},
	"BD233002-F6C0-A136-6EE4-C899A9E92856": {
		"file": "tactics",
		"tooltip": "Tactics"
	},
	"BD255B29-389B-53DC-6116-072B1A8DDD5F": {
		"file": "bracers",
		"tooltip": "Bracers"
	},
	"BD274DB4-75BE-BF81-FB33-A225748563BC": {
		"file": "_spellblade",
		"tooltip": "Spellblade"
	},
	"BDAF9378-AA7A-445F-D24F-8E6A0EE84456": {
		"file": "arcane_fatigue_10",
		"tooltip": "Arcane Fatigue 10"
	},
	"BDCFE0B2-7BC9-462A-878D-22886DCDC426": {
		"file": "study_of_dark_necromancy",
		"tooltip": "Study Of Dark Necromancy"
	},
	"BE024638-C2F8-8F7B-2C08-BF017BBFB56F": {
		"file": "heavy_snow",
		"tooltip": "Heavy Snow"
	},
	"BE55F5A2-74F7-63D0-D169-900934E2E26E": {
		"file": "impaired",
		"tooltip": "Impaired"
	},
	"BE674A0A-D7B9-DBED-A9E3-BBBA166CC831": {
		"file": "forest_location",
		"tooltip": "Forest Location"
	},
	"BE6DC590-4EB7-B297-5AC6-8E47AA4E00EF": {
		"file": "hunkered_down",
		"tooltip": "Hunkered Down"
	},
	"BE936924-6C8B-CBEC-3E77-6D47B1F98959": {
		"file": "armor",
		"tooltip": "Armor Size: Huge"
	},
	"BEDCAD25-AC66-B6A5-AD3E-6B4D9DAF2422": {
		"file": "oath_of_purification",
		"tooltip": "Oath Of Purification"
	},
	"BF1C1C48-8171-90B8-CD83-F2768348629F": {
		"file": "shielded_8",
		"tooltip": "Shielded 8"
	},
	"BF31EE0A-5B3C-370B-0118-96B067CFD929": {
		"file": "paralyzed",
		"tooltip": "Paralyzed"
	},
	"BF71B9FC-32EF-29EF-9560-7219EBE600CD": {
		"file": "custom_reaction_ability",
		"tooltip": "Custom Reaction Ability"
	},
	"BF823982-6FC8-51F0-F452-5BE1C949FBA6": {
		"file": "shielded_1",
		"tooltip": "Shielded 1"
	},
	"BF94F6AD-C025-6102-C3A8-50E8FE367EC6": {
		"file": "hospitality_camping",
		"tooltip": "Hospitality Camping"
	},
	"BFA219C5-CB8E-BB94-3DA7-702E0E894775": {
		"file": "harbinger_of_blood",
		"tooltip": "Harbinger of Blood"
	},
	"C05381EC-D66A-15AC-46F0-42F5EA8D9383": {
		"file": "weapon",
		"tooltip": "Weapon Size: Colossal"
	},
	"C0EC8294-FFBD-2CF7-20DE-2B64B56C5723": {
		"file": "plain",
		"tooltip": "Plain"
	},
	"C1D6CD9B-D11A-A03C-E83E-331C275E11A0": {
		"file": "firearms_40_caliber_bullet",
		"tooltip": "Firearms 40 Caliber Bullets"
	},
	"C1F4E2B6-DA45-8CAC-322D-C5DF54FFC418": {
		"file": "parched",
		"tooltip": "Parched"
	},
	"C2123333-EEA1-57EA-FF1A-CC01378DE998": {
		"file": "copse",
		"tooltip": "Copse"
	},
	"C2A6D6F1-3078-3B9A-3AF5-9D87B59F613E": {
		"file": "inland_sea",
		"tooltip": "Inland Sea"
	},
	"C3A3E1D8-1393-370F-C3D5-FEA77B0EB518": {
		"file": "summer",
		"tooltip": "Summer"
	},
	"C3FB8547-44FE-7DA8-9601-DF2CBE44019A": {
		"file": "blooming_fang_stance",
		"tooltip": "Blooming Fang Stance"
	},
	"C4097260-89C0-CB3C-19DD-B76A305EC039": {
		"file": "snowing_and_raining",
		"tooltip": "Sleet"
	},
	"C4392CC6-ED12-0278-839A-96420C0DEB7E": {
		"file": "blood_of_the_wildsoul",
		"tooltip": "Blood Of The Wildsoul"
	},
	"C45FF93F-1106-6B2F-D6DB-25213C8F1D8B": {
		"file": "lair_building",
		"tooltip": "Lair Building"
	},
	"C48555B1-E374-9AAD-8CA0-C55D07AD6776": {
		"file": "breast",
		"tooltip": "Breast"
	},
	"C4A65F4F-C3FA-FF3F-FDD1-E3BAC58D5E56": {
		"file": "strait",
		"tooltip": "Strait"
	},
	"C518B122-A108-4EA3-B140-E6211C1071BB": {
		"file": "empowered",
		"tooltip": "Empowered"
	},
	"C5248D97-B2E5-2046-A5CD-15820694BC31": {
		"file": "obelisk",
		"tooltip": "Obelisk"
	},
	"C53BE2B6-07EA-4B3B-9664-1AD286C44AF9": {
		"file": "circle",
		"tooltip": "Circle"
	},
	"C552CB52-F198-12ED-FA4E-7F60E606108A": {
		"file": "supermarket_megastore",
		"tooltip": "Supermarket Megastore"
	},
	"C62E5227-0AB4-4C34-9058-DE97E36B0706": {
		"file": "piercing",
		"tooltip": "Piercing"
	},
	"C64044AF-3A5E-DE56-BB5F-5400FECD5CC0": {
		"file": "ministry_city_hall",
		"tooltip": "Ministry City Hall"
	},
	"C65C0AB8-0129-04D8-5C9E-8BCDECCFC127": {
		"file": "gambeson_armors",
		"tooltip": "Gambeson Armors"
	},
	"C6630706-C18B-AA42-BF23-58FDD517D1FC": {
		"file": "training_in_the_sentinel",
		"tooltip": "Training In The Sentinel"
	},
	"C6CA860F-F58D-7129-87C4-893A3E78090C": {
		"file": "valley",
		"tooltip": "Valley"
	},
	"C6E8D41C-390B-47C8-35AC-EA8BF4656BBD": {
		"file": "sinkhole",
		"tooltip": "Sinkhole"
	},
	"C6EAE41C-7898-2A43-9003-029314CB1E71": {
		"file": "allotment",
		"tooltip": "Allotment"
	},
	"C6FDF4E8-CFEC-E603-8994-496C3576E010": {
		"file": "training_in_the_commander",
		"tooltip": "Training In The Commander"
	},
	"C70D6C1A-5A4D-AB29-EE60-82BDFDC25392": {
		"file": "disengage",
		"tooltip": "Disengage"
	},
	"C79A906F-BA10-B705-1CB9-6A7C5DFAEBEF": {
		"file": "custom_full_ability",
		"tooltip": "Custom Full Ability"
	},
	"C80A28EC-E4DF-664C-FA7C-870A8A53C032": {
		"file": "weapon",
		"tooltip": "Weapon Size: Tiny"
	},
	"C8163F62-7B18-8221-A60D-C9DD775682E3": {
		"file": "trackers_brand",
		"tooltip": "Trackers Brand"
	},
	"C823C739-A9DE-AA5A-07B8-CB67F578F880": {
		"file": "increase_luck_roll",
		"tooltip": "Increase Luck Roll"
	},
	"C8867600-ACD9-4088-A886-F6AB2BFA6FBB": {
		"file": "outer_space",
		"tooltip": "Outer Space"
	},
	"C89BAEA4-FD78-25F1-32D3-6AAB4BFBFA50": {
		"file": "faith_in_time",
		"tooltip": "Faith In Time"
	},
	"C8A114DD-4380-D1C3-CFD0-F50C10B59F93": {
		"file": "specialist_in_the_nullvein",
		"tooltip": "Specialist In The Nullvein"
	},
	"C8B52433-7E4D-B8E1-296E-BE22246545BB": {
		"file": "flutes",
		"tooltip": "Flutes"
	},
	"C92D2BD6-DE2F-2A4D-7423-0C40CC8B3305": {
		"file": "harmony",
		"tooltip": "Harmony"
	},
	"C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": {
		"file": "colossal",
		"tooltip": "Colossal"
	},
	"C9630A6D-D44E-4154-ADD6-FFF1FA4467AE": {
		"file": "blood_of_the_conduit",
		"tooltip": "Blood Of The Conduit"
	},
	"C97076EF-FED9-19B4-D109-C22F9BC740E8": {
		"file": "wounded",
		"tooltip": "Wounded"
	},
	"CA6567EA-74E1-41CC-9C7C-E8EEA8C0B6D6": {
		"file": "fury",
		"tooltip": "Fury"
	},
	"CAD2A16E-0DB5-91C5-F7F4-24F46B28011C": {
		"file": "greater_weakened",
		"tooltip": "Greater Weakened"
	},
	"CC1A807C-117A-5815-74F2-9C1253381F2E": {
		"file": "patron_of_the_plague",
		"tooltip": "Patron Of The Plague"
	},
	"CC224B6E-4A3A-1874-5038-BE285AEA784D": {
		"file": "mountain_pass",
		"tooltip": "Mountain Pass"
	},
	"CC2CBD07-A4BC-E872-12EF-37CC91005D49": {
		"file": "mill",
		"tooltip": "Mill"
	},
	"CC2CEB6B-CEFB-481F-911A-A47A427D5EB2": {
		"file": "lockpicking_roll",
		"tooltip": "Lockpicking Roll"
	},
	"CC4C52BD-A341-0CAC-6C0B-671C9CC1C2EC": {
		"file": "circle_of_transmutation",
		"tooltip": "Circle of Transmutation"
	},
	"CC4E28C3-8FD5-49D5-A537-6AAEE88756F7": {
		"file": "mount_worn_legs",
		"tooltip": "Visual Mount — Worn: Legs"
	},
	"CCE2F7CD-502B-C8AA-37D4-70FE8F416A52": {
		"file": "conclave_of_the_demon_slayer",
		"tooltip": "Conclave Of The Demon Slayer"
	},
	"CD92F978-1CBE-330C-0CC3-71E3C1A32525": {
		"file": "river_basin",
		"tooltip": "River Basin"
	},
	"CDC5CFDA-B09C-4A68-820D-6C74D90BD595": {
		"file": "mirror_image_effect",
		"tooltip": "Mirror Images"
	},
	"CDC76E93-5AD1-E80D-08C5-7B2F10080649": {
		"file": "hospitality_spa",
		"tooltip": "Hospitality Spa"
	},
	"CE4A8031-3CFD-6FE8-0518-C0FAF4BFEEFD": {
		"file": "brush",
		"tooltip": "Brush"
	},
	"CE922467-93C7-3589-86B8-B5C1B12F24DB": {
		"file": "domir",
		"tooltip": "Domir"
	},
	"CEA2946E-D395-46EA-A6E7-74D21EA2376E": {
		"file": "gargantuan",
		"tooltip": "Gargantuan"
	},
	"CEC78DC1-BBD3-C002-C417-AF27527D5BDD": {
		"file": "drums",
		"tooltip": "Drums"
	},
	"CED1BEFE-54AD-8AEB-9874-EAD2E1A39618": {
		"file": "town_square",
		"tooltip": "Town Square"
	},
	"CEECB777-7F28-3D7A-4951-B54C55168F92": {
		"file": "drug_den",
		"tooltip": "Drug Den"
	},
	"CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD": {
		"file": "main_hand",
		"tooltip": "Main Hand"
	},
	"CEF623E6-6A71-37FD-29C7-12988B43151A": {
		"file": "arcane_fatigue",
		"tooltip": "Arcane Fatigue"
	},
	"CEFB07FE-0663-45C6-A532-39E1E70EE2D0": {
		"file": "conclave_of_the_abberation",
		"tooltip": "Conclave Of The Abberation"
	},
	"CEFF8A40-503C-FDA3-41B3-43DC06BF762D": {
		"file": "blinded",
		"tooltip": "Blinded"
	},
	"CF8B21A5-32CE-7E43-22E3-ABC56C457628": {
		"file": "tridents",
		"tooltip": "Tridents"
	},
	"CFBFF802-8C7C-AAD7-3E02-930D012FC7BE": {
		"file": "blood_of_the_storm",
		"tooltip": "Blood Of The Storm"
	},
	"CFF971CB-DE1E-408C-FC40-A199C092001F": {
		"file": "peninsula",
		"tooltip": "Peninsula"
	},
	"CFFB0D03-2192-BEA6-1EDC-3C3920B18202": {
		"file": "customs_house",
		"tooltip": "Customs House"
	},
	"D07FEDBB-A83C-44DD-AA29-61B918DA52B8": {
		"file": "mind_of_the_telekinetic",
		"tooltip": "Mind Of The Telekinetic"
	},
	"D09D563D-0689-4B56-AEAA-5A254DC408A4": {
		"file": "performing_a_melody",
		"tooltip": "Performing a Melody"
	},
	"D0BF3EF3-177C-8AD2-3673-EF10C4452A8C": {
		"file": "airport",
		"tooltip": "Airport"
	},
	"D0E5D185-0E49-FBE3-EFA9-E99CADDE7B0C": {
		"file": "arctic",
		"tooltip": "Arctic"
	},
	"D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": {
		"file": "huge",
		"tooltip": "Huge"
	},
	"D11FB4D0-3A08-A17D-5151-9AEAA1F78660": {
		"file": "weapon_ranged_attack_roll",
		"tooltip": "Dead Eye"
	},
	"D1429E13-BDC0-8D8A-011A-522DF622FA2C": {
		"file": "giant",
		"tooltip": "Giant"
	},
	"D1E8DA38-61C2-97AA-6173-4BF6157FEEE3": {
		"file": "range_far",
		"tooltip": "Far (120)"
	},
	"D1F38F68-95A2-13F2-AD27-5CAC6B8E4FC1": {
		"file": "consulate",
		"tooltip": "Consulate"
	},
	"D1FCB683-7F8A-D179-6C01-4982234B1A10": {
		"file": "specialist_in_sabotage",
		"tooltip": "Specialist In Sabotage"
	},
	"D218F4FB-5693-87B9-93C1-776FC1F7ED90": {
		"file": "stunned",
		"tooltip": "Stunned"
	},
	"D25638CA-09AF-2722-FBA9-5074DBDE3410": {
		"file": "song_of_the_fey",
		"tooltip": "Song Of The Fey"
	},
	"D266179F-EAD6-AAF2-EC00-EAF45679AD0B": {
		"file": "min_skill_tier_7",
		"tooltip": "Natural Weapon (min skill tier 7)"
	},
	"D267CD08-6952-99E9-B19E-52EC690546BB": {
		"file": "sylvan",
		"tooltip": "Sylvan"
	},
	"D28986FA-DCD0-F760-9F58-9E0AEF386F38": {
		"file": "_paladin",
		"tooltip": "Paladin"
	},
	"D2E7BA2C-562D-D4AC-7F71-13E4AC540484": {
		"file": "dominated",
		"tooltip": "Dominated"
	},
	"D2FE0631-AD39-F0FA-7B69-8DE9642D54BB": {
		"file": "tao_of_the_drunken_master",
		"tooltip": "Tao Of The Drunken Master"
	},
	"D31BAE4B-F984-13F2-537D-156D07F2F7BE": {
		"file": "auran",
		"tooltip": "Auran"
	},
	"D31E3DD8-FFA1-67EC-D3F4-FCD323059091": {
		"file": "disguised",
		"tooltip": "Disguised"
	},
	"D32C5490-F221-382F-5F10-78C118E746AA": {
		"file": "horns",
		"tooltip": "Horns"
	},
	"D343892B-338C-4FBE-BEA0-2015FE503F43": {
		"file": "donning",
		"tooltip": "Donning"
	},
	"D37F3000-77CE-2508-E0D2-E03DDDD4E903": {
		"file": "expanse",
		"tooltip": "Expanse"
	},
	"D381A7F3-A0E2-FC3F-8EC2-39FF1AEC91AE": {
		"file": "controller_role",
		"tooltip": "Controller Role"
	},
	"D3DE0245-0CBE-1FE3-04F8-D2BC22C9A849": {
		"file": "core_of_the_necroforge",
		"tooltip": "Core Of The Necroforge"
	},
	"D3E7CACD-C46B-1C27-39BC-3E4803D6AED5": {
		"file": "elemental",
		"tooltip": "Elemental"
	},
	"D3F66A5C-A446-2217-697F-C174E2E5801E": {
		"file": "_thief",
		"tooltip": "Thief"
	},
	"D4CA3D58-2C59-4515-AF01-169E7890F0D3": {
		"file": "planar",
		"tooltip": "Planar"
	},
	"D53B454A-1DA8-9358-E266-A93553FEE7D4": {
		"file": "amphitheatre",
		"tooltip": "Amphitheatre"
	},
	"D5906717-7237-CA1D-B089-18CF323A04DB": {
		"file": "flails",
		"tooltip": "Flails"
	},
	"D5A31654-692A-B4BE-49DC-2B3360F76D4A": {
		"file": "confused",
		"tooltip": "Confused"
	},
	"D5DE14C4-3194-87BC-D767-6D45BDD90552": {
		"file": "on_deaths_door",
		"tooltip": "On Deaths Door"
	},
	"D6549CC9-C7E1-F24F-D0CE-2C626360F126": {
		"file": "highlands",
		"tooltip": "Highlands"
	},
	"D656F798-435B-26F9-0332-0E489BBDEC7F": {
		"file": "_bard",
		"tooltip": "Bard"
	},
	"D66B715F-E086-4C4B-A887-4BDB38AE32EB": {
		"file": "necrotic",
		"tooltip": "Necrotic"
	},
	"D748B500-AEC7-8AA4-B103-3020410FB3DF": {
		"file": "light_shields",
		"tooltip": "Light Shields"
	},
	"D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C": {
		"file": "slings",
		"tooltip": "Slings"
	},
	"D7C86CF3-8B6D-00EC-9308-468F0FBB2FD6": {
		"file": "boathouse_wharf",
		"tooltip": "Boathouse Wharf"
	},
	"D7F51670-F6D9-5DD6-11D9-0CDBF35096A0": {
		"file": "machining",
		"tooltip": "Machining"
	},
	"D7F6DF07-296F-B231-3E70-9D6B46575709": {
		"file": "law",
		"tooltip": "Law"
	},
	"D80255AC-6D02-0158-0796-76D110DE7778": {
		"file": "blowguns",
		"tooltip": "Blowguns"
	},
	"D82855E1-4BB9-93EA-6374-B9904318BC1D": {
		"file": "range_self",
		"tooltip": "Self"
	},
	"D82D0B01-C890-8802-9650-8AD027221355": {
		"file": "shard_of_fhalora",
		"tooltip": "Shard of Fhalora"
	},
	"D868C84E-C132-1B2B-B2EC-A4679D33BAF4": {
		"file": "apartment",
		"tooltip": "Apartment"
	},
	"D8A5BF1C-75A9-0B3A-C730-0CB31DB3F712": {
		"file": "skirmisher_role",
		"tooltip": "Skirmisher Role"
	},
	"D8C10B5A-06DB-EA50-ED0F-BF5F72370A0D": {
		"file": "tower",
		"tooltip": "Tower"
	},
	"D9043BEC-2EFF-BC30-BE5C-270D7E1A68A8": {
		"file": "poisoned",
		"tooltip": "Poisoned"
	},
	"D9385FAD-9078-1329-C3B5-AA794CE08DCA": {
		"file": "forest_jungle_tropical",
		"tooltip": "Forest Jungle Tropical"
	},
	"D9394C92-068A-FAFA-231D-289157FD2980": {
		"file": "fate_card_suit_war",
		"tooltip": "Fate Card Suit War"
	},
	"D9668790-E866-861A-FDE0-D23D2903B0FA": {
		"file": "blighted_7",
		"tooltip": "Blighted 7"
	},
	"D98B076A-3A38-E225-B8E3-A646C69AA29D": {
		"file": "judgement",
		"tooltip": "Judgement"
	},
	"D9903CA2-4D2C-0352-FB50-8067D5898D9D": {
		"file": "conclave_of_the_monstrosity",
		"tooltip": "Conclave Of The Monstrosity"
	},
	"D9B64F38-A817-47B8-AB07-60D59F3D893C": {
		"file": "mirror_image_1",
		"tooltip": "Mirror Image 1"
	},
	"DA1FE3CB-8621-5252-85EE-F22EFE35C2FA": {
		"file": "planetoid",
		"tooltip": "Planetoid"
	},
	"DA2F74EB-CF67-AEEB-0DE1-376C6BB7CABA": {
		"file": "holy_turned",
		"tooltip": "Holy Turned"
	},
	"DA5A18C5-FDE5-D20B-0E3B-07B68E6C7C1C": {
		"file": "arcane_fatigue_5",
		"tooltip": "Arcane Fatigue 5"
	},
	"DA93B17F-9205-022A-D20D-1C396719FDB7": {
		"file": "specialist_in_corpsman",
		"tooltip": "Specialist In Corpsman"
	},
	"DABF4143-1969-C974-4903-C1212E57B94C": {
		"file": "ocean",
		"tooltip": "Ocean"
	},
	"DADEF475-1E69-4EF4-8B46-06F3FC2B450D": {
		"file": "orb_slots",
		"tooltip": "Orb Slots"
	},
	"DAEDF534-4EC3-E916-F2CC-E3E0E31E8BC0": {
		"file": "government_complex",
		"tooltip": "Government Complex"
	},
	"DB1C8E56-CBD7-09E4-0FBF-148F28A93D67": {
		"file": "fleeing",
		"tooltip": "Fleeing"
	},
	"DB1F3A9C-996D-4CD9-AC59-7607CF044826": {
		"file": "keyboards",
		"tooltip": "Keyboards"
	},
	"DB30C685-3830-9AEA-D8FA-D92FEA762982": {
		"file": "increase_mana_roll",
		"tooltip": "Increase Mana Roll"
	},
	"DB6A91D7-7F88-7FB2-1783-7393CF041B9C": {
		"file": "song_of_the_loom",
		"tooltip": "Song Of The Loom"
	},
	"DBE04183-FCE3-1DBC-33E5-961A1EA483EF": {
		"file": "aviary",
		"tooltip": "Aviary"
	},
	"DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": {
		"file": "medium",
		"tooltip": "Medium - Size"
	},
	"DC3DC1CB-1E0A-86B0-1F24-75DF34EFD580": {
		"file": "mansion_villa",
		"tooltip": "Mansion Villa"
	},
	"DC474A8F-1F4B-CC10-1C8C-BDEDADF471C0": {
		"file": "firearms_25_caliber_bullet",
		"tooltip": "Firearms 25 Caliber Bullets"
	},
	"DC50590B-2070-766A-43D5-76E5A0A8D5E5": {
		"file": "crossbow_bolt",
		"tooltip": "Crossbow Bolts"
	},
	"DC69D264-F1AD-97F1-FCB3-C53138BC74BC": {
		"file": "altar",
		"tooltip": "Altar"
	},
	"DCAD0629-C1D1-97C9-E05C-5DFB1FE998F8": {
		"file": "space_station",
		"tooltip": "Space Station"
	},
	"DCB240F7-C033-1B9C-0E27-446C5C1F4D0C": {
		"file": "repelled",
		"tooltip": "Repelled"
	},
	"DCE7B411-99FB-9517-2E2B-21B2DD0F0125": {
		"file": "megastructure",
		"tooltip": "Megastructure"
	},
	"DCE7C0B4-5ADD-4501-B53A-8F17808F2F4C": {
		"file": "abyss",
		"tooltip": "Abyss"
	},
	"DD1EFCA2-2A4C-AD3D-B814-A325B2D22D85": {
		"file": "circle_of_abjuration",
		"tooltip": "Circle of Abjuration"
	},
	"DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C": {
		"file": "spell_ranged_attack_roll",
		"tooltip": "Spell Ranged Attack Roll"
	},
	"DD4C0995-C3D2-43A3-CFC7-226C3005274C": {
		"file": "charmed",
		"tooltip": "Charmed"
	},
	"DD53CA8E-DF3D-9AF4-49CB-9C61926BBB93": {
		"file": "defenseless",
		"tooltip": "Defenseless"
	},
	"DD8437E1-8615-D32E-C689-E6A0CD8DBE71": {
		"file": "skyscraper",
		"tooltip": "Skyscraper"
	},
	"DDB21DE1-F41C-4456-B99C-D1B9D8742B84": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Slam"
	},
	"DDC66C31-4093-84AF-18BB-093D924B8738": {
		"file": "piloted",
		"tooltip": "Piloted"
	},
	"DE15C4F8-2710-8187-3788-2DA46D8724B8": {
		"file": "scythes",
		"tooltip": "Scythes"
	},
	"DE5B6A74-0024-FFDB-C5C6-B0248D956515": {
		"file": "reduce_luck_roll",
		"tooltip": "Reduce Luck Roll"
	},
	"DE790F66-C77A-570A-579F-71A9E44B2884": {
		"file": "pond",
		"tooltip": "Pond"
	},
	"DEC0A112-9ADC-09D3-0FA7-3A59CFE8C008": {
		"file": "navigation",
		"tooltip": "Navigation"
	},
	"DF516479-F164-87FA-7BB8-6F268BF1DCE7": {
		"file": "speed_walking",
		"tooltip": "Walking Speed"
	},
	"DF593FA2-C331-4CCC-8DCD-4978D4DA77BE": {
		"file": "mind_of_the_telepath",
		"tooltip": "Mind Of The Telepath"
	},
	"DF66C93B-B190-4A4C-8E15-72E79D8F7C08": {
		"file": "campaign_difficulty_hardcore",
		"tooltip": "Campaign Difficulty Hardcore"
	},
	"DF9823AC-E1BB-E716-486C-FBEBDF270964": {
		"file": "parliament",
		"tooltip": "Parliament"
	},
	"DFCE3528-A8AF-ACFF-B837-7A89B1E85FB3": {
		"file": "grel",
		"tooltip": "Grel"
	},
	"DFCF49C0-D5BC-C56F-A7C5-DC8D134ED7D7": {
		"file": "petrifying",
		"tooltip": "Petrifying"
	},
	"E0135F81-E291-0553-9FF8-0BCB67C342C4": {
		"file": "grove_of_the_mountain",
		"tooltip": "Grove Of The Mountain"
	},
	"E023B642-259E-69D7-4E72-334FE0A6EE64": {
		"file": "geology",
		"tooltip": "Geology"
	},
	"E03A9BC3-2D6E-4C5F-8FFB-D7BA35D99301": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Pincer"
	},
	"E03C63EE-6D22-0F0D-0E13-FBA5FD5995B6": {
		"file": "support_role",
		"tooltip": "Support Role"
	},
	"E0407389-A0AC-7C17-89E1-F451F7E2BF59": {
		"file": "supercontinent",
		"tooltip": "Supercontinent"
	},
	"E05E77E1-F35F-12E7-111F-EB582D78C862": {
		"file": "craftsman_blacksmith_smithy",
		"tooltip": "Craftsman Blacksmith Smithy"
	},
	"E11509DD-8F0F-41FB-A34F-7F9917136D7A": {
		"file": "study_of_necromancy",
		"tooltip": "Study Of Necromancy"
	},
	"E15FE1AD-692D-E640-9A4C-AF21D95ED7BD": {
		"file": "asteroid_belt",
		"tooltip": "Asteroid Belt"
	},
	"E18A79D1-AA69-7F80-2579-78B583E0771B": {
		"file": "arcane_fatigue_2",
		"tooltip": "Arcane Fatigue 2"
	},
	"E19F0AB8-E760-D84A-85C3-1A14E7DFE399": {
		"file": "arcane_fatigue_7",
		"tooltip": "Arcane Fatigue 7"
	},
	"E1C8D281-0DC7-4883-8381-5630E23AD99D": {
		"file": "excavation_roll",
		"tooltip": "Excavation Roll"
	},
	"E2054884-038E-3D6E-56C5-19ABBFED8379": {
		"file": "obscured",
		"tooltip": "Obscured"
	},
	"E2528842-8503-6034-9AE2-1C28C1893A22": {
		"file": "sign_language",
		"tooltip": "Sign Language"
	},
	"E25DE317-AB3A-45A1-AE7E-1F8F5A6C47D2": {
		"file": "oath_of_the_guardian",
		"tooltip": "Oath Of The Guardian"
	},
	"E2642195-EDA0-141A-2147-77E13647D85F": {
		"file": "military_base_complex",
		"tooltip": "Military Base Complex"
	},
	"E26F9653-FBDA-52BA-080B-8BBB422069CE": {
		"file": "blood_of_the_stars",
		"tooltip": "Blood Of The Stars"
	},
	"E26FC164-16F5-E38B-66F9-337FAEDE2A67": {
		"file": "skill_roll_assistance_roll",
		"tooltip": "Skill Roll Assistance Roll"
	},
	"E29189CC-A2FA-B06A-5DBD-8551A3259829": {
		"file": "arcane_fatigue_9",
		"tooltip": "Arcane Fatigue 9"
	},
	"E2C8138B-8805-08A0-C8E2-C79AD86B720B": {
		"file": "craftsman_leatherworker",
		"tooltip": "Craftsman Leatherworker"
	},
	"E2C8228D-A3A4-415F-26BA-AD832865C0FC": {
		"file": "specialist_in_piracy",
		"tooltip": "Specialist In Piracy"
	},
	"E2CEA842-2B66-5D3C-C20D-0454E18215F4": {
		"file": "monstrous_cavalry",
		"tooltip": "Monstrous Cavalry"
	},
	"E2E31010-3F23-7038-4AD0-4DC1ABE897E6": {
		"file": "estate",
		"tooltip": "Estate"
	},
	"E2EBA358-809D-BA9D-0A25-C82844B76370": {
		"file": "heavy_cavalry",
		"tooltip": "Heavy Cavalry"
	},
	"E3169368-A4EF-476F-B699-5EFE62C7CE2A": {
		"file": "wet",
		"tooltip": "Wet"
	},
	"E332C998-1B31-430A-8796-6D991689F60E": {
		"file": "abbey",
		"tooltip": "Abbey"
	},
	"E34AF232-5438-88FC-9A9F-73850CCCFD51": {
		"file": "restrained",
		"tooltip": "Restrained"
	},
	"E350D4F5-B29D-17C0-4AB4-0CAA0398C74A": {
		"file": "custom_ability",
		"tooltip": "Custom Ability"
	},
	"E38D3E9B-55CE-49EE-272B-C053D3C2E3B9": {
		"file": "finance",
		"tooltip": "Finance"
	},
	"E3DFF047-0ACE-4C14-A204-3B32572EF1DE": {
		"file": "mount_worn_hands",
		"tooltip": "Visual Mount — Worn: Hands"
	},
	"E472D6BD-1A9C-F84E-AD55-F3068A3EC303": {
		"file": "ghostsight",
		"tooltip": "Ghostsight"
	},
	"E48B1524-C478-E245-AF07-2A1A145EE4D5": {
		"file": "longswords",
		"tooltip": "Longswords"
	},
	"E4994653-49B3-D768-35C1-36C8DE40CC1A": {
		"file": "maimed_5",
		"tooltip": "Maimed 5"
	},
	"E49AA8BA-1F60-4FD8-B3C0-852BBA3978C3": {
		"file": "crafting_progress",
		"tooltip": "Crafting Progress"
	},
	"E4A34093-AAAB-6453-BCE0-FBA65EE263AD": {
		"file": "grappling",
		"tooltip": "Grappling"
	},
	"E4B7F803-C689-A9A5-0FB7-EB8D9946874E": {
		"file": "sun_state_night",
		"tooltip": "Sun State Night"
	},
	"E4DF1F3A-78BC-A901-6118-8C549AB811D8": {
		"file": "shoal",
		"tooltip": "Shoal"
	},
	"E4FB85CE-C211-BE13-B674-A2A591384C11": {
		"file": "pikes",
		"tooltip": "Pikes"
	},
	"E5016E3A-6A12-2287-5F48-5CFAC863E967": {
		"file": "summon_roll",
		"tooltip": "Summon Roll"
	},
	"E5314BED-1269-3A65-8C15-01E80A3A8E23": {
		"file": "shielded_4",
		"tooltip": "Shielded 4"
	},
	"E5347227-42FD-9173-6C81-ADAD3E0ED6ED": {
		"file": "woodworking",
		"tooltip": "Woodworking"
	},
	"E53C0243-22DB-72BE-2ABD-21BD858BEE60": {
		"file": "national_territory",
		"tooltip": "National Territory"
	},
	"E5452E0D-251E-4BDD-AC25-DADD00A7BEC7": {
		"file": "electrocuted",
		"tooltip": "Electrocuted"
	},
	"E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F": {
		"file": "bad_newses",
		"tooltip": "Bad News"
	},
	"E5890CE0-37BB-B295-B094-85C2B9FAD943": {
		"file": "sea",
		"tooltip": "Sea"
	},
	"E5F142A7-D1C5-4ED9-BBC6-C7F8FEDF5D57": {
		"file": "ambusher_role",
		"tooltip": "Ambusher Role"
	},
	"E614D75F-CF27-D169-3D91-0D33D9CE354B": {
		"file": "shielded_5",
		"tooltip": "Shielded 5"
	},
	"E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30": {
		"file": "blighted_10",
		"tooltip": "Blighted 10"
	},
	"E64E94A5-60A7-26FF-DE15-DEA120685D00": {
		"file": "police_fire_station",
		"tooltip": "Police Fire Station"
	},
	"E69EFD66-F8CC-0847-D4C3-41D1E9DFD255": {
		"file": "monastery",
		"tooltip": "Monastery"
	},
	"E6CCEF87-419A-57CF-DC12-73324DB86CD1": {
		"file": "crossbows_hand",
		"tooltip": "Hand Crossbows"
	},
	"E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D": {
		"file": "both_hands",
		"tooltip": "Both Hands"
	},
	"E7039ED2-EA0E-4218-A3BF-931A63F983DA": {
		"file": "umbral",
		"tooltip": "Umbral"
	},
	"E73758E2-453A-B5EA-A8AE-0418702C3E90": {
		"file": "core_of_the_quaking_bell",
		"tooltip": "Core Of The Quaking Bell"
	},
	"E749A3D6-F04A-4890-85B2-ACD31A722718": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Pseudopod"
	},
	"E75F440A-B675-0C34-AEDD-568FDAD06675": {
		"file": "tavern_pub_bar_restaurant",
		"tooltip": "Tavern Pub Bar Restaurant"
	},
	"E76097FE-D47E-FD76-B7AF-8F0C40A3BCA1": {
		"file": "thieves_cant",
		"tooltip": "Thieves Cant"
	},
	"E769E451-65EE-3628-1A78-D12C9A3FF02B": {
		"file": "fortune",
		"tooltip": "Fortune"
	},
	"E77A8B34-F880-E0E2-E6EC-42F4241F4FCC": {
		"file": "enchanting",
		"tooltip": "Enchanting"
	},
	"E7E1210B-7197-DD1F-5324-5FAA39395450": {
		"file": "hill",
		"tooltip": "Hill"
	},
	"E7E628D7-A21D-9136-E171-4A35BF375FF4": {
		"file": "dimensional_plane",
		"tooltip": "Dimensional Plane"
	},
	"E7FDB796-26DA-E0F5-8F88-C21FE01D923B": {
		"file": "concentrating",
		"tooltip": "Concentrating"
	},
	"E831D078-0533-33A9-76FE-5070AC95F373": {
		"file": "mountain_range",
		"tooltip": "Mountain Range"
	},
	"E83F15DB-2FA1-991A-D117-74B0022D3338": {
		"file": "grassland_location",
		"tooltip": "Grassland Location"
	},
	"E8B770D7-1BC3-4035-A29C-B99047884CC1": {
		"file": "cylinder",
		"tooltip": "Cylinder"
	},
	"E8FB3E1F-2B16-4889-831C-99FC9E34853E": {
		"file": "half_caster",
		"tooltip": "Half Caster"
	},
	"E973D6BE-E84E-4373-B134-BA8AA13BCD30": {
		"file": "shield_armor_skill",
		"tooltip": "Shield Armor Skill"
	},
	"E988F6F8-ABBF-9395-1931-80CA1BAB1F9A": {
		"file": "megalith",
		"tooltip": "Megalith"
	},
	"E9C4F105-E156-8DC4-4753-9F9427621B05": {
		"file": "citadel",
		"tooltip": "Citadel"
	},
	"E9E1745B-7B0B-4082-BE65-72EAFEAA2CB1": {
		"file": "training_in_the_gunslinger",
		"tooltip": "Training In The Gunslinger"
	},
	"E9FC70FC-7F7C-48AB-B2AC-E25172104583": {
		"file": "wenhe_stance",
		"tooltip": "Wenhe Stance"
	},
	"EA0C0C09-5B81-A5E2-D325-82330B54A196": {
		"file": "ignan",
		"tooltip": "Ignan"
	},
	"EAA88590-DB1D-7C46-F523-E87A31912777": {
		"file": "dizzy",
		"tooltip": "Dizzy"
	},
	"EAC11C79-B399-7259-8556-8EDA88B7FCD8": {
		"file": "terran",
		"tooltip": "Terran"
	},
	"EB39CEE1-4B20-DDB2-3FD8-51C04BE2DB96": {
		"file": "island_floating",
		"tooltip": "Island Floating"
	},
	"EB59D8AE-9995-800A-4696-3254B1FD6A13": {
		"file": "laboratory",
		"tooltip": "Laboratory"
	},
	"EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022": {
		"file": "shielded",
		"tooltip": "Shielded"
	},
	"EB6FB558-7427-A647-8F46-D2E8C25F1F60": {
		"file": "exhausted",
		"tooltip": "Exhausted"
	},
	"EBC29BD4-10ED-12BD-5E78-854A8AD232E2": {
		"file": "hauberk_armors",
		"tooltip": "Hauberk Armors"
	},
	"EBC4D926-EF60-DD81-248E-54F6F31F29E0": {
		"file": "tornado",
		"tooltip": "Storm Wind"
	},
	"EBF9B1EB-6800-6251-4BF6-36BB50D97595": {
		"file": "harbinger_of_rot",
		"tooltip": "Harbinger of Rot"
	},
	"EC1F7FF4-9E4C-DAE0-633A-B0BE7F4A2788": {
		"file": "circle_of_illusion",
		"tooltip": "Circle of Illusion"
	},
	"EC7ACDFA-A5FE-77B7-3451-C5C080DD71B5": {
		"file": "wind_breeze",
		"tooltip": "Breeze"
	},
	"EC7FB5BE-A124-EC02-E9B6-0B5BA4C26D47": {
		"file": "fishery",
		"tooltip": "Fishery"
	},
	"EC8F4821-26B6-4874-86E0-2B344CDC8B4F": {
		"file": "reckless",
		"tooltip": "Reckless"
	},
	"ECAF373E-3B22-C666-FB53-2707ED576BCD": {
		"file": "galactic_quadrant",
		"tooltip": "Galactic Quadrant"
	},
	"ED30CCB0-1645-B97E-B9A6-867D8D0094BD": {
		"file": "reading",
		"tooltip": "Reading"
	},
	"ED4A5C96-E0DA-8CAE-136D-E7D0BD14728A": {
		"file": "datacenter",
		"tooltip": "Datacenter"
	},
	"ED5B44EA-7438-9582-A388-04EFF342E460": {
		"file": "dc_roll",
		"tooltip": "DC Roll"
	},
	"ED9810A9-3456-4D6B-BC5C-A1BAF5952B98": {
		"file": "speed_swimming",
		"tooltip": "Swimming Speed"
	},
	"EDBF0393-95BC-452B-9E23-7ACE3BA34840": {
		"file": "mount_back_pack",
		"tooltip": "Visual Mount — Back Pack"
	},
	"EDCBE2A8-CD3D-43DC-9B92-84A634BE12AE": {
		"file": "speed_climbing",
		"tooltip": "Climbing Speed"
	},
	"EDD2EF50-DC2D-75F3-367F-A6A9D63D9316": {
		"file": "aberration",
		"tooltip": "Aberration"
	},
	"EE063289-1AF3-41CF-B73C-64A0556E6D07": {
		"file": "dying_state_1",
		"tooltip": "Dying State 1"
	},
	"EE3151A4-5BA0-52EB-85C8-B4E829E888BF": {
		"file": "temperature_chill",
		"tooltip": "Chill"
	},
	"EE83AA36-981D-EC06-A7BE-2FF328180A8D": {
		"file": "grove",
		"tooltip": "Grove"
	},
	"EE995E91-1D61-F2DC-E7BB-AA5651E561C7": {
		"file": "leader_role",
		"tooltip": "Leader Role"
	},
	"EEB78637-0F73-8369-D230-8C29512B759E": {
		"file": "custom_free_ability",
		"tooltip": "Custom Free Ability"
	},
	"EEDA8505-F8C2-2E1E-2DEC-B0BD79F35871": {
		"file": "park",
		"tooltip": "Park"
	},
	"EEDD357F-C1CA-44C1-A53F-DD06EEFBA597": {
		"file": "holding_mastery",
		"tooltip": "Holding Mastery"
	},
	"EF165E68-DD93-90C8-A848-01D93B041CBD": {
		"file": "arcane_fatigue_4",
		"tooltip": "Arcane Fatigue 4"
	},
	"F00CE88F-4D41-A36D-8883-8C3CAFAAD744": {
		"file": "temple_church",
		"tooltip": "Temple Church"
	},
	"F020D412-8836-1074-612E-D703B7488CC7": {
		"file": "ready",
		"tooltip": "Ready"
	},
	"F05BF8F6-1C95-C64D-DA2B-8C1C8D7E51BB": {
		"file": "cemetery",
		"tooltip": "Cemetery"
	},
	"F07C595F-D2DC-4CE9-904E-A4D73ABF9DEA": {
		"file": "stabilized",
		"tooltip": "Stabilized"
	},
	"F13F6A58-FE91-F24D-12BE-BE7CCAD81A40": {
		"file": "ridden",
		"tooltip": "Ridden"
	},
	"F14311B1-5B45-9E9A-E12A-42C0E4915F41": {
		"file": "bulwarks",
		"tooltip": "Bulwarks"
	},
	"F187EE82-1D32-4C53-9F69-E59DDF33D7C7": {
		"file": "fist_weapons",
		"tooltip": "Fist Weapons"
	},
	"F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB": {
		"file": "back",
		"tooltip": "Back"
	},
	"F1A71448-07EF-462D-BF26-D3DB88F7E489": {
		"file": "mount_back_quiver",
		"tooltip": "Visual Mount — Back Quiver"
	},
	"F1CB1CCF-138F-0B16-266F-3AFE1AB8C73D": {
		"file": "extra_healing_roll",
		"tooltip": "Extra Healing Roll"
	},
	"F1D0A27A-43F1-4A4C-A5F8-ED9BD2D908D4": {
		"file": "speed_flying",
		"tooltip": "Flying Speed"
	},
	"F259DADA-89E7-F08F-E24C-DA140F84FB36": {
		"file": "music",
		"tooltip": "Music"
	},
	"F277610B-299C-49B4-9773-2F1A3F3E80FB": {
		"file": "off_hand",
		"tooltip": "Advanced Grip Training"
	},
	"F29D806E-160C-4EC2-923F-AAF1D5CDDB7E": {
		"file": "leatherworking",
		"tooltip": "Leatherworking"
	},
	"F2CD1603-38A4-85E9-D148-CE3D429310A2": {
		"file": "banished",
		"tooltip": "Banished"
	},
	"F2D31321-42E4-926B-892A-DF0A41176D14": {
		"file": "_psion",
		"tooltip": "Psion"
	},
	"F2D8C4B3-FA31-291C-995A-2046F84A289F": {
		"file": "air_around",
		"tooltip": "Air Around"
	},
	"F2FDFE14-A998-81D5-024E-3CF1B0B26E43": {
		"file": "trail_of_the_broken_limits",
		"tooltip": "Trail Of The Broken Limits"
	},
	"F30890EA-DC2E-B1CF-3AEE-66751777F2A9": {
		"file": "bakery",
		"tooltip": "Bakery"
	},
	"F326ECEC-8545-48E6-80DC-B3901DD4CE37": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Talon"
	},
	"F3DD13A6-DBA1-104A-E16D-78CD3513E97C": {
		"file": "draconic",
		"tooltip": "Draconic"
	},
	"F40E19A3-FC86-187F-050E-8C8B69761353": {
		"file": "immobile",
		"tooltip": "Immobile"
	},
	"F4329ECF-140A-B898-41DA-FB0AFF071B01": {
		"file": "bathhouse",
		"tooltip": "Bathhouse"
	},
	"F437FC6A-AEB0-8030-B1D9-8A18CFBD52D8": {
		"file": "shard_of_alucard",
		"tooltip": "Shard of Alucard"
	},
	"F447DB78-35EB-BB77-E5CC-BF0FBE2377A8": {
		"file": "shock_cavalry",
		"tooltip": "Shock Cavalry"
	},
	"F450C824-98D3-D0B1-D6B1-C326F15F1578": {
		"file": "enfeebled",
		"tooltip": "Enfeebled"
	},
	"F55C0D31-091D-0F3F-74F0-AEE4C20BE1ED": {
		"file": "vulnerable",
		"tooltip": "Vulnerable"
	},
	"F573438B-0CA0-C945-B90F-5EFB6E1E1C99": {
		"file": "_priest",
		"tooltip": "Priest"
	},
	"F5A23631-F770-1C49-79F0-E8A2B7A6DCAC": {
		"file": "influence",
		"tooltip": "Influence"
	},
	"F5ACBDB4-D923-3684-57F6-FBF3F720AEFA": {
		"file": "prone",
		"tooltip": "Prone"
	},
	"F5BC82EE-DBDF-4594-F850-0C49E4292AC7": {
		"file": "temporary_max_vitality_roll",
		"tooltip": "Temporary Max Vitality Roll"
	},
	"F5D2429C-6BA8-901F-2E23-30C780107C47": {
		"file": "circle_of_necromancy",
		"tooltip": "Circle of Necromancy"
	},
	"F5E27A66-BF01-7CD2-C68E-CBE64A9F73E9": {
		"file": "blood_of_the_hemophage",
		"tooltip": "Blood Of The Hemophage"
	},
	"F5EE40A5-D18A-4186-82D3-E21075B43CBA": {
		"file": "tao_of_gentleness",
		"tooltip": "Tao Of Gentleness"
	},
	"F632281D-2F16-FFDA-FB95-2E958988F01F": {
		"file": "corroding",
		"tooltip": "Corroding"
	},
	"F66879A9-5BDC-4996-8419-AF162CFCDC5F": {
		"file": "acid",
		"tooltip": "Acid"
	},
	"F66F5044-B272-A3B0-0432-7E39B27A25B1": {
		"file": "coast",
		"tooltip": "Coast"
	},
	"F676CF26-49CD-89EB-79F5-C594FFC55902": {
		"file": "castle",
		"tooltip": "Castle"
	},
	"F6AA8864-18EE-0140-0C65-8EEEFE2FE5E4": {
		"file": "core_of_the_rimeguard",
		"tooltip": "Core Of The Rimeguard"
	},
	"F6CED23C-3BE7-2904-C18A-C77C589CE0B1": {
		"file": "pier",
		"tooltip": "Pier"
	},
	"F6CFA733-CEBD-41EE-B357-2CCEA45FECF6": {
		"file": "trail_of_the_hallow_mind",
		"tooltip": "Trail Of The Hallow Mind"
	},
	"F6DAE84B-CBB3-5C0F-89EF-370DE841DFDA": {
		"file": "range_very_far",
		"tooltip": "Very Far (240)"
	},
	"F711788C-2BB4-4114-8339-B3C85BE0D52A": {
		"file": "shocked",
		"tooltip": "Shocked"
	},
	"F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1": {
		"file": "unconscious",
		"tooltip": "Unconscious"
	},
	"F74CFA32-D114-191D-CC2F-C8DE12B8E871": {
		"file": "weapon",
		"tooltip": "Weapon Size: Huge"
	},
	"F76F59F0-67A5-4492-05B2-19DB315AD6DF": {
		"file": "stream",
		"tooltip": "Stream"
	},
	"F77D6A8D-D5F2-44ED-81DB-74ADCFF5B366": {
		"file": "beijxing_stance",
		"tooltip": "Beijxing Stance"
	},
	"F7944C69-7A83-4BF1-9B39-C4EE05951309": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Claw"
	},
	"F794E50D-95E8-A7AB-D7BD-CC2C3035CFEC": {
		"file": "faith_in_dreams",
		"tooltip": "Faith In Dreams"
	},
	"F79CF36E-F439-44C3-9668-050683A30F1C": {
		"file": "thunder",
		"tooltip": "Thunder"
	},
	"F7A1C3B2-5D64-4E18-9A70-2C8B41D5E093": {
		"file": "spoiling",
		"tooltip": "Spoiling"
	},
	"F7FCBD40-CA99-88E6-BC5B-7D2F7D3C0EDB": {
		"file": "zithers",
		"tooltip": "Zithers Skill"
	},
	"F84B81E6-D7BD-CBD5-A1EC-0C39226E3E69": {
		"file": "cliff",
		"tooltip": "Cliff"
	},
	"F84D1999-6C79-E58C-537B-77AEB2D6490C": {
		"file": "bodden",
		"tooltip": "Bodden"
	},
	"F87E66D1-0EB2-469F-BB07-CF2CF4E26B30": {
		"file": "blindsight",
		"tooltip": "Blindsight"
	},
	"F8E5B117-B27E-E5AC-1482-73078CAA2BA0": {
		"file": "school",
		"tooltip": "School"
	},
	"F8E5F274-2F31-1340-6167-ED9131E81A88": {
		"file": "arcane_fatigue_1",
		"tooltip": "Arcane Fatigue 1"
	},
	"F90FB02F-2549-6FE0-A162-CC3FA7C90C67": {
		"file": "dissolving",
		"tooltip": "Dissolving"
	},
	"F9134996-0370-34A2-A101-13497D6631A0": {
		"file": "drums",
		"tooltip": "Drums Skill"
	},
	"F922ECF7-2053-2F23-EEEF-E5B86C72C2E5": {
		"file": "glacier",
		"tooltip": "Glacier"
	},
	"F964C0DA-54EA-1EB5-ED00-8E9AD50FFA53": {
		"file": "bending_weapon_skill",
		"tooltip": "Bending Weapon Skill"
	},
	"F968E89D-C2FF-FA26-951F-02587238161A": {
		"file": "druidic",
		"tooltip": "Druidic"
	},
	"F99172CC-DDEF-48D4-87F8-8B94F0071247": {
		"file": "attention",
		"tooltip": "Attention"
	},
	"F99AF61A-D832-47CD-8464-E9AE0E1881BD": {
		"file": "mount_back_bow",
		"tooltip": "Visual Mount — Back Bow"
	},
	"FA17A3A2-3068-C84C-1EA5-C511F71FBD8B": {
		"file": "gathering_roll",
		"tooltip": "Gathering Roll"
	},
	"FA5A9A83-FB7B-F756-A22E-7ADF7DB80140": {
		"file": "wormhole",
		"tooltip": "Wormhole"
	},
	"FABD5931-2BE5-4A39-BD45-62529717A62F": {
		"file": "tail",
		"tooltip": "Natural Weapon Form — Tail"
	},
	"FAEFBA34-2176-46E5-911D-51580EF6DA74": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Stinger"
	},
	"FAFC9034-187C-4E86-926C-AF8DFBF0BE99": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 3+)"
	},
	"FB03E84D-6902-1885-DDF0-5BFD0D59A2C5": {
		"file": "natural_wonder",
		"tooltip": "Natural Wonder"
	},
	"FB124CCD-B381-452B-CAA1-B598E90A8534": {
		"file": "greatswords",
		"tooltip": "Greatswords"
	},
	"FB30C45A-AC2F-FDE0-B530-6E7C426FA237": {
		"file": "district",
		"tooltip": "District"
	},
	"FB7A648E-43E8-B396-4DB0-06D828EC2B2E": {
		"file": "dungeon",
		"tooltip": "Dungeon"
	},
	"FBBD1092-449F-4322-9AF5-588825C2E3BD": {
		"file": "great_arrow",
		"tooltip": "Great Arrows"
	},
	"FBD22CAB-950F-8DAE-E052-65A88BF5205B": {
		"file": "sign_language",
		"tooltip": "Sign Language"
	},
	"FBD8C681-C1CE-B2D5-9D2C-B41CFA9E16D7": {
		"file": "stringed_plucked",
		"tooltip": "Stringed Plucked"
	},
	"FBDDC2CF-8E49-005F-EEB7-ADBA5ECE045A": {
		"file": "grove_of_the_deep",
		"tooltip": "Grove Of The Deep"
	},
	"FC1A548D-2BDF-D613-3645-59FCCFC0FD6D": {
		"file": "minion_role",
		"tooltip": "Minion Role"
	},
	"FC73E87B-BD88-590F-5409-8C2BDA8974A8": {
		"file": "theme_park_entertainment_complex",
		"tooltip": "Theme Park Entertainment Complex"
	},
	"FCB7F0DD-461E-82DC-B522-DE4FD47D1CD3": {
		"file": "silo",
		"tooltip": "Silo"
	},
	"FCC88F77-777D-56B1-913E-E676C90E39E3": {
		"file": "blighted_4",
		"tooltip": "Blighted 4"
	},
	"FCED5C37-344C-1B6A-7598-E682452C1AA9": {
		"file": "palm_pistols",
		"tooltip": "Palm Pistols"
	},
	"FD2AC285-7609-49D5-B6BD-3287F920472F": {
		"file": "swamp",
		"tooltip": "Swamp"
	},
	"FD5CB2E3-B247-274A-5B42-25F538F72661": {
		"file": "weary",
		"tooltip": "Weary"
	},
	"FDC0E3EB-402E-156E-9EBD-EF8C4E2DA59C": {
		"file": "tao_of_the_courtesan",
		"tooltip": "Tao Of The Courtesan"
	},
	"FDC86C34-8F96-3361-E0A9-FCFAFF0522D9": {
		"file": "campaign_difficulty_easy",
		"tooltip": "Campaign Difficulty Easy"
	},
	"FDDFF216-A24D-C129-BB48-DB543159B2B7": {
		"file": "shard_of_korravex",
		"tooltip": "Shard Of Korravex"
	},
	"FE5CD056-4302-EBB7-BAE4-E8BC0CCC1FCD": {
		"file": "plant",
		"tooltip": "Plant"
	},
	"FF0AD09F-3CD3-3585-6D6F-AF14E13CB5AB": {
		"file": "tao_of_the_dancing_spider",
		"tooltip": "Tao Of The Dancing Spider"
	},
	"FF30B76E-785D-2CAF-FC66-C131D0548808": {
		"file": "fresh",
		"tooltip": "Fresh"
	},
	"FF534A71-6D75-FA02-6614-3DE578770FE5": {
		"file": "contact_poison",
		"tooltip": "Contact Poison"
	},
	"FF8D219A-2A83-0EE5-A222-E748753E8D0B": {
		"file": "riding",
		"tooltip": "Riding"
	},
	"FF9A38A3-5F35-F083-E153-7DF41B0C0826": {
		"file": "lockpicking",
		"tooltip": "Lockpicking"
	},
	"_barbarian": {
		"file": "_barbarian",
		"tooltip": "Barbarian"
	},
	"_bard": {
		"file": "_bard",
		"tooltip": "Bard"
	},
	"_champion": {
		"file": "_champion",
		"tooltip": "Champion"
	},
	"_deathbringer": {
		"file": "_deathbringer",
		"tooltip": "Deathbringer"
	},
	"_druid": {
		"file": "_druid",
		"tooltip": "Druid"
	},
	"_hunter": {
		"file": "_hunter",
		"tooltip": "Hunter"
	},
	"_machinist": {
		"file": "_machinist",
		"tooltip": "Machinist"
	},
	"_monk": {
		"file": "_monk",
		"tooltip": "Monk"
	},
	"_paladin": {
		"file": "_paladin",
		"tooltip": "Paladin"
	},
	"_priest": {
		"file": "_priest",
		"tooltip": "Priest"
	},
	"_psion": {
		"file": "_psion",
		"tooltip": "Psion"
	},
	"_shaman": {
		"file": "_shaman",
		"tooltip": "Shaman"
	},
	"_sorcerer": {
		"file": "_sorcerer",
		"tooltip": "Sorcerer"
	},
	"_spellblade": {
		"file": "_spellblade",
		"tooltip": "Spellblade"
	},
	"_summoner": {
		"file": "_summoner",
		"tooltip": "Summoner"
	},
	"_thief": {
		"file": "_thief",
		"tooltip": "Thief"
	},
	"_warlock": {
		"file": "_warlock",
		"tooltip": "Warlock"
	},
	"_wizard": {
		"file": "_wizard",
		"tooltip": "Wizard"
	},
	"abbey": {
		"file": "abbey",
		"tooltip": "Abbey"
	},
	"aberration": {
		"file": "aberration",
		"tooltip": "Aberration"
	},
	"abolian": {
		"file": "abolian",
		"tooltip": "Abolian"
	},
	"abyss": {
		"file": "abyss",
		"tooltip": "Abyss"
	},
	"abyssal": {
		"file": "abyssal",
		"tooltip": "Abyssal"
	},
	"acid": {
		"file": "acid",
		"tooltip": "Acid"
	},
	"acropolis_citadel": {
		"file": "acropolis_citadel",
		"tooltip": "Acropolis Citadel"
	},
	"adv": {
		"file": "adv",
		"tooltip": "Advantage"
	},
	"advance_grapple_restrain": {
		"file": "advance_grapple_restrain",
		"tooltip": "Advance Grapple: Restrain"
	},
	"advanced_grip_training": {
		"file": "off_hand",
		"tooltip": "Advanced Grip Training"
	},
	"aether": {
		"file": "aether",
		"tooltip": "Aether"
	},
	"ageless": {
		"file": "ageless",
		"tooltip": "Ageless"
	},
	"air_around": {
		"file": "air_around",
		"tooltip": "Air Around"
	},
	"airport": {
		"file": "airport",
		"tooltip": "Airport"
	},
	"alchemy": {
		"file": "alchemy",
		"tooltip": "Alchemy"
	},
	"allotment": {
		"file": "allotment",
		"tooltip": "Allotment"
	},
	"altar": {
		"file": "altar",
		"tooltip": "Altar"
	},
	"ambusher_role": {
		"file": "ambusher_role",
		"tooltip": "Ambusher Role"
	},
	"amphitheatre": {
		"file": "amphitheatre",
		"tooltip": "Amphitheatre"
	},
	"animated": {
		"file": "animated_summon",
		"tooltip": "Animated Summon"
	},
	"aoe_redirection": {
		"file": "aoe_redirection",
		"tooltip": "AOE Redirection"
	},
	"apartment": {
		"file": "apartment",
		"tooltip": "Apartment"
	},
	"apartment_building_tenement": {
		"file": "apartment_building_tenement",
		"tooltip": "Apartment Building Tenement"
	},
	"apothecary_building": {
		"file": "apothecary_building",
		"tooltip": "Apothecary Building"
	},
	"aquan": {
		"file": "aquan",
		"tooltip": "Aquan"
	},
	"aqueduct": {
		"file": "aqueduct",
		"tooltip": "Aqueduct"
	},
	"arcane": {
		"file": "arcane",
		"tooltip": "Arcane Sphere of Magic"
	},
	"arcane_circle": {
		"file": "arcane_circle",
		"tooltip": "Arcane Circle"
	},
	"arcane_fatigue": {
		"file": "arcane_fatigue",
		"tooltip": "Arcane Fatigue"
	},
	"arcane_fatigue_1": {
		"file": "arcane_fatigue_1",
		"tooltip": "Arcane Fatigue 1"
	},
	"arcane_fatigue_10": {
		"file": "arcane_fatigue_10",
		"tooltip": "Arcane Fatigue 10"
	},
	"arcane_fatigue_2": {
		"file": "arcane_fatigue_2",
		"tooltip": "Arcane Fatigue 2"
	},
	"arcane_fatigue_3": {
		"file": "arcane_fatigue_3",
		"tooltip": "Arcane Fatigue 3"
	},
	"arcane_fatigue_4": {
		"file": "arcane_fatigue_4",
		"tooltip": "Arcane Fatigue 4"
	},
	"arcane_fatigue_5": {
		"file": "arcane_fatigue_5",
		"tooltip": "Arcane Fatigue 5"
	},
	"arcane_fatigue_6": {
		"file": "arcane_fatigue_6",
		"tooltip": "Arcane Fatigue 6"
	},
	"arcane_fatigue_7": {
		"file": "arcane_fatigue_7",
		"tooltip": "Arcane Fatigue 7"
	},
	"arcane_fatigue_8": {
		"file": "arcane_fatigue_8",
		"tooltip": "Arcane Fatigue 8"
	},
	"arcane_fatigue_9": {
		"file": "arcane_fatigue_9",
		"tooltip": "Arcane Fatigue 9"
	},
	"archery_weapon_skill": {
		"file": "archery_weapon_skill",
		"tooltip": "Archery Weapon Skill"
	},
	"archipelago": {
		"file": "archipelago",
		"tooltip": "Archipelago"
	},
	"architecture": {
		"file": "architecture",
		"tooltip": "Architecture"
	},
	"archive": {
		"file": "archive",
		"tooltip": "Archive"
	},
	"arcology": {
		"file": "arcology",
		"tooltip": "Arcology"
	},
	"arctic": {
		"file": "arctic",
		"tooltip": "Arctic"
	},
	"arena": {
		"file": "arena",
		"tooltip": "Arena"
	},
	"armor": {
		"file": "armor",
		"tooltip": "Armor"
	},
	"armor_bending_roll": {
		"file": "armor_bending_roll",
		"tooltip": "Armor Bending Roll"
	},
	"armor_encumbered": {
		"file": "armor_encumbered",
		"tooltip": "Armor Encumbered"
	},
	"armor_size_colossal": {
		"file": "armor",
		"tooltip": "Armor Size: Colossal"
	},
	"armor_size_gargantuan": {
		"file": "armor",
		"tooltip": "Armor Size: Gargantuan"
	},
	"armor_size_huge": {
		"file": "armor",
		"tooltip": "Armor Size: Huge"
	},
	"armor_size_large": {
		"file": "armor",
		"tooltip": "Armor Size: Large"
	},
	"armor_size_tiny": {
		"file": "armor",
		"tooltip": "Armor Size: Tiny"
	},
	"armor_size_titanic": {
		"file": "armor",
		"tooltip": "Armor Size: Titantic"
	},
	"arrow": {
		"file": "arrow",
		"tooltip": "Arrows"
	},
	"arsenal": {
		"file": "arsenal",
		"tooltip": "Arsenal"
	},
	"art": {
		"file": "art",
		"tooltip": "Art"
	},
	"art_gallery": {
		"file": "art_gallery",
		"tooltip": "Art Gallery"
	},
	"artillery_role": {
		"file": "artillery_role",
		"tooltip": "Artillery Role"
	},
	"ashfall": {
		"file": "ashfall",
		"tooltip": "Ashfall"
	},
	"asteroid": {
		"file": "asteroid",
		"tooltip": "Asteroid"
	},
	"asteroid_belt": {
		"file": "asteroid_belt",
		"tooltip": "Asteroid Belt"
	},
	"astronomy": {
		"file": "astronomy",
		"tooltip": "Astronomy"
	},
	"asylum": {
		"file": "asylum",
		"tooltip": "Asylum"
	},
	"atoll_underwater": {
		"file": "atoll_underwater",
		"tooltip": "Atoll Underwater"
	},
	"attention": {
		"file": "attention",
		"tooltip": "Attention"
	},
	"auran": {
		"file": "auran",
		"tooltip": "Auran"
	},
	"autumn": {
		"file": "autumn",
		"tooltip": "Autumn"
	},
	"aviary": {
		"file": "aviary",
		"tooltip": "Aviary"
	},
	"awake": {
		"file": "awake",
		"tooltip": "Awake"
	},
	"back": {
		"file": "back",
		"tooltip": "Back"
	},
	"backlash": {
		"file": "backlash",
		"tooltip": "Backlash"
	},
	"bad_newses": {
		"file": "bad_newses",
		"tooltip": "Bad News"
	},
	"badlands": {
		"file": "badlands",
		"tooltip": "Badlands"
	},
	"bakery": {
		"file": "bakery",
		"tooltip": "Bakery"
	},
	"balance": {
		"file": "balance",
		"tooltip": "Balance"
	},
	"banished": {
		"file": "banished",
		"tooltip": "Banished"
	},
	"bank_treasury": {
		"file": "bank_treasury",
		"tooltip": "Bank Treasury"
	},
	"barber_dentist_surgery": {
		"file": "barber_dentist_surgery",
		"tooltip": "Barber Dentist Surgery"
	},
	"barely_wounded": {
		"file": "barely_wounded",
		"tooltip": "Barely Wounded"
	},
	"barracks": {
		"file": "barracks",
		"tooltip": "Barracks"
	},
	"bathhouse": {
		"file": "bathhouse",
		"tooltip": "Bathhouse"
	},
	"battleaxes": {
		"file": "battleaxes",
		"tooltip": "Battleaxes"
	},
	"bay": {
		"file": "bay",
		"tooltip": "Bay"
	},
	"beast": {
		"file": "beast",
		"tooltip": "Beast"
	},
	"beijxing_stance": {
		"file": "beijxing_stance",
		"tooltip": "Beijxing Stance"
	},
	"bending_weapon_skill": {
		"file": "bending_weapon_skill",
		"tooltip": "Bending Weapon Skill"
	},
	"biology": {
		"file": "biology",
		"tooltip": "Biology"
	},
	"black_hole": {
		"file": "black_hole",
		"tooltip": "Black Hole"
	},
	"blade_of_the_chronoknight": {
		"file": "blade_of_the_chronoknight",
		"tooltip": "Blade Of The Chronoknight"
	},
	"blade_of_the_eidolon": {
		"file": "blade_of_the_eidolon",
		"tooltip": "Blade Of The Eidolon"
	},
	"blade_of_the_grimoire": {
		"file": "blade_of_the_grimoire",
		"tooltip": "Blade Of The Grimoire"
	},
	"blade_of_the_shade": {
		"file": "blade_of_the_shade",
		"tooltip": "Blade Of The Shade"
	},
	"blade_of_the_spellbreaker": {
		"file": "blade_of_the_spellbreaker",
		"tooltip": "Blade Of The Spellbreaker"
	},
	"blade_of_the_valkyrie": {
		"file": "blade_of_the_valkyrie",
		"tooltip": "Blade Of The Valkyrie"
	},
	"blade_of_the_vanishing_edge": {
		"file": "blade_of_the_vanishing_edge",
		"tooltip": "Blade Of The Vanishing Edge"
	},
	"blade_of_the_witcher": {
		"file": "blade_of_the_witcher",
		"tooltip": "Blade Of The Witcher"
	},
	"bladed_fans": {
		"file": "bladed_fans",
		"tooltip": "Bladed Fans"
	},
	"bladed_umbrellas": {
		"file": "bladed_umbrellas",
		"tooltip": "Bladed Umbrellas"
	},
	"bleeding": {
		"file": "bleeding",
		"tooltip": "Bleeding"
	},
	"blighted": {
		"file": "blighted",
		"tooltip": "Blighted"
	},
	"blighted_1": {
		"file": "blighted_1",
		"tooltip": "Blighted 1"
	},
	"blighted_10": {
		"file": "blighted_10",
		"tooltip": "Blighted 10"
	},
	"blighted_2": {
		"file": "blighted_2",
		"tooltip": "Blighted 2"
	},
	"blighted_3": {
		"file": "blighted_3",
		"tooltip": "Blighted 3"
	},
	"blighted_4": {
		"file": "blighted_4",
		"tooltip": "Blighted 4"
	},
	"blighted_5": {
		"file": "blighted_5",
		"tooltip": "Blighted 5"
	},
	"blighted_6": {
		"file": "blighted_6",
		"tooltip": "Blighted 6"
	},
	"blighted_7": {
		"file": "blighted_7",
		"tooltip": "Blighted 7"
	},
	"blighted_8": {
		"file": "blighted_8",
		"tooltip": "Blighted 8"
	},
	"blighted_9": {
		"file": "blighted_9",
		"tooltip": "Blighted 9"
	},
	"blinded": {
		"file": "blinded",
		"tooltip": "Blinded"
	},
	"blindsight": {
		"file": "blindsight",
		"tooltip": "Blindsight"
	},
	"blood_of_the_angel": {
		"file": "blood_of_the_angel",
		"tooltip": "Blood Of The Angel"
	},
	"blood_of_the_artifical_soul": {
		"file": "blood_of_the_artifical_soul",
		"tooltip": "Blood Of The Artifical Soul"
	},
	"blood_of_the_conduit": {
		"file": "blood_of_the_conduit",
		"tooltip": "Blood Of The Conduit"
	},
	"blood_of_the_dragon": {
		"file": "blood_of_the_dragon",
		"tooltip": "Blood Of The Dragon"
	},
	"blood_of_the_fey": {
		"file": "blood_of_the_fey",
		"tooltip": "Blood Of The Fey"
	},
	"blood_of_the_glacier": {
		"file": "blood_of_the_glacier",
		"tooltip": "Blood Of The Glacier"
	},
	"blood_of_the_hemophage": {
		"file": "blood_of_the_hemophage",
		"tooltip": "Blood Of The Hemophage"
	},
	"blood_of_the_oracle": {
		"file": "blood_of_the_oracle",
		"tooltip": "Blood Of The Oracle"
	},
	"blood_of_the_pyre": {
		"file": "blood_of_the_pyre",
		"tooltip": "Blood Of The Pyre"
	},
	"blood_of_the_shadow": {
		"file": "blood_of_the_shadow",
		"tooltip": "Blood Of The Shadow"
	},
	"blood_of_the_stars": {
		"file": "blood_of_the_stars",
		"tooltip": "Blood Of The Stars"
	},
	"blood_of_the_storm": {
		"file": "blood_of_the_storm",
		"tooltip": "Blood Of The Storm"
	},
	"blood_of_the_wildsoul": {
		"file": "blood_of_the_wildsoul",
		"tooltip": "Blood Of The Wildsoul"
	},
	"bloodied": {
		"file": "bloodied",
		"tooltip": "Bloodied"
	},
	"blooming_fang_stance": {
		"file": "blooming_fang_stance",
		"tooltip": "Blooming Fang Stance"
	},
	"blowgun_needle": {
		"file": "blowgun_needle",
		"tooltip": "Blowgun Needles"
	},
	"blowguns": {
		"file": "blowguns",
		"tooltip": "Blowguns"
	},
	"bludgeoning": {
		"file": "bludgeoning",
		"tooltip": "Bludgeoning"
	},
	"blunderbusses": {
		"file": "blunderbusses",
		"tooltip": "Blunderbusses"
	},
	"boathouse_wharf": {
		"file": "boathouse_wharf",
		"tooltip": "Boathouse Wharf"
	},
	"bodden": {
		"file": "bodden",
		"tooltip": "Bodden"
	},
	"body": {
		"file": "body",
		"tooltip": "Body"
	},
	"bolstered": {
		"file": "bolstered",
		"tooltip": "Bolstered"
	},
	"bookstore": {
		"file": "bookstore",
		"tooltip": "Bookstore"
	},
	"both_hands": {
		"file": "both_hands",
		"tooltip": "Both Hands"
	},
	"bracers": {
		"file": "bracers",
		"tooltip": "Bracers"
	},
	"breast": {
		"file": "breast",
		"tooltip": "Breast"
	},
	"brewery_winery": {
		"file": "brewery_winery",
		"tooltip": "Brewery Winery"
	},
	"brigandine_armors": {
		"file": "brigandine_armors",
		"tooltip": "Brigandine Armors"
	},
	"bright_light": {
		"file": "bright_light",
		"tooltip": "Bright Light"
	},
	"brothel_whorehouse": {
		"file": "brothel_whorehouse",
		"tooltip": "Brothel Whorehouse"
	},
	"brush": {
		"file": "brush",
		"tooltip": "Brush"
	},
	"brute_role": {
		"file": "brute_role",
		"tooltip": "Brute Role"
	},
	"buck_riders": {
		"file": "buck_creature",
		"tooltip": "Buck Riders"
	},
	"bucklers": {
		"file": "bucklers",
		"tooltip": "Bucklers"
	},
	"bulwarks": {
		"file": "bulwarks",
		"tooltip": "Bulwarks"
	},
	"bunker": {
		"file": "bunker",
		"tooltip": "Bunker"
	},
	"burning": {
		"file": "burning",
		"tooltip": "Burning"
	},
	"butchery": {
		"file": "butchery",
		"tooltip": "Butchery"
	},
	"cabin_lodge": {
		"file": "cabin_lodge",
		"tooltip": "Cabin Lodge"
	},
	"cafe_tearoom": {
		"file": "cafe_tearoom",
		"tooltip": "Cafe Tearoom"
	},
	"campaign_difficulty_easy": {
		"file": "campaign_difficulty_easy",
		"tooltip": "Campaign Difficulty Easy"
	},
	"campaign_difficulty_hardcore": {
		"file": "campaign_difficulty_hardcore",
		"tooltip": "Campaign Difficulty Hardcore"
	},
	"campaign_difficulty_normal": {
		"file": "campaign_difficulty_normal",
		"tooltip": "Campaign Difficulty Normal"
	},
	"canyon": {
		"file": "canyon",
		"tooltip": "Canyon"
	},
	"capital": {
		"file": "capital",
		"tooltip": "Capital"
	},
	"caravan": {
		"file": "caravan",
		"tooltip": "Caravan"
	},
	"caravanserai": {
		"file": "caravanserai",
		"tooltip": "Caravanserai"
	},
	"casino": {
		"file": "casino",
		"tooltip": "Casino"
	},
	"casting": {
		"file": "casting",
		"tooltip": "Casting"
	},
	"casting_ritual_spell": {
		"file": "casting_ritual_spell",
		"tooltip": "Casting Ritual Spell"
	},
	"castle": {
		"file": "castle",
		"tooltip": "Castle"
	},
	"catacomb": {
		"file": "catacomb",
		"tooltip": "Catacomb"
	},
	"cathedral_great_temple": {
		"file": "cathedral_great_temple",
		"tooltip": "Cathedral Great Temple"
	},
	"cavalry_shields": {
		"file": "cavalry_shields",
		"tooltip": "Cavalry Shields"
	},
	"cave": {
		"file": "cave",
		"tooltip": "Cave"
	},
	"cave_system": {
		"file": "cave_system",
		"tooltip": "Cave System"
	},
	"celestial": {
		"file": "celestial",
		"tooltip": "Celestial"
	},
	"cemetery": {
		"file": "cemetery",
		"tooltip": "Cemetery"
	},
	"challenge_roll_assistance_roll": {
		"file": "challenge_roll_assistance_roll",
		"tooltip": "Challenge Roll Assistance Roll"
	},
	"challenged": {
		"file": "challenged",
		"tooltip": "Challenged"
	},
	"chapel": {
		"file": "chapel",
		"tooltip": "Chapel"
	},
	"charmed": {
		"file": "charmed",
		"tooltip": "Charmed"
	},
	"chasm_underwater": {
		"file": "chasm_underwater",
		"tooltip": "Chasm Underwater"
	},
	"chilled": {
		"file": "chilled",
		"tooltip": "Chilled"
	},
	"circle": {
		"file": "circle",
		"tooltip": "Circle"
	},
	"circle_locked_abjuration": {
		"file": "circle_locked_abjuration",
		"tooltip": "Abjuration Locked"
	},
	"circle_locked_charm": {
		"file": "circle_locked_charm",
		"tooltip": "Charm Locked"
	},
	"circle_locked_conjuration": {
		"file": "circle_locked_conjuration",
		"tooltip": "Conjuration Locked"
	},
	"circle_locked_divination": {
		"file": "circle_locked_divination",
		"tooltip": "Divination Locked"
	},
	"circle_locked_evocation": {
		"file": "circle_locked_evocation",
		"tooltip": "Evocation Locked"
	},
	"circle_locked_illusion": {
		"file": "circle_locked_illusion",
		"tooltip": "Illusion Locked"
	},
	"circle_locked_necromancy": {
		"file": "circle_locked_necromancy",
		"tooltip": "Necromancy Locked"
	},
	"circle_locked_transmutation": {
		"file": "circle_locked_transmutation",
		"tooltip": "Transmutation Locked"
	},
	"circle_of_abjuration": {
		"file": "circle_of_abjuration",
		"tooltip": "Circle of Abjuration"
	},
	"circle_of_charm": {
		"file": "circle_of_charm",
		"tooltip": "Circle of Charm"
	},
	"circle_of_conjuration": {
		"file": "circle_of_conjuration",
		"tooltip": "Circle of Conjuration"
	},
	"circle_of_divination": {
		"file": "circle_of_divination",
		"tooltip": "Circle of Divination"
	},
	"circle_of_evocation": {
		"file": "circle_of_evocation",
		"tooltip": "Circle of Evocation"
	},
	"circle_of_illusion": {
		"file": "circle_of_illusion",
		"tooltip": "Circle of Illusion"
	},
	"circle_of_necromancy": {
		"file": "circle_of_necromancy",
		"tooltip": "Circle of Necromancy"
	},
	"circle_of_transmutation": {
		"file": "circle_of_transmutation",
		"tooltip": "Circle of Transmutation"
	},
	"citadel": {
		"file": "citadel",
		"tooltip": "Citadel"
	},
	"civics": {
		"file": "civics",
		"tooltip": "Civics"
	},
	"class": {
		"file": "class",
		"tooltip": "Class"
	},
	"cliff": {
		"file": "cliff",
		"tooltip": "Cliff"
	},
	"clinic": {
		"file": "clinic",
		"tooltip": "Clinic"
	},
	"cloak": {
		"file": "cloak",
		"tooltip": "Cloak"
	},
	"clothing": {
		"file": "clothing",
		"tooltip": "Clothing"
	},
	"cloudy": {
		"file": "cloudy",
		"tooltip": "Cloudy"
	},
	"cloudy_lightning": {
		"file": "cloudy_lightning",
		"tooltip": "Thunderstorm"
	},
	"clubs": {
		"file": "clubs",
		"tooltip": "Clubs"
	},
	"coast": {
		"file": "coast",
		"tooltip": "Coast"
	},
	"coast_shore": {
		"file": "coast_shore",
		"tooltip": "Coast Shore"
	},
	"cold": {
		"file": "cold",
		"tooltip": "Cold"
	},
	"college_academy": {
		"file": "college_academy",
		"tooltip": "College Academy"
	},
	"colossal": {
		"file": "colossal",
		"tooltip": "Colossal"
	},
	"colossal_melee_weapons": {
		"file": "colossal_melee_weapons",
		"tooltip": "Colossal Melee Weapons"
	},
	"colossal_ranged_weapons": {
		"file": "colossal_ranged_weapons",
		"tooltip": "Colossal Ranged Weapons"
	},
	"common": {
		"file": "common",
		"tooltip": "Common"
	},
	"concentrating": {
		"file": "concentrating",
		"tooltip": "Concentrating"
	},
	"conclave_of_the_abberation": {
		"file": "conclave_of_the_abberation",
		"tooltip": "Conclave Of The Abberation"
	},
	"conclave_of_the_bounty_hunter": {
		"file": "conclave_of_the_bounty_hunter",
		"tooltip": "Conclave Of The Bounty Hunter"
	},
	"conclave_of_the_construct": {
		"file": "conclave_of_the_construct",
		"tooltip": "Conclave Of The Construct"
	},
	"conclave_of_the_demon_slayer": {
		"file": "conclave_of_the_demon_slayer",
		"tooltip": "Conclave Of The Demon Slayer"
	},
	"conclave_of_the_dragon": {
		"file": "conclave_of_the_dragon",
		"tooltip": "Conclave Of The Dragon"
	},
	"conclave_of_the_marksman": {
		"file": "conclave_of_the_marksman",
		"tooltip": "Conclave Of The Marksman"
	},
	"conclave_of_the_monstrosity": {
		"file": "conclave_of_the_monstrosity",
		"tooltip": "Conclave Of The Monstrosity"
	},
	"conclave_of_the_ooze": {
		"file": "conclave_of_the_ooze",
		"tooltip": "Conclave Of The Ooze"
	},
	"cone": {
		"file": "cone",
		"tooltip": "Cone"
	},
	"confused": {
		"file": "confused",
		"tooltip": "Confused"
	},
	"consecrated": {
		"file": "consecrated",
		"tooltip": "Consecrated"
	},
	"construct": {
		"file": "construct",
		"tooltip": "Construct"
	},
	"consulate": {
		"file": "consulate",
		"tooltip": "Consulate"
	},
	"contact_poison": {
		"file": "contact_poison",
		"tooltip": "Contact Poison"
	},
	"contesting_roll": {
		"file": "contesting_roll",
		"tooltip": "Contesting Roll"
	},
	"continent": {
		"file": "continent",
		"tooltip": "Continent"
	},
	"controller_role": {
		"file": "controller_role",
		"tooltip": "Controller Role"
	},
	"conurbation": {
		"file": "conurbation",
		"tooltip": "Conurbation"
	},
	"cooking": {
		"file": "cooking",
		"tooltip": "Cooking"
	},
	"copse": {
		"file": "copse",
		"tooltip": "Copse"
	},
	"coral_reef_atoll": {
		"file": "coral_reef_atoll",
		"tooltip": "Coral Reef Atoll"
	},
	"coral_reef_barrier": {
		"file": "coral_reef_barrier",
		"tooltip": "Coral Reef Barrier"
	},
	"coral_reef_fringing": {
		"file": "coral_reef_fringing",
		"tooltip": "Coral Reef Fringing"
	},
	"coral_reef_platform": {
		"file": "coral_reef_platform",
		"tooltip": "Coral Reef Platform"
	},
	"core_of_the_dissolver": {
		"file": "core_of_the_dissolver",
		"tooltip": "Core Of The Dissolver"
	},
	"core_of_the_graviturge": {
		"file": "core_of_the_graviturge",
		"tooltip": "Core Of The Graviturge"
	},
	"core_of_the_necroforge": {
		"file": "core_of_the_necroforge",
		"tooltip": "Core Of The Necroforge"
	},
	"core_of_the_pyromechanist": {
		"file": "core_of_the_pyromechanist",
		"tooltip": "Core Of The Pyromechanist"
	},
	"core_of_the_quaking_bell": {
		"file": "core_of_the_quaking_bell",
		"tooltip": "Core Of The Quaking Bell"
	},
	"core_of_the_rimeguard": {
		"file": "core_of_the_rimeguard",
		"tooltip": "Core Of The Rimeguard"
	},
	"core_of_the_venomworks": {
		"file": "core_of_the_venomworks",
		"tooltip": "Core Of The Venomworks"
	},
	"core_of_the_voltaic": {
		"file": "core_of_the_voltaic",
		"tooltip": "Core Of The Voltaic"
	},
	"corroding": {
		"file": "corroding",
		"tooltip": "Corroding"
	},
	"cottage": {
		"file": "cottage",
		"tooltip": "Cottage"
	},
	"courtesan_stance": {
		"file": "courtesan_stance",
		"tooltip": "Courtesan Stance"
	},
	"courthouse": {
		"file": "courthouse",
		"tooltip": "Courthouse"
	},
	"cove": {
		"file": "cove",
		"tooltip": "Cove"
	},
	"cracked_planet": {
		"file": "cracked_planet",
		"tooltip": "Cracked Planet"
	},
	"crafting": {
		"file": "crafting",
		"tooltip": "Crafting"
	},
	"crafting_progress": {
		"file": "crafting_progress",
		"tooltip": "Crafting Progress"
	},
	"crafting_roll": {
		"file": "crafting_roll",
		"tooltip": "Crafting Roll"
	},
	"craftsman_blacksmith_smithy": {
		"file": "craftsman_blacksmith_smithy",
		"tooltip": "Craftsman Blacksmith Smithy"
	},
	"craftsman_leatherworker": {
		"file": "craftsman_leatherworker",
		"tooltip": "Craftsman Leatherworker"
	},
	"craftsman_tanner": {
		"file": "craftsman_tanner",
		"tooltip": "Craftsman Tanner"
	},
	"crater": {
		"file": "crater",
		"tooltip": "Crater"
	},
	"crippled": {
		"file": "crippled",
		"tooltip": "Crippled"
	},
	"crossbow_bolt": {
		"file": "crossbow_bolt",
		"tooltip": "Crossbow Bolts"
	},
	"crossbows_hand": {
		"file": "crossbows_hand",
		"tooltip": "Hand Crossbows"
	},
	"crossbows_heavy": {
		"file": "crossbows_heavy",
		"tooltip": "Heavy Crossbows"
	},
	"crossbows_light": {
		"file": "crossbows_light",
		"tooltip": "Light Crossbows"
	},
	"crypt": {
		"file": "crypt",
		"tooltip": "Crypt"
	},
	"cube": {
		"file": "cube",
		"tooltip": "Cube"
	},
	"cuirass_armors": {
		"file": "cuirass_armors",
		"tooltip": "Cuirass Armors"
	},
	"cunning": {
		"file": "cunning",
		"tooltip": "Cunning"
	},
	"custom_ability": {
		"file": "custom_ability",
		"tooltip": "Custom Ability"
	},
	"custom_free_ability": {
		"file": "custom_free_ability",
		"tooltip": "Custom Free Ability"
	},
	"custom_full_ability": {
		"file": "custom_full_ability",
		"tooltip": "Custom Full Ability"
	},
	"custom_quick_ability": {
		"file": "custom_quick_ability",
		"tooltip": "Custom Quick Ability"
	},
	"custom_reaction_ability": {
		"file": "custom_reaction_ability",
		"tooltip": "Custom Reaction Ability"
	},
	"customs_house": {
		"file": "customs_house",
		"tooltip": "Customs House"
	},
	"cylinder": {
		"file": "cylinder",
		"tooltip": "Cylinder"
	},
	"cymbals": {
		"file": "cymbals",
		"tooltip": "Cymbals"
	},
	"daggers": {
		"file": "daggers",
		"tooltip": "Daggers"
	},
	"dam": {
		"file": "dam",
		"tooltip": "Dam"
	},
	"damage_over_time_roll": {
		"file": "damage_over_time_roll",
		"tooltip": "Damage Over Time Roll"
	},
	"damage_roll": {
		"file": "damage_roll",
		"tooltip": "Damage Roll"
	},
	"dance_club": {
		"file": "dance_club",
		"tooltip": "Dance Club"
	},
	"darts": {
		"file": "darts",
		"tooltip": "Darts"
	},
	"datacenter": {
		"file": "datacenter",
		"tooltip": "Datacenter"
	},
	"dazed": {
		"file": "dazed",
		"tooltip": "Dazed"
	},
	"dc_roll": {
		"file": "dc_roll",
		"tooltip": "DC Roll"
	},
	"dead": {
		"file": "dead",
		"tooltip": "Dead"
	},
	"dead_eye": {
		"file": "weapon_ranged_attack_roll",
		"tooltip": "Dead Eye"
	},
	"deafened": {
		"file": "deafened",
		"tooltip": "Deafened"
	},
	"defenseless": {
		"file": "defenseless",
		"tooltip": "Defenseless"
	},
	"desert": {
		"file": "desert",
		"tooltip": "Desert"
	},
	"desert_ice": {
		"file": "desert_ice",
		"tooltip": "Desert Ice"
	},
	"desert_location": {
		"file": "desert_location",
		"tooltip": "Desert Location"
	},
	"desiccating": {
		"file": "desiccating",
		"tooltip": "Desiccating"
	},
	"dim_light": {
		"file": "dim_light",
		"tooltip": "Dim Light"
	},
	"dimensional_plane": {
		"file": "dimensional_plane",
		"tooltip": "Dimensional Plane"
	},
	"dimensional_pocket": {
		"file": "dimensional_pocket",
		"tooltip": "Dimensional Pocket"
	},
	"dimmed": {
		"file": "dimmed",
		"tooltip": "Dimmed"
	},
	"dis": {
		"file": "dis",
		"tooltip": "Disadvantage"
	},
	"diseased": {
		"file": "diseased",
		"tooltip": "Diseased"
	},
	"disenchanting": {
		"file": "disenchanting",
		"tooltip": "Disenchanting"
	},
	"disengage": {
		"file": "disengage",
		"tooltip": "Disengage"
	},
	"disguised": {
		"file": "disguised",
		"tooltip": "Disguised"
	},
	"dissolving": {
		"file": "dissolving",
		"tooltip": "Dissolving"
	},
	"district": {
		"file": "district",
		"tooltip": "District"
	},
	"divine": {
		"file": "divine",
		"tooltip": "Divine Sphere of Magic"
	},
	"dizzy": {
		"file": "dizzy",
		"tooltip": "Dizzy"
	},
	"doffing": {
		"file": "doffing",
		"tooltip": "Doffing"
	},
	"dojo": {
		"file": "dojo",
		"tooltip": "Dojo"
	},
	"dominated": {
		"file": "dominated",
		"tooltip": "Dominated"
	},
	"domir": {
		"file": "domir",
		"tooltip": "Domir"
	},
	"donning": {
		"file": "donning",
		"tooltip": "Donning"
	},
	"double_bladed_scimitars": {
		"file": "double_bladed_scimitars",
		"tooltip": "Double Bladed Scimitars"
	},
	"double_concentration": {
		"file": "concentration",
		"tooltip": "Double Concentration"
	},
	"draconic": {
		"file": "draconic",
		"tooltip": "Draconic"
	},
	"dragon": {
		"file": "dragon",
		"tooltip": "Dragon"
	},
	"dragon_stance": {
		"file": "dragon_stance",
		"tooltip": "Dragon Stance"
	},
	"drowning": {
		"file": "drowning",
		"tooltip": "Drowning"
	},
	"drug_den": {
		"file": "drug_den",
		"tooltip": "Drug Den"
	},
	"druidic": {
		"file": "druidic",
		"tooltip": "Druidic"
	},
	"drums": {
		"file": "drums",
		"tooltip": "Drums"
	},
	"drunk": {
		"file": "drunk",
		"tooltip": "Drunk"
	},
	"drunken_stance": {
		"file": "drunken_stance",
		"tooltip": "Drunken Stance"
	},
	"dungeon": {
		"file": "dungeon",
		"tooltip": "Dungeon"
	},
	"dust_storm": {
		"file": "dust_storm",
		"tooltip": "Dust Storm"
	},
	"dwarvish": {
		"file": "dwarvish",
		"tooltip": "Dwarvish"
	},
	"dying": {
		"file": "dying",
		"tooltip": "Dying"
	},
	"dying_state": {
		"file": "dying_state",
		"tooltip": "Dying State"
	},
	"dying_state_1": {
		"file": "dying_state_1",
		"tooltip": "Dying State 1"
	},
	"dying_state_2": {
		"file": "dying_state_2",
		"tooltip": "Dying State 2"
	},
	"dying_state_3": {
		"file": "dying_state_3",
		"tooltip": "Dying State 3"
	},
	"dying_stratum_roll": {
		"file": "dying_stratum_roll",
		"tooltip": "Dying Stratum Roll"
	},
	"ecumenopolis": {
		"file": "ecumenopolis",
		"tooltip": "Ecumenopolis"
	},
	"electrocuted": {
		"file": "electrocuted",
		"tooltip": "Electrocuted"
	},
	"elemental": {
		"file": "elemental",
		"tooltip": "Elemental"
	},
	"elvish": {
		"file": "elvish",
		"tooltip": "Elvish"
	},
	"embassy": {
		"file": "embassy",
		"tooltip": "Embassy"
	},
	"empathy": {
		"file": "empathy",
		"tooltip": "Empathy"
	},
	"empowered": {
		"file": "empowered",
		"tooltip": "Empowered"
	},
	"enchanting": {
		"file": "enchanting",
		"tooltip": "Enchanting"
	},
	"encumbered": {
		"file": "encumbered",
		"tooltip": "Encumbered"
	},
	"enemy": {
		"file": "enemy",
		"tooltip": "Enemy"
	},
	"enfeebled": {
		"file": "enfeebled",
		"tooltip": "Enfeebled"
	},
	"enochian": {
		"file": "enochian",
		"tooltip": "Enochian"
	},
	"essence_roll": {
		"file": "essence_roll",
		"tooltip": "Essence Roll"
	},
	"estate": {
		"file": "estate",
		"tooltip": "Estate"
	},
	"estuary": {
		"file": "estuary",
		"tooltip": "Estuary"
	},
	"ether": {
		"file": "ether",
		"tooltip": "Ether"
	},
	"ethereal": {
		"file": "ethereal",
		"tooltip": "Ethereal"
	},
	"excavating": {
		"file": "excavating",
		"tooltip": "Excavating"
	},
	"excavation_found": {
		"file": "excavation_found",
		"tooltip": "Excavation Found"
	},
	"excavation_roll": {
		"file": "excavation_roll",
		"tooltip": "Excavation Roll"
	},
	"exhausted": {
		"file": "exhausted",
		"tooltip": "Exhausted"
	},
	"expanse": {
		"file": "expanse",
		"tooltip": "Expanse"
	},
	"exposed": {
		"file": "exposed",
		"tooltip": "Exposed"
	},
	"extra_damage_roll": {
		"file": "extra_damage_roll",
		"tooltip": "Extra Damage Roll"
	},
	"extra_damage_roll_taken": {
		"file": "extra_damage_roll_taken",
		"tooltip": "Extra Damage Taken Roll"
	},
	"extra_healing_roll": {
		"file": "extra_healing_roll",
		"tooltip": "Extra Healing Roll"
	},
	"extra_weapon_damage_roll": {
		"file": "extra_weapon_damage_roll",
		"tooltip": "Extra Weapon Damage Roll"
	},
	"extreme_photosensitive_eye_strain": {
		"file": "extreme_photosensitive_eye_strain",
		"tooltip": "Extreme Photosensitive Eye Strain"
	},
	"factory": {
		"file": "factory",
		"tooltip": "Factory"
	},
	"faith_in_dreams": {
		"file": "faith_in_dreams",
		"tooltip": "Faith In Dreams"
	},
	"faith_in_fate": {
		"file": "faith_in_fate",
		"tooltip": "Faith In Fate"
	},
	"faith_in_fire": {
		"file": "faith_in_fire",
		"tooltip": "Faith In Fire"
	},
	"faith_in_heresy": {
		"file": "faith_in_heresy",
		"tooltip": "Faith In Heresy"
	},
	"faith_in_karma": {
		"file": "faith_in_karma",
		"tooltip": "Faith In Karma"
	},
	"faith_in_life": {
		"file": "faith_in_life",
		"tooltip": "Faith In Life"
	},
	"faith_in_light": {
		"file": "faith_in_light",
		"tooltip": "Faith In Light"
	},
	"faith_in_self_sacrifice": {
		"file": "faith_in_self_sacrifice",
		"tooltip": "Faith In Self Sacrifice"
	},
	"faith_in_the_mask": {
		"file": "faith_in_the_mask",
		"tooltip": "Faith In The Mask"
	},
	"faith_in_the_spirits": {
		"file": "faith_in_the_spirits",
		"tooltip": "Faith In The Spirits"
	},
	"faith_in_the_storm": {
		"file": "faith_in_the_storm",
		"tooltip": "Faith In The Storm"
	},
	"faith_in_time": {
		"file": "faith_in_time",
		"tooltip": "Faith In Time"
	},
	"farm": {
		"file": "farm",
		"tooltip": "Farm"
	},
	"farming": {
		"file": "farming",
		"tooltip": "Farming"
	},
	"fate_card_suit_change": {
		"file": "fate_card_suit_change",
		"tooltip": "Fate Card Suit Change"
	},
	"fate_card_suit_love": {
		"file": "fate_card_suit_love",
		"tooltip": "Fate Card Suit Love"
	},
	"fate_card_suit_prosperity": {
		"file": "fate_card_suit_prosperity",
		"tooltip": "Fate Card Suit Prosperity"
	},
	"fate_card_suit_war": {
		"file": "fate_card_suit_war",
		"tooltip": "Fate Card Suit War"
	},
	"feebleminded": {
		"file": "feebleminded",
		"tooltip": "Feebleminded"
	},
	"feet": {
		"file": "feet",
		"tooltip": "Feet"
	},
	"female": {
		"file": "female",
		"tooltip": "Female"
	},
	"fey": {
		"file": "fey",
		"tooltip": "Fey"
	},
	"field": {
		"file": "field",
		"tooltip": "Field"
	},
	"fiend": {
		"file": "fiend",
		"tooltip": "Fiend"
	},
	"fiendsight": {
		"file": "fiendsight",
		"tooltip": "Fiendsight"
	},
	"finance": {
		"file": "finance",
		"tooltip": "Finance"
	},
	"fire": {
		"file": "fire",
		"tooltip": "Fire"
	},
	"firearms": {
		"file": "firearms_weapon_skill",
		"tooltip": "Firearms"
	},
	"firearms_25_caliber_bullet": {
		"file": "firearms_25_caliber_bullet",
		"tooltip": "Firearms 25 Caliber Bullets"
	},
	"firearms_300_caliber_bullet": {
		"file": "firearms_300_caliber_bullet",
		"tooltip": "Firearms 300 Caliber Bullets"
	},
	"firearms_40_caliber_bullet": {
		"file": "firearms_40_caliber_bullet",
		"tooltip": "Firearms 40 Caliber Bullets"
	},
	"firearms_50_caliber_bullet": {
		"file": "firearms_50_caliber_bullet",
		"tooltip": "Firearms 50 Caliber Bullets"
	},
	"firearms_mortar_shell": {
		"file": "firearms_mortar_shell",
		"tooltip": "Firearms Mortar Shells"
	},
	"firearms_weapon_skill": {
		"file": "firearms_weapon_skill",
		"tooltip": "Firearms Weapon Skill"
	},
	"fishery": {
		"file": "fishery",
		"tooltip": "Fishery"
	},
	"fishing": {
		"file": "fishing",
		"tooltip": "Fishing"
	},
	"fist_weapons": {
		"file": "fist_weapons",
		"tooltip": "Fist Weapons"
	},
	"fjord": {
		"file": "fjord",
		"tooltip": "Fjord"
	},
	"flails": {
		"file": "flails",
		"tooltip": "Flails"
	},
	"flanked": {
		"file": "flanked",
		"tooltip": "Flanked"
	},
	"fleeing": {
		"file": "fleeing",
		"tooltip": "Fleeing"
	},
	"flutes": {
		"file": "flutes",
		"tooltip": "Flutes"
	},
	"flying_cavalry": {
		"file": "flying_cavalry",
		"tooltip": "Flying Cavalry"
	},
	"food_poisoning": {
		"file": "food_poisoning",
		"tooltip": "Food Poisoning"
	},
	"force": {
		"file": "force",
		"tooltip": "Force"
	},
	"forest": {
		"file": "forest",
		"tooltip": "Forest"
	},
	"forest_boreal_coniferous": {
		"file": "forest_boreal_coniferous",
		"tooltip": "Forest Boreal Coniferous"
	},
	"forest_cloud_water_subtropical": {
		"file": "forest_cloud_water_subtropical",
		"tooltip": "Forest Cloud Water Subtropical"
	},
	"forest_jungle_tropical": {
		"file": "forest_jungle_tropical",
		"tooltip": "Forest Jungle Tropical"
	},
	"forest_location": {
		"file": "forest_location",
		"tooltip": "Forest Location"
	},
	"forest_temperate_seasonal": {
		"file": "forest_temperate_seasonal",
		"tooltip": "Forest Temperate Seasonal"
	},
	"fort": {
		"file": "fort",
		"tooltip": "Fort"
	},
	"fortitude": {
		"file": "fortitude",
		"tooltip": "Fortitude"
	},
	"fortress": {
		"file": "fortress",
		"tooltip": "Fortress"
	},
	"fortune": {
		"file": "fortune",
		"tooltip": "Fortune"
	},
	"foundry": {
		"file": "foundry",
		"tooltip": "Foundry"
	},
	"freezing": {
		"file": "freezing",
		"tooltip": "Freezing"
	},
	"fresh": {
		"file": "fresh",
		"tooltip": "Fresh"
	},
	"friend": {
		"file": "friend",
		"tooltip": "Friend"
	},
	"frighten": {
		"file": "frighten",
		"tooltip": "Frighten"
	},
	"frightened": {
		"file": "frightened",
		"tooltip": "Frightened"
	},
	"frozen": {
		"file": "frozen",
		"tooltip": "Frozen"
	},
	"full_caster": {
		"file": "full_caster",
		"tooltip": "Full Caster"
	},
	"full_cover": {
		"file": "full_cover",
		"tooltip": "Full Cover"
	},
	"fully_rested": {
		"file": "fully_rested",
		"tooltip": "Fully Rested"
	},
	"fury": {
		"file": "fury",
		"tooltip": "Fury"
	},
	"galactic_nebula": {
		"file": "galactic_nebula",
		"tooltip": "Galactic Nebula"
	},
	"galactic_quadrant": {
		"file": "galactic_quadrant",
		"tooltip": "Galactic Quadrant"
	},
	"galactic_sector": {
		"file": "galactic_sector",
		"tooltip": "Galactic Sector"
	},
	"galaxy": {
		"file": "galaxy",
		"tooltip": "Galaxy"
	},
	"galaxy_cluster": {
		"file": "galaxy_cluster",
		"tooltip": "Galaxy Cluster"
	},
	"galaxy_supercluster": {
		"file": "galaxy_supercluster",
		"tooltip": "Galaxy Supercluster"
	},
	"gale": {
		"file": "gale",
		"tooltip": "Gale"
	},
	"gambeson_armors": {
		"file": "gambeson_armors",
		"tooltip": "Gambeson Armors"
	},
	"gamesmanship": {
		"file": "gamesmanship",
		"tooltip": "Gamesmanship"
	},
	"garage": {
		"file": "garage",
		"tooltip": "Garage"
	},
	"garden": {
		"file": "garden",
		"tooltip": "Garden"
	},
	"gargantuan": {
		"file": "gargantuan",
		"tooltip": "Gargantuan"
	},
	"gatehouse": {
		"file": "gatehouse",
		"tooltip": "Gatehouse"
	},
	"gathering": {
		"file": "gathering",
		"tooltip": "Gathering"
	},
	"gathering_roll": {
		"file": "gathering_roll",
		"tooltip": "Gathering Roll"
	},
	"general_store": {
		"file": "general_store",
		"tooltip": "General Store"
	},
	"geology": {
		"file": "geology",
		"tooltip": "Geology"
	},
	"ghost_train": {
		"file": "ghost_train",
		"tooltip": "Ghost Train"
	},
	"ghostsight": {
		"file": "ghostsight",
		"tooltip": "Ghostsight"
	},
	"giant": {
		"file": "giant",
		"tooltip": "Giant"
	},
	"gift": {
		"file": "gift",
		"tooltip": "Gift"
	},
	"glacier": {
		"file": "glacier",
		"tooltip": "Glacier"
	},
	"glaives": {
		"file": "glaives",
		"tooltip": "Glaives"
	},
	"glassblowing": {
		"file": "glassblowing",
		"tooltip": "Glassblowing"
	},
	"gnomish": {
		"file": "gnomish",
		"tooltip": "Gnomish"
	},
	"gorge_rift": {
		"file": "gorge_rift",
		"tooltip": "Gorge Rift"
	},
	"government_complex": {
		"file": "government_complex",
		"tooltip": "Government Complex"
	},
	"grappled": {
		"file": "grappled",
		"tooltip": "Grappled"
	},
	"grappling": {
		"file": "grappling",
		"tooltip": "Grappling"
	},
	"grassland": {
		"file": "grassland",
		"tooltip": "Grassland"
	},
	"grassland_location": {
		"file": "grassland_location",
		"tooltip": "Grassland Location"
	},
	"graveyard": {
		"file": "graveyard",
		"tooltip": "Graveyard"
	},
	"great_arrow": {
		"file": "great_arrow",
		"tooltip": "Great Arrows"
	},
	"great_hall": {
		"file": "great_hall",
		"tooltip": "Great Hall"
	},
	"greataxes": {
		"file": "greataxes",
		"tooltip": "Greataxes"
	},
	"greatclubs": {
		"file": "greatclubs",
		"tooltip": "Greatclubs"
	},
	"greater_invisible": {
		"file": "greater_invisible",
		"tooltip": "Greater Invisible"
	},
	"greater_powerful": {
		"file": "greater_powerful",
		"tooltip": "Greater Powerful"
	},
	"greater_weakened": {
		"file": "greater_weakened",
		"tooltip": "Greater Weakened"
	},
	"greatswords": {
		"file": "greatswords",
		"tooltip": "Greatswords"
	},
	"grel": {
		"file": "grel",
		"tooltip": "Grel"
	},
	"grip_training": {
		"file": "off_hand",
		"tooltip": "Grip Training"
	},
	"grove": {
		"file": "grove",
		"tooltip": "Grove"
	},
	"grove_of_the_deep": {
		"file": "grove_of_the_deep",
		"tooltip": "Grove Of The Deep"
	},
	"grove_of_the_desert": {
		"file": "grove_of_the_desert",
		"tooltip": "Grove Of The Desert"
	},
	"grove_of_the_forest": {
		"file": "grove_of_the_forest",
		"tooltip": "Grove Of The Forest"
	},
	"grove_of_the_heavens": {
		"file": "grove_of_the_heavens",
		"tooltip": "Grove Of The Heavens"
	},
	"grove_of_the_infestation": {
		"file": "grove_of_the_infestation",
		"tooltip": "Grove Of The Infestation"
	},
	"grove_of_the_mountain": {
		"file": "grove_of_the_mountain",
		"tooltip": "Grove Of The Mountain"
	},
	"grove_of_the_skinwalker": {
		"file": "grove_of_the_skinwalker",
		"tooltip": "Grove Of The Skinwalker"
	},
	"grove_of_the_swamp": {
		"file": "grove_of_the_swamp",
		"tooltip": "Grove Of The Swamp"
	},
	"grove_of_the_void": {
		"file": "grove_of_the_void",
		"tooltip": "Grove Of The Void"
	},
	"grove_of_the_waterway": {
		"file": "grove_of_the_waterway",
		"tooltip": "Grove Of The Waterway"
	},
	"guildhall": {
		"file": "guildhall",
		"tooltip": "Guildhall"
	},
	"gulf_lagoon": {
		"file": "gulf_lagoon",
		"tooltip": "Gulf Lagoon"
	},
	"gunlances": {
		"file": "gunlances",
		"tooltip": "Gunlances"
	},
	"gym": {
		"file": "gym",
		"tooltip": "Gym"
	},
	"hail": {
		"file": "hail",
		"tooltip": "Hail"
	},
	"halberds": {
		"file": "halberds",
		"tooltip": "Halberds"
	},
	"half_caster": {
		"file": "half_caster",
		"tooltip": "Half Caster"
	},
	"half_plate_armors": {
		"file": "half_plate_armors",
		"tooltip": "Half Plate Armors"
	},
	"hamlet": {
		"file": "hamlet",
		"tooltip": "Hamlet"
	},
	"hammers_light": {
		"file": "hammers_light",
		"tooltip": "Light Hammers"
	},
	"hamstrung": {
		"file": "hamstrung",
		"tooltip": "Hamstrung"
	},
	"hand_mortars": {
		"file": "hand_mortars",
		"tooltip": "Hand Mortars"
	},
	"handaxes": {
		"file": "handaxes",
		"tooltip": "Handaxes"
	},
	"hangar": {
		"file": "hangar",
		"tooltip": "Hangar"
	},
	"harbinger_of_blood": {
		"file": "harbinger_of_blood",
		"tooltip": "Harbinger of Blood"
	},
	"harbinger_of_corrosion": {
		"file": "harbinger_of_corrosion",
		"tooltip": "Harbinger of Corrosion"
	},
	"harbinger_of_permafrost": {
		"file": "harbinger_of_permafrost",
		"tooltip": "Harbinger of Permafrost"
	},
	"harbinger_of_rot": {
		"file": "harbinger_of_rot",
		"tooltip": "Harbinger of Rot"
	},
	"harbinger_of_the_artifact": {
		"file": "harbinger_of_the_artifact",
		"tooltip": "Harbinger of the Artifact"
	},
	"harbinger_of_the_soulforge": {
		"file": "harbinger_of_the_soulforge",
		"tooltip": "Harbinger of the Soulforge"
	},
	"harbinger_of_the_spellbane": {
		"file": "harbinger_of_the_spellbane",
		"tooltip": "Harbinger of the Spellbane"
	},
	"harbinger_of_undeath": {
		"file": "harbinger_of_undeath",
		"tooltip": "Harbinger of Undeath"
	},
	"harmony": {
		"file": "harmony",
		"tooltip": "Harmony"
	},
	"harps": {
		"file": "harps",
		"tooltip": "Harps"
	},
	"hasted": {
		"file": "hasted",
		"tooltip": "Hasted"
	},
	"hauberk_armors": {
		"file": "hauberk_armors",
		"tooltip": "Hauberk Armors"
	},
	"hazy": {
		"file": "hazy",
		"tooltip": "Hazy"
	},
	"head": {
		"file": "head",
		"tooltip": "Head"
	},
	"headland": {
		"file": "headland",
		"tooltip": "Headland"
	},
	"healing_roll": {
		"file": "healing_roll",
		"tooltip": "Healing Roll"
	},
	"heavily_encumbered": {
		"file": "heavily_encumbered",
		"tooltip": "Heavily Encumbered"
	},
	"heavy_armor_skill": {
		"file": "heavy_armor_skill",
		"tooltip": "Heavy Armor Skill"
	},
	"heavy_cavalry": {
		"file": "heavy_cavalry",
		"tooltip": "Heavy Cavalry"
	},
	"heavy_rain": {
		"file": "heavy_rain",
		"tooltip": "Heavy Rain"
	},
	"heavy_shields": {
		"file": "heavy_shields",
		"tooltip": "Heavy Shields"
	},
	"heavy_snow": {
		"file": "heavy_snow",
		"tooltip": "Heavy Snow"
	},
	"help": {
		"file": "help",
		"tooltip": "Help"
	},
	"henge": {
		"file": "henge",
		"tooltip": "Henge"
	},
	"herbalism": {
		"file": "herbalism",
		"tooltip": "Herbalism"
	},
	"hidden": {
		"file": "hidden",
		"tooltip": "Hidden"
	},
	"hideout": {
		"file": "hideout",
		"tooltip": "Hideout"
	},
	"highlands": {
		"file": "highlands",
		"tooltip": "Highlands"
	},
	"hill": {
		"file": "hill",
		"tooltip": "Hill"
	},
	"hill_location": {
		"file": "hill_location",
		"tooltip": "Hill Location"
	},
	"hindered": {
		"file": "hindered",
		"tooltip": "Hindered"
	},
	"history": {
		"file": "history",
		"tooltip": "History"
	},
	"holding_mastery": {
		"file": "holding_mastery",
		"tooltip": "Holding Mastery"
	},
	"holy_turned": {
		"file": "holy_turned",
		"tooltip": "Holy Turned"
	},
	"horns": {
		"file": "horns",
		"tooltip": "Horns"
	},
	"hospital": {
		"file": "hospital",
		"tooltip": "Hospital"
	},
	"hospitality_camping": {
		"file": "hospitality_camping",
		"tooltip": "Hospitality Camping"
	},
	"hospitality_hotel": {
		"file": "hospitality_hotel",
		"tooltip": "Hospitality Hotel"
	},
	"hospitality_motel": {
		"file": "hospitality_motel",
		"tooltip": "Hospitality Motel"
	},
	"hospitality_resort": {
		"file": "hospitality_resort",
		"tooltip": "Hospitality Resort"
	},
	"hospitality_spa": {
		"file": "hospitality_spa",
		"tooltip": "Hospitality Spa"
	},
	"host": {
		"file": "host",
		"tooltip": "Host"
	},
	"house": {
		"file": "house",
		"tooltip": "House"
	},
	"house_large": {
		"file": "house_large",
		"tooltip": "House Large"
	},
	"huge": {
		"file": "huge",
		"tooltip": "Huge"
	},
	"humanoid": {
		"file": "humanoid",
		"tooltip": "Humanoid"
	},
	"hunger_and_thirst_tick": {
		"file": "hunger_and_thirst_tick",
		"tooltip": "Hunger and Thirst Tick"
	},
	"hungry": {
		"file": "hungry",
		"tooltip": "Hungry"
	},
	"hunkered_down": {
		"file": "hunkered_down",
		"tooltip": "Hunkered Down"
	},
	"hunter": {
		"file": "hunter",
		"tooltip": "Hunter Summon"
	},
	"hunting": {
		"file": "hunting",
		"tooltip": "Hunting"
	},
	"huo_stance": {
		"file": "huo_stance",
		"tooltip": "Huo Stance"
	},
	"hybrid_cavalry": {
		"file": "hybrid_cavalry",
		"tooltip": "Hybrid Cavalry"
	},
	"hydroponics_agricultural_complex": {
		"file": "hydroponics_agricultural_complex",
		"tooltip": "Hydroponics Agricultural Complex"
	},
	"ignan": {
		"file": "ignan",
		"tooltip": "Ignan"
	},
	"immobile": {
		"file": "immobile",
		"tooltip": "Immobile"
	},
	"impaired": {
		"file": "impaired",
		"tooltip": "Impaired"
	},
	"incorporeal": {
		"file": "incorporeal",
		"tooltip": "Incorporeal"
	},
	"increase_luck_roll": {
		"file": "increase_luck_roll",
		"tooltip": "Increase Luck Roll"
	},
	"increase_mana_roll": {
		"file": "increase_mana_roll",
		"tooltip": "Increase Mana Roll"
	},
	"infernal": {
		"file": "infernal",
		"tooltip": "Infernal"
	},
	"influence": {
		"file": "influence",
		"tooltip": "Influence"
	},
	"inhaled_poison": {
		"file": "inhaled_poison",
		"tooltip": "Inhaled Poison"
	},
	"initiative": {
		"file": "initiative",
		"tooltip": "Initiative"
	},
	"injested_poison": {
		"file": "injested_poison",
		"tooltip": "Ingested Poison"
	},
	"injury_poison": {
		"file": "injury_poison",
		"tooltip": "Injury Poison"
	},
	"inland_sea": {
		"file": "inland_sea",
		"tooltip": "Inland Sea"
	},
	"inn": {
		"file": "inn",
		"tooltip": "Inn"
	},
	"inspection": {
		"file": "inspection",
		"tooltip": "Inspection"
	},
	"integrated_object": {
		"file": "integrated_object",
		"tooltip": "Integrated Object"
	},
	"inverted": {
		"file": "inverted",
		"tooltip": "Inverted"
	},
	"invigorated": {
		"file": "invigorated",
		"tooltip": "Invigorated"
	},
	"invisible": {
		"file": "invisible",
		"tooltip": "Invisible"
	},
	"invulnerable": {
		"file": "invulnerable",
		"tooltip": "Invulnerable"
	},
	"island": {
		"file": "island",
		"tooltip": "Island"
	},
	"island_floating": {
		"file": "island_floating",
		"tooltip": "Island Floating"
	},
	"isthmus": {
		"file": "isthmus",
		"tooltip": "Isthmus"
	},
	"javelins": {
		"file": "javelins",
		"tooltip": "Javelins"
	},
	"jeweler_building": {
		"file": "jeweler_building",
		"tooltip": "Jeweler Building"
	},
	"jewelling": {
		"file": "jewelling",
		"tooltip": "Jewelling"
	},
	"judgement": {
		"file": "judgement",
		"tooltip": "Judgement"
	},
	"judgement_1": {
		"file": "judgement_1",
		"tooltip": "Judgement 1"
	},
	"judgement_2": {
		"file": "judgement_2",
		"tooltip": "Judgement 2"
	},
	"judgement_3": {
		"file": "judgement_3",
		"tooltip": "Judgement 3"
	},
	"jungle": {
		"file": "jungle",
		"tooltip": "Jungle"
	},
	"keep": {
		"file": "keep",
		"tooltip": "Keep"
	},
	"keyboards": {
		"file": "keyboards",
		"tooltip": "Keyboards"
	},
	"kiosk_small_store": {
		"file": "kiosk_small_store",
		"tooltip": "Kiosk Small Store"
	},
	"kite_shields": {
		"file": "kite_shields",
		"tooltip": "Kite Shields"
	},
	"laboratory": {
		"file": "laboratory",
		"tooltip": "Laboratory"
	},
	"laboratory_magical": {
		"file": "laboratory_magical",
		"tooltip": "Laboratory Magical"
	},
	"lair_building": {
		"file": "lair_building",
		"tooltip": "Lair Building"
	},
	"lake": {
		"file": "lake",
		"tooltip": "Lake"
	},
	"lake_dry": {
		"file": "lake_dry",
		"tooltip": "Lake Dry"
	},
	"lamellar_armors": {
		"file": "lamellar_armors",
		"tooltip": "Lamellar Armors"
	},
	"lances": {
		"file": "lances",
		"tooltip": "Lances"
	},
	"landmass": {
		"file": "landmass",
		"tooltip": "Landmass"
	},
	"large": {
		"file": "large",
		"tooltip": "Large"
	},
	"large_city": {
		"file": "large_city",
		"tooltip": "Large City"
	},
	"large_town": {
		"file": "large_town",
		"tooltip": "Large Town"
	},
	"lava_river": {
		"file": "lava_river",
		"tooltip": "Lava River"
	},
	"law": {
		"file": "law",
		"tooltip": "Law"
	},
	"leader_role": {
		"file": "leader_role",
		"tooltip": "Leader Role"
	},
	"leather_jerkin_armors": {
		"file": "leather_jerkin_armors",
		"tooltip": "Leather Jerkin Armors"
	},
	"leatherworking": {
		"file": "leatherworking",
		"tooltip": "Leatherworking"
	},
	"legs": {
		"file": "legs",
		"tooltip": "Legs"
	},
	"library": {
		"file": "library",
		"tooltip": "Library"
	},
	"light_armor_skill": {
		"file": "light_armor_skill",
		"tooltip": "Light Armor Skill"
	},
	"light_cavalry": {
		"file": "light_cavalry",
		"tooltip": "Light Cavalry"
	},
	"light_shields": {
		"file": "light_shields",
		"tooltip": "Light Shields"
	},
	"lighthouse": {
		"file": "lighthouse",
		"tooltip": "Lighthouse"
	},
	"lightning": {
		"file": "lightning",
		"tooltip": "Lightning"
	},
	"line": {
		"file": "line",
		"tooltip": "Line"
	},
	"linguistics": {
		"file": "linguistics",
		"tooltip": "Linguistics"
	},
	"locked": {
		"file": "locked",
		"tooltip": "Locked"
	},
	"lockpicking": {
		"file": "lockpicking",
		"tooltip": "Lockpicking"
	},
	"lockpicking_roll": {
		"file": "lockpicking_roll",
		"tooltip": "Lockpicking Roll"
	},
	"locks": {
		"file": "locks",
		"tooltip": "Locks"
	},
	"longbows": {
		"file": "longbows",
		"tooltip": "Longbows"
	},
	"longswords": {
		"file": "longswords",
		"tooltip": "Longswords"
	},
	"luck": {
		"file": "luck",
		"tooltip": "Luck"
	},
	"maces": {
		"file": "maces",
		"tooltip": "Maces"
	},
	"machining": {
		"file": "machining",
		"tooltip": "Machining"
	},
	"magic": {
		"file": "magic",
		"tooltip": "Magic"
	},
	"magical_darkness": {
		"file": "magical_darkness",
		"tooltip": "Magical Darkness"
	},
	"magical_realm": {
		"file": "magical_realm",
		"tooltip": "Magical Realm"
	},
	"mail_shirt_armors": {
		"file": "mail_shirt_armors",
		"tooltip": "Mail Shirt Armors"
	},
	"maimed": {
		"file": "maimed",
		"tooltip": "Maimed"
	},
	"maimed_1": {
		"file": "maimed_1",
		"tooltip": "Maimed 1"
	},
	"maimed_10": {
		"file": "maimed_10",
		"tooltip": "Maimed 10"
	},
	"maimed_2": {
		"file": "maimed_2",
		"tooltip": "Maimed 2"
	},
	"maimed_3": {
		"file": "maimed_3",
		"tooltip": "Maimed 3"
	},
	"maimed_4": {
		"file": "maimed_4",
		"tooltip": "Maimed 4"
	},
	"maimed_5": {
		"file": "maimed_5",
		"tooltip": "Maimed 5"
	},
	"maimed_6": {
		"file": "maimed_6",
		"tooltip": "Maimed 6"
	},
	"maimed_7": {
		"file": "maimed_7",
		"tooltip": "Maimed 7"
	},
	"maimed_8": {
		"file": "maimed_8",
		"tooltip": "Maimed 8"
	},
	"maimed_9": {
		"file": "maimed_9",
		"tooltip": "Maimed 9"
	},
	"main_hand": {
		"file": "main_hand",
		"tooltip": "Main Hand"
	},
	"male": {
		"file": "male",
		"tooltip": "Male"
	},
	"mana_drain_roll": {
		"file": "mana_drain_roll",
		"tooltip": "Mana Drain Roll"
	},
	"manifestation_of_clairvoyance": {
		"file": "manifestation_of_clairvoyance",
		"tooltip": "Manifestation Of Clairvoyance"
	},
	"manifestation_of_metamorphosis": {
		"file": "manifestation_of_metamorphosis",
		"tooltip": "Manifestation Of Metamorphosis"
	},
	"manifestation_of_pyrokinesis": {
		"file": "manifestation_of_pyrokinesis",
		"tooltip": "Manifestation Of Pyrokinesis"
	},
	"manifestation_of_telekinesis": {
		"file": "manifestation_of_telekinesis",
		"tooltip": "Manifestation Of Telekinesis"
	},
	"manifestation_of_telepathy": {
		"file": "manifestation_of_telepathy",
		"tooltip": "Manifestation Of Telepathy"
	},
	"manor_house_meeting_hall": {
		"file": "manor_house_meeting_hall",
		"tooltip": "Manor House Meeting Hall"
	},
	"mansion_villa": {
		"file": "mansion_villa",
		"tooltip": "Mansion Villa"
	},
	"market_square": {
		"file": "market_square",
		"tooltip": "Market Square"
	},
	"market_stall": {
		"file": "market_stall",
		"tooltip": "Market Stall"
	},
	"masoning": {
		"file": "masoning",
		"tooltip": "Masoning"
	},
	"mastery": {
		"file": "mastery",
		"tooltip": "Mastery"
	},
	"mauls": {
		"file": "mauls",
		"tooltip": "Mauls"
	},
	"meadow": {
		"file": "meadow",
		"tooltip": "Meadow"
	},
	"medicine": {
		"file": "medicine",
		"tooltip": "Medicine"
	},
	"medium": {
		"file": "medium",
		"tooltip": "Medium - Size"
	},
	"medium_armor_skill": {
		"file": "medium_armor_skill",
		"tooltip": "Medium Armor Skill"
	},
	"medium_shields": {
		"file": "medium_shields",
		"tooltip": "Medium Shields"
	},
	"megalith": {
		"file": "megalith",
		"tooltip": "Megalith"
	},
	"megalopolis": {
		"file": "megalopolis",
		"tooltip": "Megalopolis"
	},
	"megastructure": {
		"file": "megastructure",
		"tooltip": "Megastructure"
	},
	"melee_weapon_type": {
		"file": "melee_weapon_type",
		"tooltip": "Melee Weapon Type"
	},
	"melody": {
		"file": "melody",
		"tooltip": "Melody"
	},
	"melting": {
		"file": "melting",
		"tooltip": "Melting"
	},
	"memorial_war_memorial": {
		"file": "memorial_war_memorial",
		"tooltip": "Memorial War Memorial"
	},
	"menace": {
		"file": "menace",
		"tooltip": "Menace"
	},
	"metropolis": {
		"file": "metropolis",
		"tooltip": "Metropolis"
	},
	"military_base": {
		"file": "military_base",
		"tooltip": "Military Base"
	},
	"military_base_complex": {
		"file": "military_base_complex",
		"tooltip": "Military Base Complex"
	},
	"military_camp": {
		"file": "military_camp",
		"tooltip": "Military Camp"
	},
	"mill": {
		"file": "mill",
		"tooltip": "Mill"
	},
	"min_skill_tier_1": {
		"file": "min_skill_tier_1",
		"tooltip": "Natural Weapon (min skill tier 1)"
	},
	"min_skill_tier_14": {
		"file": "min_skill_tier_14",
		"tooltip": "Natural Weapon (min skill tier 14)"
	},
	"min_skill_tier_3": {
		"file": "min_skill_tier_3",
		"tooltip": "Natural Weapon (min skill tier 3)"
	},
	"min_skill_tier_5": {
		"file": "min_skill_tier_5",
		"tooltip": "Natural Weapon (min skill tier 5)"
	},
	"min_skill_tier_7": {
		"file": "min_skill_tier_7",
		"tooltip": "Natural Weapon (min skill tier 7)"
	},
	"min_skill_tier_9": {
		"file": "min_skill_tier_9",
		"tooltip": "Natural Weapon (min skill tier 9)"
	},
	"mind": {
		"file": "mind",
		"tooltip": "Mind"
	},
	"mind_of_the_clairvoyant": {
		"file": "mind_of_the_clairvoyant",
		"tooltip": "Mind Of The Clairvoyant"
	},
	"mind_of_the_hallucinarch": {
		"file": "mind_of_the_hallucinarch",
		"tooltip": "Mind Of The Hallucinarch"
	},
	"mind_of_the_metamorph": {
		"file": "mind_of_the_metamorph",
		"tooltip": "Mind Of The Metamorph"
	},
	"mind_of_the_pyrokinetic": {
		"file": "mind_of_the_pyrokinetic",
		"tooltip": "Mind Of The Pyrokinetic"
	},
	"mind_of_the_telekinetic": {
		"file": "mind_of_the_telekinetic",
		"tooltip": "Mind Of The Telekinetic"
	},
	"mind_of_the_telepath": {
		"file": "mind_of_the_telepath",
		"tooltip": "Mind Of The Telepath"
	},
	"mine": {
		"file": "mine",
		"tooltip": "Mine"
	},
	"mining": {
		"file": "mining",
		"tooltip": "Mining"
	},
	"minion_role": {
		"file": "minion_role",
		"tooltip": "Minion Role"
	},
	"ministry_city_hall": {
		"file": "ministry_city_hall",
		"tooltip": "Ministry City Hall"
	},
	"mirror_image_1": {
		"file": "mirror_image_1",
		"tooltip": "Mirror Image 1"
	},
	"mirror_image_2": {
		"file": "mirror_image_2",
		"tooltip": "Mirror Image 2"
	},
	"mirror_image_3": {
		"file": "mirror_image_3",
		"tooltip": "Mirror Image 3"
	},
	"mirror_image_effect": {
		"file": "mirror_image_effect",
		"tooltip": "Mirror Images"
	},
	"missile_cavalry": {
		"file": "missile_cavalry",
		"tooltip": "Missile Cavalry"
	},
	"missile_launch_facility": {
		"file": "missile_launch_facility",
		"tooltip": "Missile Launch Facility"
	},
	"moderate_bleeding": {
		"file": "moderate_bleeding",
		"tooltip": "Moderate Bleeding"
	},
	"monastery": {
		"file": "monastery",
		"tooltip": "Monastery"
	},
	"monstrosity": {
		"file": "monstrosity",
		"tooltip": "Monstrosity"
	},
	"monstrous_cavalry": {
		"file": "monstrous_cavalry",
		"tooltip": "Monstrous Cavalry"
	},
	"monument_statue_large": {
		"file": "monument_statue_large",
		"tooltip": "Monument Statue Large"
	},
	"moor": {
		"file": "moor",
		"tooltip": "Moor"
	},
	"morningstars": {
		"file": "morningstars",
		"tooltip": "Morningstars"
	},
	"mount_back_bow": {
		"file": "mount_back_bow",
		"tooltip": "Visual Mount — Back Bow"
	},
	"mount_back_pack": {
		"file": "mount_back_pack",
		"tooltip": "Visual Mount — Back Pack"
	},
	"mount_back_primary": {
		"file": "mount_back_primary",
		"tooltip": "Visual Mount — Back Primary"
	},
	"mount_back_quiver": {
		"file": "mount_back_quiver",
		"tooltip": "Visual Mount — Back Quiver"
	},
	"mount_back_shield": {
		"file": "mount_back_shield",
		"tooltip": "Visual Mount — Back Shield"
	},
	"mount_held_main": {
		"file": "mount_held_main",
		"tooltip": "Visual Mount — Held Main Hand"
	},
	"mount_held_off": {
		"file": "mount_held_off",
		"tooltip": "Visual Mount — Held Off Hand"
	},
	"mount_hidden": {
		"file": "mount_hidden",
		"tooltip": "Visual Mount — Hidden"
	},
	"mount_hip_auto": {
		"file": "mount_hip_auto",
		"tooltip": "Visual Mount — Either Hip"
	},
	"mount_hip_left": {
		"file": "mount_hip_left",
		"tooltip": "Visual Mount — Left Hip"
	},
	"mount_hip_right": {
		"file": "mount_hip_right",
		"tooltip": "Visual Mount — Right Hip"
	},
	"mount_thigh_left": {
		"file": "mount_thigh_left",
		"tooltip": "Visual Mount — Left Thigh"
	},
	"mount_thigh_right": {
		"file": "mount_thigh_right",
		"tooltip": "Visual Mount — Right Thigh"
	},
	"mount_waist": {
		"file": "mount_waist",
		"tooltip": "Visual Mount — Waist Belt"
	},
	"mount_worn": {
		"file": "mount_worn",
		"tooltip": "Visual Mount — Worn"
	},
	"mount_worn_cloak": {
		"file": "mount_worn_cloak",
		"tooltip": "Visual Mount — Worn: Cloak"
	},
	"mount_worn_feet": {
		"file": "mount_worn_feet",
		"tooltip": "Visual Mount — Worn: Feet"
	},
	"mount_worn_hands": {
		"file": "mount_worn_hands",
		"tooltip": "Visual Mount — Worn: Hands"
	},
	"mount_worn_head": {
		"file": "mount_worn_head",
		"tooltip": "Visual Mount — Worn: Head"
	},
	"mount_worn_legs": {
		"file": "mount_worn_legs",
		"tooltip": "Visual Mount — Worn: Legs"
	},
	"mount_worn_neck": {
		"file": "mount_worn_neck",
		"tooltip": "Visual Mount — Worn: Neck"
	},
	"mount_worn_torso": {
		"file": "mount_worn_torso",
		"tooltip": "Visual Mount — Worn: Torso"
	},
	"mountain": {
		"file": "mountain",
		"tooltip": "Mountain"
	},
	"mountain_location": {
		"file": "mountain_location",
		"tooltip": "Mountain Location"
	},
	"mountain_pass": {
		"file": "mountain_pass",
		"tooltip": "Mountain Pass"
	},
	"mountain_range": {
		"file": "mountain_range",
		"tooltip": "Mountain Range"
	},
	"mounted": {
		"file": "mounted",
		"tooltip": "Mounted"
	},
	"multiverse": {
		"file": "multiverse",
		"tooltip": "Multiverse"
	},
	"museum": {
		"file": "museum",
		"tooltip": "Museum"
	},
	"music": {
		"file": "music",
		"tooltip": "Music"
	},
	"muskets": {
		"file": "muskets",
		"tooltip": "Muskets"
	},
	"nagh": {
		"file": "nagh",
		"tooltip": "Nagh"
	},
	"national_territory": {
		"file": "national_territory",
		"tooltip": "National Territory"
	},
	"natural_armor": {
		"file": "armor_type",
		"tooltip": "Natural Armor"
	},
	"natural_armor_skill": {
		"file": "natural_armor_skill",
		"tooltip": "Natural Armor Skill"
	},
	"natural_armor_skill_tier_14": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 14+)"
	},
	"natural_armor_skill_tier_3": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 3+)"
	},
	"natural_armor_skill_tier_5": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 5+)"
	},
	"natural_armor_skill_tier_7": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 7+)"
	},
	"natural_armor_skill_tier_9": {
		"file": "armor_type",
		"tooltip": "Natural Armor Reaction (Skill Tier 9+)"
	},
	"natural_armors": {
		"file": "armor_type",
		"tooltip": "Natural Armors"
	},
	"natural_weapon": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form — Other"
	},
	"natural_weapon_skill": {
		"file": "natural_weapon_skill",
		"tooltip": "Natural Weapon Skill"
	},
	"natural_weapons": {
		"file": "natural_weapons",
		"tooltip": "Natural Weapons"
	},
	"natural_wonder": {
		"file": "natural_wonder",
		"tooltip": "Natural Wonder"
	},
	"navigation": {
		"file": "navigation",
		"tooltip": "Navigation"
	},
	"nebula": {
		"file": "nebula",
		"tooltip": "Nebula"
	},
	"neck": {
		"file": "neck",
		"tooltip": "Neck"
	},
	"necrotic": {
		"file": "necrotic",
		"tooltip": "Necrotic"
	},
	"neighborhood": {
		"file": "neighborhood",
		"tooltip": "Neighborhood"
	},
	"nets": {
		"file": "nets",
		"tooltip": "Nets"
	},
	"neutral": {
		"file": "neutral",
		"tooltip": "Neutral"
	},
	"nightsight": {
		"file": "nightsight",
		"tooltip": "Nightsight"
	},
	"no_bending_powers": {
		"file": "no_bending_powers",
		"tooltip": "No Bending Powers"
	},
	"nondetection_effect": {
		"file": "nondetection_effect",
		"tooltip": "Nondetection Effect"
	},
	"oasis": {
		"file": "oasis",
		"tooltip": "Oasis"
	},
	"oath_of_honor": {
		"file": "oath_of_honor",
		"tooltip": "Oath Of Honor"
	},
	"oath_of_love": {
		"file": "oath_of_love",
		"tooltip": "Oath Of Love"
	},
	"oath_of_mercy": {
		"file": "oath_of_mercy",
		"tooltip": "Oath Of Mercy"
	},
	"oath_of_purification": {
		"file": "oath_of_purification",
		"tooltip": "Oath Of Purification"
	},
	"oath_of_revolution": {
		"file": "oath_of_revolution",
		"tooltip": "Oath Of Revolution"
	},
	"oath_of_the_guardian": {
		"file": "oath_of_the_guardian",
		"tooltip": "Oath Of The Guardian"
	},
	"oath_of_the_spellbreaker": {
		"file": "oath_of_the_spellbreaker",
		"tooltip": "Oath Of The Spellbreaker"
	},
	"oath_of_the_stars": {
		"file": "oath_of_the_stars",
		"tooltip": "Oath Of The Stars"
	},
	"oath_of_vengeance": {
		"file": "oath_of_vengeance",
		"tooltip": "Oath Of Vengeance"
	},
	"obelisk": {
		"file": "obelisk",
		"tooltip": "Obelisk"
	},
	"obscured": {
		"file": "obscured",
		"tooltip": "Obscured"
	},
	"observatory_telescope": {
		"file": "observatory_telescope",
		"tooltip": "Observatory Telescope"
	},
	"ocean": {
		"file": "ocean",
		"tooltip": "Ocean"
	},
	"off_hand": {
		"file": "off_hand",
		"tooltip": "Off Hand"
	},
	"office": {
		"file": "office",
		"tooltip": "Office"
	},
	"on_deaths_door": {
		"file": "on_deaths_door",
		"tooltip": "On Deaths Door"
	},
	"one_handed_melee_weapon_skill": {
		"file": "one_handed_melee_weapon_skill",
		"tooltip": "One-Handed Melee Weapon Skill"
	},
	"ooze": {
		"file": "ooze",
		"tooltip": "Ooze"
	},
	"opera_house": {
		"file": "opera_house",
		"tooltip": "Opera House"
	},
	"orb_slots": {
		"file": "orb_slots",
		"tooltip": "Orb Slots"
	},
	"orbital_station": {
		"file": "orbital_station",
		"tooltip": "Orbital Station"
	},
	"orcish": {
		"file": "orcish",
		"tooltip": "Orcish"
	},
	"orphanage": {
		"file": "orphanage",
		"tooltip": "Orphanage"
	},
	"orrery": {
		"file": "orrery",
		"tooltip": "Orrery"
	},
	"outer_space": {
		"file": "outer_space",
		"tooltip": "Outer Space"
	},
	"outpost": {
		"file": "outpost",
		"tooltip": "Outpost"
	},
	"pain_stance": {
		"file": "pain_stance",
		"tooltip": "Pain Stance"
	},
	"palace": {
		"file": "palace",
		"tooltip": "Palace"
	},
	"palm_pistols": {
		"file": "palm_pistols",
		"tooltip": "Palm Pistols"
	},
	"paralyzed": {
		"file": "paralyzed",
		"tooltip": "Paralyzed"
	},
	"parched": {
		"file": "parched",
		"tooltip": "Parched"
	},
	"park": {
		"file": "park",
		"tooltip": "Park"
	},
	"parliament": {
		"file": "parliament",
		"tooltip": "Parliament"
	},
	"partial_cover": {
		"file": "partial_cover",
		"tooltip": "Partial Cover"
	},
	"partly_cloudy": {
		"file": "partly_cloudy",
		"tooltip": "Partly Cloudy"
	},
	"patron_of_chance": {
		"file": "patron_of_chance",
		"tooltip": "Patron Of Chance"
	},
	"patron_of_death": {
		"file": "patron_of_death",
		"tooltip": "Patron Of Death"
	},
	"patron_of_secrets": {
		"file": "patron_of_secrets",
		"tooltip": "Patron Of Secrets"
	},
	"patron_of_the_angel": {
		"file": "patron_of_the_angel",
		"tooltip": "Patron Of The Angel"
	},
	"patron_of_the_artifact": {
		"file": "patron_of_the_artifact",
		"tooltip": "Patron Of The Artifact"
	},
	"patron_of_the_deep": {
		"file": "patron_of_the_deep",
		"tooltip": "Patron Of The Deep"
	},
	"patron_of_the_devil": {
		"file": "patron_of_the_devil",
		"tooltip": "Patron Of The Devil"
	},
	"patron_of_the_djinn": {
		"file": "patron_of_the_djinn",
		"tooltip": "Patron Of The Djinn"
	},
	"patron_of_the_fey": {
		"file": "patron_of_the_fey",
		"tooltip": "Patron Of The Fey"
	},
	"patron_of_the_lich": {
		"file": "patron_of_the_lich",
		"tooltip": "Patron Of The Lich"
	},
	"patron_of_the_plague": {
		"file": "patron_of_the_plague",
		"tooltip": "Patron Of The Plague"
	},
	"patron_of_the_void": {
		"file": "patron_of_the_void",
		"tooltip": "Patron Of The Void"
	},
	"patron_of_war": {
		"file": "patron_of_war",
		"tooltip": "Patron Of War"
	},
	"peninsula": {
		"file": "peninsula",
		"tooltip": "Peninsula"
	},
	"pepperboxes": {
		"file": "pepperboxes",
		"tooltip": "Pepperboxes"
	},
	"performing_a_melody": {
		"file": "performing_a_melody",
		"tooltip": "Performing a Melody"
	},
	"petrified": {
		"file": "petrified",
		"tooltip": "Petrified"
	},
	"petrifying": {
		"file": "petrifying",
		"tooltip": "Petrifying"
	},
	"photosensitive_eye_strain": {
		"file": "photosensitive_eye_strain",
		"tooltip": "Photosensitive Eye Strain"
	},
	"pier": {
		"file": "pier",
		"tooltip": "Pier"
	},
	"piercing": {
		"file": "piercing",
		"tooltip": "Piercing"
	},
	"pikes": {
		"file": "pikes",
		"tooltip": "Pikes"
	},
	"piloted": {
		"file": "piloted",
		"tooltip": "Piloted"
	},
	"piloting": {
		"file": "piloting",
		"tooltip": "Piloting"
	},
	"pipes": {
		"file": "pipes",
		"tooltip": "Pipes"
	},
	"pistols": {
		"file": "pistols",
		"tooltip": "Pistols"
	},
	"pitch_black": {
		"file": "pitch_black",
		"tooltip": "Pitch Black"
	},
	"plain": {
		"file": "plain",
		"tooltip": "Plain"
	},
	"planar": {
		"file": "planar",
		"tooltip": "Planar"
	},
	"planar_sphere_grouping": {
		"file": "planar_sphere_grouping",
		"tooltip": "Planar Sphere Grouping"
	},
	"plane_of_existence": {
		"file": "plane_of_existence",
		"tooltip": "Plane Of Existence"
	},
	"planes": {
		"file": "planes",
		"tooltip": "Planes"
	},
	"planet": {
		"file": "planet",
		"tooltip": "Planet"
	},
	"planetary_orbit": {
		"file": "planetary_orbit",
		"tooltip": "Planetary Orbit"
	},
	"planetary_ring": {
		"file": "planetary_ring",
		"tooltip": "Planetary Ring"
	},
	"planetoid": {
		"file": "planetoid",
		"tooltip": "Planetoid"
	},
	"planetoid_moon": {
		"file": "planetoid_moon",
		"tooltip": "Planetoid Moon"
	},
	"planetoid_rogue": {
		"file": "planetoid_rogue",
		"tooltip": "Planetoid Rogue"
	},
	"plant": {
		"file": "plant",
		"tooltip": "Plant"
	},
	"plate_armors": {
		"file": "plate_armors",
		"tooltip": "Plate Armors"
	},
	"plateau": {
		"file": "plateau",
		"tooltip": "Plateau"
	},
	"plaza": {
		"file": "plaza",
		"tooltip": "Plaza"
	},
	"pocket_universe": {
		"file": "pocket_universe",
		"tooltip": "Pocket Universe"
	},
	"poison": {
		"file": "poison",
		"tooltip": "Poison"
	},
	"poisoned": {
		"file": "poisoned",
		"tooltip": "Poisoned"
	},
	"police_fire_station": {
		"file": "police_fire_station",
		"tooltip": "Police Fire Station"
	},
	"pond": {
		"file": "pond",
		"tooltip": "Pond"
	},
	"portal": {
		"file": "portal",
		"tooltip": "Portal"
	},
	"possessed": {
		"file": "possessed",
		"tooltip": "Possessed"
	},
	"post_office": {
		"file": "post_office",
		"tooltip": "Post Office"
	},
	"power_plant": {
		"file": "power_plant",
		"tooltip": "Power Plant"
	},
	"powerful": {
		"file": "powerful",
		"tooltip": "Powerful"
	},
	"primal": {
		"file": "primal",
		"tooltip": "Primal Sphere of Magic"
	},
	"primordial": {
		"file": "primordial",
		"tooltip": "Primordial"
	},
	"prison": {
		"file": "prison",
		"tooltip": "Prison"
	},
	"prone": {
		"file": "prone",
		"tooltip": "Prone"
	},
	"protected": {
		"file": "protected",
		"tooltip": "Protected"
	},
	"psi": {
		"file": "psi",
		"tooltip": "Psi"
	},
	"psyche": {
		"file": "psyche",
		"tooltip": "Psyche"
	},
	"psychic": {
		"file": "psychic",
		"tooltip": "Psychic"
	},
	"puppet_stance": {
		"file": "puppet_stance",
		"tooltip": "Puppet Stance"
	},
	"qini": {
		"file": "qini",
		"tooltip": "Qini"
	},
	"quarry": {
		"file": "quarry",
		"tooltip": "Quarry"
	},
	"quarter": {
		"file": "quarter",
		"tooltip": "Quarter"
	},
	"quarterstaffs": {
		"file": "quarterstaffs",
		"tooltip": "Quarterstaffs"
	},
	"quick_study": {
		"file": "prepare_spells",
		"tooltip": "Quick Study"
	},
	"racing_track_hippodrome": {
		"file": "racing_track_hippodrome",
		"tooltip": "Racing Track Hippodrome"
	},
	"radiant": {
		"file": "radiant",
		"tooltip": "Radiant"
	},
	"raining": {
		"file": "raining",
		"tooltip": "Raining"
	},
	"range_close": {
		"file": "range_close",
		"tooltip": "Close (30)"
	},
	"range_far": {
		"file": "range_far",
		"tooltip": "Far (120)"
	},
	"range_near": {
		"file": "range_near",
		"tooltip": "Near (60)"
	},
	"range_object": {
		"file": "range_object",
		"tooltip": "Object Range"
	},
	"range_reach": {
		"file": "range_reach",
		"tooltip": "Reach"
	},
	"range_self": {
		"file": "range_self",
		"tooltip": "Self"
	},
	"range_unlimited": {
		"file": "range_unlimited",
		"tooltip": "Unlimited"
	},
	"range_very_far": {
		"file": "range_very_far",
		"tooltip": "Very Far (240)"
	},
	"ranged_weapon_type": {
		"file": "ranged_weapon_type",
		"tooltip": "Ranged Weapon Type"
	},
	"rapids": {
		"file": "rapids",
		"tooltip": "Rapids"
	},
	"rapiers": {
		"file": "rapiers",
		"tooltip": "Rapiers"
	},
	"reading": {
		"file": "reading",
		"tooltip": "Reading"
	},
	"ready": {
		"file": "ready",
		"tooltip": "Ready"
	},
	"received_prayer_of_healing": {
		"file": "received_prayer_of_healing",
		"tooltip": "Received Prayer of Healing"
	},
	"recharge_ability_roll": {
		"file": "recharge_ability_roll",
		"tooltip": "Recharge Ability Roll"
	},
	"reckless": {
		"file": "reckless",
		"tooltip": "Reckless"
	},
	"recovery_state": {
		"file": "recovery_state",
		"tooltip": "Recovery State"
	},
	"recovery_state_1": {
		"file": "recovery_state_1",
		"tooltip": "Recovery State 1"
	},
	"recovery_state_2": {
		"file": "recovery_state_2",
		"tooltip": "Recovery State 2"
	},
	"recovery_state_3": {
		"file": "recovery_state_3",
		"tooltip": "Recovery State 3"
	},
	"reduce_damage_roll": {
		"file": "reduce_damage_roll",
		"tooltip": "Reduce Damage Roll"
	},
	"reduce_luck_roll": {
		"file": "reduce_luck_roll",
		"tooltip": "Reduce Luck Roll"
	},
	"reduce_mana_roll": {
		"file": "reduce_mana_roll",
		"tooltip": "Reduce Mana Roll"
	},
	"refinery_industrial_complex": {
		"file": "refinery_industrial_complex",
		"tooltip": "Refinery Industrial Complex"
	},
	"regeneration_roll": {
		"file": "regeneration_roll",
		"tooltip": "Regeneration Roll"
	},
	"region": {
		"file": "region",
		"tooltip": "Region"
	},
	"regress_grapple_escape": {
		"file": "regress_grapple_escape",
		"tooltip": "Regress Grapple: Escape"
	},
	"regress_grapple_restrain": {
		"file": "regress_grapple_restrain",
		"tooltip": "Regress Grapple: Restrain"
	},
	"release_grapple": {
		"file": "release_grapple",
		"tooltip": "Release Grapple"
	},
	"religion": {
		"file": "religion",
		"tooltip": "Religion"
	},
	"repelled": {
		"file": "repelled",
		"tooltip": "Repelled"
	},
	"reservoir": {
		"file": "reservoir",
		"tooltip": "Reservoir"
	},
	"resistant": {
		"file": "resistant",
		"tooltip": "Resistant"
	},
	"resting": {
		"file": "resting",
		"tooltip": "Resting"
	},
	"restrained": {
		"file": "restrained",
		"tooltip": "Restrained"
	},
	"retirement_home": {
		"file": "retirement_home",
		"tooltip": "Retirement Home"
	},
	"ridden": {
		"file": "ridden",
		"tooltip": "Ridden"
	},
	"riding": {
		"file": "riding",
		"tooltip": "Riding"
	},
	"ring": {
		"file": "ring",
		"tooltip": "Ring"
	},
	"rite": {
		"file": "rite",
		"tooltip": "Rite"
	},
	"river": {
		"file": "river",
		"tooltip": "River"
	},
	"river_basin": {
		"file": "river_basin",
		"tooltip": "River Basin"
	},
	"rock_formation": {
		"file": "rock_formation",
		"tooltip": "Rock Formation"
	},
	"rolling_hills": {
		"file": "rolling_hills",
		"tooltip": "Rolling Hills"
	},
	"rope_darts": {
		"file": "rope_darts",
		"tooltip": "Rope Darts"
	},
	"rotting": {
		"file": "rotting",
		"tooltip": "Rotting"
	},
	"rushed": {
		"file": "rushed",
		"tooltip": "Rushed"
	},
	"salt_flat": {
		"file": "salt_flat",
		"tooltip": "Salt Flat"
	},
	"sanguine": {
		"file": "sanguine",
		"tooltip": "Sanguine"
	},
	"savannah": {
		"file": "savannah",
		"tooltip": "Savannah"
	},
	"school": {
		"file": "school",
		"tooltip": "School"
	},
	"scimitars": {
		"file": "scimitars",
		"tooltip": "Scimitars"
	},
	"scythes": {
		"file": "scythes",
		"tooltip": "Scythes"
	},
	"sea": {
		"file": "sea",
		"tooltip": "Sea"
	},
	"seaport": {
		"file": "seaport",
		"tooltip": "Seaport"
	},
	"search_for_hidden_inventory": {
		"file": "search_for_hidden_inventory",
		"tooltip": "Search for Hidden Inventory"
	},
	"searching": {
		"file": "searching",
		"tooltip": "Searching"
	},
	"severe_bleeding": {
		"file": "severe_bleeding",
		"tooltip": "Severe Bleeding"
	},
	"sewers": {
		"file": "sewers",
		"tooltip": "Sewers"
	},
	"shadowform": {
		"file": "shadowform",
		"tooltip": "Shadowform"
	},
	"shard_of_alucard": {
		"file": "shard_of_alucard",
		"tooltip": "Shard of Alucard"
	},
	"shard_of_aurelion": {
		"file": "shard_of_aurelion",
		"tooltip": "Shard of Aurelion"
	},
	"shard_of_caelix": {
		"file": "shard_of_caelix",
		"tooltip": "Shard of Caelix"
	},
	"shard_of_fhalora": {
		"file": "shard_of_fhalora",
		"tooltip": "Shard of Fhalora"
	},
	"shard_of_irvatha": {
		"file": "shard_of_irvatha",
		"tooltip": "Shard of Irvatha"
	},
	"shard_of_korravex": {
		"file": "shard_of_korravex",
		"tooltip": "Shard Of Korravex"
	},
	"shard_of_the_glass_mage": {
		"file": "shard_of_the_glass_mage",
		"tooltip": "Shard of the Glass Mage"
	},
	"shard_of_the_glass_warrior": {
		"file": "shard_of_the_glass_warrior",
		"tooltip": "Shard of the Glass Warrior"
	},
	"shed": {
		"file": "shed",
		"tooltip": "Shed"
	},
	"shelled": {
		"file": "shelled",
		"tooltip": "Shelled"
	},
	"shield_armor_skill": {
		"file": "shield_armor_skill",
		"tooltip": "Shield Armor Skill"
	},
	"shield_encumbered": {
		"file": "shield_encumbered",
		"tooltip": "Shield Encumbered"
	},
	"shielded": {
		"file": "shielded",
		"tooltip": "Shielded"
	},
	"shielded_1": {
		"file": "shielded_1",
		"tooltip": "Shielded 1"
	},
	"shielded_10": {
		"file": "shielded_10",
		"tooltip": "Shielded 10"
	},
	"shielded_2": {
		"file": "shielded_2",
		"tooltip": "Shielded 2"
	},
	"shielded_3": {
		"file": "shielded_3",
		"tooltip": "Shielded 3"
	},
	"shielded_4": {
		"file": "shielded_4",
		"tooltip": "Shielded 4"
	},
	"shielded_5": {
		"file": "shielded_5",
		"tooltip": "Shielded 5"
	},
	"shielded_6": {
		"file": "shielded_6",
		"tooltip": "Shielded 6"
	},
	"shielded_7": {
		"file": "shielded_7",
		"tooltip": "Shielded 7"
	},
	"shielded_8": {
		"file": "shielded_8",
		"tooltip": "Shielded 8"
	},
	"shielded_9": {
		"file": "shielded_9",
		"tooltip": "Shielded 9"
	},
	"ship": {
		"file": "ship",
		"tooltip": "Ship"
	},
	"shizen_stance": {
		"file": "shizen_stance",
		"tooltip": "Shizen Stance"
	},
	"shoal": {
		"file": "shoal",
		"tooltip": "Shoal"
	},
	"shock_cavalry": {
		"file": "shock_cavalry",
		"tooltip": "Shock Cavalry"
	},
	"shocked": {
		"file": "shocked",
		"tooltip": "Shocked"
	},
	"shop_cobbler": {
		"file": "shop_cobbler",
		"tooltip": "Shop Cobbler"
	},
	"shop_generic": {
		"file": "shop_generic",
		"tooltip": "Shop Generic"
	},
	"shop_magic": {
		"file": "shop_magic",
		"tooltip": "Shop Magic"
	},
	"shop_tailor": {
		"file": "shop_tailor",
		"tooltip": "Shop Tailor"
	},
	"shopping_mall_commercial_complex": {
		"file": "shopping_mall_commercial_complex",
		"tooltip": "Shopping Mall Commercial Complex"
	},
	"shortbows": {
		"file": "shortbows",
		"tooltip": "Shortbows"
	},
	"shortswords": {
		"file": "shortswords",
		"tooltip": "Shortswords"
	},
	"shrine": {
		"file": "shrine",
		"tooltip": "Shrine"
	},
	"shu_stance": {
		"file": "shu_stance",
		"tooltip": "Shu Stance"
	},
	"sickles": {
		"file": "sickles",
		"tooltip": "Sickles"
	},
	"sightless": {
		"file": "sightless",
		"tooltip": "Sightless"
	},
	"sign_language": {
		"file": "sign_language",
		"tooltip": "Sign Language"
	},
	"silenced": {
		"file": "silenced",
		"tooltip": "Silenced"
	},
	"silo": {
		"file": "silo",
		"tooltip": "Silo"
	},
	"sinkhole": {
		"file": "sinkhole",
		"tooltip": "Sinkhole"
	},
	"skill_roll": {
		"file": "skill_roll",
		"tooltip": "Skill Roll"
	},
	"skill_roll_assistance_roll": {
		"file": "skill_roll_assistance_roll",
		"tooltip": "Skill Roll Assistance Roll"
	},
	"skill_roll_retracting_roll": {
		"file": "skill_roll_retracting_roll",
		"tooltip": "Skill Roll Retracting Roll"
	},
	"skinning": {
		"file": "skinning",
		"tooltip": "Skinning"
	},
	"skirmisher_role": {
		"file": "skirmisher_role",
		"tooltip": "Skirmisher Role"
	},
	"skyscraper": {
		"file": "skyscraper",
		"tooltip": "Skyscraper"
	},
	"slashing": {
		"file": "slashing",
		"tooltip": "Slashing"
	},
	"slaughterhouse": {
		"file": "slaughterhouse",
		"tooltip": "Slaughterhouse"
	},
	"sleeping": {
		"file": "sleeping",
		"tooltip": "Sleeping"
	},
	"slightly_drunk": {
		"file": "slightly_drunk",
		"tooltip": "Slightly Drunk"
	},
	"sling_bullet": {
		"file": "sling_bullet",
		"tooltip": "Sling Bullets"
	},
	"slings": {
		"file": "slings",
		"tooltip": "Slings"
	},
	"slowed": {
		"file": "slowed",
		"tooltip": "Slowed"
	},
	"sluggish": {
		"file": "sluggish",
		"tooltip": "Sluggish"
	},
	"slum": {
		"file": "slum",
		"tooltip": "Slum"
	},
	"small": {
		"file": "small",
		"tooltip": "Small"
	},
	"smelter": {
		"file": "smelter",
		"tooltip": "Smelter"
	},
	"smithing": {
		"file": "smithing",
		"tooltip": "Smithing"
	},
	"sneak": {
		"file": "sneak",
		"tooltip": "Sneak"
	},
	"sneaking": {
		"file": "sneaking",
		"tooltip": "Sneaking"
	},
	"snowing": {
		"file": "snowing",
		"tooltip": "Snowing"
	},
	"snowing_and_raining": {
		"file": "snowing_and_raining",
		"tooltip": "Sleet"
	},
	"solar_system": {
		"file": "solar_system",
		"tooltip": "Solar System"
	},
	"soldier_role": {
		"file": "soldier_role",
		"tooltip": "Soldier Role"
	},
	"song_of_color": {
		"file": "song_of_color",
		"tooltip": "Song Of Color"
	},
	"song_of_discord": {
		"file": "song_of_discord",
		"tooltip": "Song Of Discord"
	},
	"song_of_knowledge": {
		"file": "song_of_knowledge",
		"tooltip": "Song Of Knowledge"
	},
	"song_of_the_celestial_choir": {
		"file": "song_of_the_celestial_choir",
		"tooltip": "Song Of The Celestial Choir"
	},
	"song_of_the_dancer": {
		"file": "song_of_the_dancer",
		"tooltip": "Song Of The Dancer"
	},
	"song_of_the_fey": {
		"file": "song_of_the_fey",
		"tooltip": "Song Of The Fey"
	},
	"song_of_the_loom": {
		"file": "song_of_the_loom",
		"tooltip": "Song Of The Loom"
	},
	"song_of_the_sea": {
		"file": "song_of_the_sea",
		"tooltip": "Song Of The Sea"
	},
	"song_of_the_vocalist": {
		"file": "song_of_the_vocalist",
		"tooltip": "Song Of The Vocalist"
	},
	"soul": {
		"file": "soul",
		"tooltip": "Soul"
	},
	"soul_breaker": {
		"file": "soul_breaker",
		"tooltip": "Soul Breaker"
	},
	"south_stance": {
		"file": "south_stance",
		"tooltip": "South Stance"
	},
	"space_station": {
		"file": "space_station",
		"tooltip": "Space Station"
	},
	"spaceport": {
		"file": "spaceport",
		"tooltip": "Spaceport"
	},
	"spears": {
		"file": "spears",
		"tooltip": "Spears"
	},
	"specialist_in_assassination": {
		"file": "specialist_in_assassination",
		"tooltip": "Specialist In Assassination"
	},
	"specialist_in_corpsman": {
		"file": "specialist_in_corpsman",
		"tooltip": "Specialist In Corpsman"
	},
	"specialist_in_espionage": {
		"file": "specialist_in_espionage",
		"tooltip": "Specialist In Espionage"
	},
	"specialist_in_piracy": {
		"file": "specialist_in_piracy",
		"tooltip": "Specialist In Piracy"
	},
	"specialist_in_sabotage": {
		"file": "specialist_in_sabotage",
		"tooltip": "Specialist In Sabotage"
	},
	"specialist_in_the_astral_grift": {
		"file": "specialist_in_the_astral_grift",
		"tooltip": "Specialist In The Astral Grift"
	},
	"specialist_in_the_nullvein": {
		"file": "specialist_in_the_nullvein",
		"tooltip": "Specialist In The Nullvein"
	},
	"specialist_in_the_war_jester": {
		"file": "specialist_in_the_war_jester",
		"tooltip": "Specialist In The War Jester"
	},
	"specialist_in_thievery": {
		"file": "specialist_in_thievery",
		"tooltip": "Specialist In Thievery"
	},
	"speed_burrowing": {
		"file": "speed_burrowing",
		"tooltip": "Burrowing Speed"
	},
	"speed_climbing": {
		"file": "speed_climbing",
		"tooltip": "Climbing Speed"
	},
	"speed_flying": {
		"file": "speed_flying",
		"tooltip": "Flying Speed"
	},
	"speed_hovering": {
		"file": "speed_hovering",
		"tooltip": "Hovering Speed"
	},
	"speed_jumping": {
		"file": "speed_jumping",
		"tooltip": "Jumping Speed"
	},
	"speed_swimming": {
		"file": "speed_swimming",
		"tooltip": "Swimming Speed"
	},
	"speed_walking": {
		"file": "speed_walking",
		"tooltip": "Walking Speed"
	},
	"spell_locked": {
		"file": "spell_locked",
		"tooltip": "Spell Locked"
	},
	"spell_melee_attack_roll": {
		"file": "spell_melee_attack_roll",
		"tooltip": "Spell Melee Attack Roll"
	},
	"spell_ranged_attack_roll": {
		"file": "spell_ranged_attack_roll",
		"tooltip": "Spell Ranged Attack Roll"
	},
	"spellsight": {
		"file": "spellsight",
		"tooltip": "Spellsight"
	},
	"sphere": {
		"file": "sphere",
		"tooltip": "Sphere"
	},
	"sphere_locked_arcane": {
		"file": "sphere_locked_arcane",
		"tooltip": "Arcane Sphere Locked"
	},
	"sphere_locked_divine": {
		"file": "sphere_locked_divine",
		"tooltip": "Divine Sphere Locked"
	},
	"sphere_locked_primal": {
		"file": "sphere_locked_primal",
		"tooltip": "Primal Sphere Locked"
	},
	"spider_climb_effect": {
		"file": "spider_climb_effect",
		"tooltip": "Spider Climb Effect"
	},
	"spider_stance": {
		"file": "spider_stance",
		"tooltip": "Spider Stance"
	},
	"spire": {
		"file": "spire",
		"tooltip": "Spire"
	},
	"spirit": {
		"file": "spirit",
		"tooltip": "Spirit"
	},
	"spoiling": {
		"file": "spoiling",
		"tooltip": "Spoiling"
	},
	"spot_hidden_creatures": {
		"file": "spot_hidden_creatures",
		"tooltip": "Spot Hidden Creatures"
	},
	"spring": {
		"file": "spring",
		"tooltip": "Spring"
	},
	"spring_location": {
		"file": "spring_location",
		"tooltip": "Spring Location"
	},
	"square": {
		"file": "square",
		"tooltip": "Square"
	},
	"squeezed": {
		"file": "squeezed",
		"tooltip": "Squeezed"
	},
	"stabilized": {
		"file": "stabilized",
		"tooltip": "Stabilized"
	},
	"stables": {
		"file": "stables",
		"tooltip": "Stables"
	},
	"stadium": {
		"file": "stadium",
		"tooltip": "Stadium"
	},
	"staggered": {
		"file": "staggered",
		"tooltip": "Staggered"
	},
	"stalk": {
		"file": "stalk",
		"tooltip": "Stalk"
	},
	"star": {
		"file": "star",
		"tooltip": "Star"
	},
	"star_system": {
		"file": "star_system",
		"tooltip": "Star System"
	},
	"star_system_sector": {
		"file": "star_system_sector",
		"tooltip": "Star System Sector"
	},
	"starbase": {
		"file": "starbase",
		"tooltip": "Starbase"
	},
	"starving": {
		"file": "starving",
		"tooltip": "Starving"
	},
	"state": {
		"file": "state",
		"tooltip": "State"
	},
	"statue": {
		"file": "statue",
		"tooltip": "Statue"
	},
	"steppe": {
		"file": "steppe",
		"tooltip": "Steppe"
	},
	"storage_house": {
		"file": "storage_house",
		"tooltip": "Storage House"
	},
	"store": {
		"file": "store",
		"tooltip": "Store"
	},
	"strait": {
		"file": "strait",
		"tooltip": "Strait"
	},
	"stream": {
		"file": "stream",
		"tooltip": "Stream"
	},
	"stringed_bow": {
		"file": "stringed_bow",
		"tooltip": "Stringed Bow"
	},
	"stringed_plucked": {
		"file": "stringed_plucked",
		"tooltip": "Stringed Plucked"
	},
	"study_of_abjuration": {
		"file": "study_of_abjuration",
		"tooltip": "Study Of Abjuration"
	},
	"study_of_charm": {
		"file": "study_of_charm",
		"tooltip": "Study Of Charm"
	},
	"study_of_conjuration": {
		"file": "study_of_conjuration",
		"tooltip": "Study Of Conjuration"
	},
	"study_of_dark_necromancy": {
		"file": "study_of_dark_necromancy",
		"tooltip": "Study Of Dark Necromancy"
	},
	"study_of_divination": {
		"file": "study_of_divination",
		"tooltip": "Study Of Divination"
	},
	"study_of_evocation": {
		"file": "study_of_evocation",
		"tooltip": "Study Of Evocation"
	},
	"study_of_gravity": {
		"file": "study_of_gravity",
		"tooltip": "Study Of Gravity"
	},
	"study_of_illusion": {
		"file": "study_of_illusion",
		"tooltip": "Study Of Illusion"
	},
	"study_of_necromancy": {
		"file": "study_of_necromancy",
		"tooltip": "Study Of Necromancy"
	},
	"study_of_time": {
		"file": "study_of_time",
		"tooltip": "Study Of Time"
	},
	"study_of_transmutation": {
		"file": "study_of_transmutation",
		"tooltip": "Study Of Transmutation"
	},
	"stunned": {
		"file": "stunned",
		"tooltip": "Stunned"
	},
	"subclass": {
		"file": "subclass",
		"tooltip": "Subclass"
	},
	"subcontinent": {
		"file": "subcontinent",
		"tooltip": "Subcontinent"
	},
	"suffocating": {
		"file": "suffocating",
		"tooltip": "Suffocating"
	},
	"summer": {
		"file": "summer",
		"tooltip": "Summer"
	},
	"summit": {
		"file": "summit",
		"tooltip": "Summit"
	},
	"summon_roll": {
		"file": "summon_roll",
		"tooltip": "Summon Roll"
	},
	"summon_tag": {
		"file": "summon_tag",
		"tooltip": "Summon Tag"
	},
	"sun_state_day": {
		"file": "sun_state_day",
		"tooltip": "Sun State Day"
	},
	"sun_state_night": {
		"file": "sun_state_night",
		"tooltip": "Sun State Night"
	},
	"sun_state_sunrise": {
		"file": "sun_state_sunrise",
		"tooltip": "Sun State Sunrise"
	},
	"sun_state_sunset": {
		"file": "sun_state_sunset",
		"tooltip": "Sun State Sunset"
	},
	"sunny": {
		"file": "sunny",
		"tooltip": "Clear"
	},
	"supercontinent": {
		"file": "supercontinent",
		"tooltip": "Supercontinent"
	},
	"supermarket_megastore": {
		"file": "supermarket_megastore",
		"tooltip": "Supermarket Megastore"
	},
	"support_role": {
		"file": "support_role",
		"tooltip": "Support Role"
	},
	"surprised": {
		"file": "surprised",
		"tooltip": "Surprised"
	},
	"swamp": {
		"file": "swamp",
		"tooltip": "Swamp"
	},
	"swampland": {
		"file": "swampland",
		"tooltip": "Swampland"
	},
	"sylvan": {
		"file": "sylvan",
		"tooltip": "Sylvan"
	},
	"tactics": {
		"file": "tactics",
		"tooltip": "Tactics"
	},
	"taiga": {
		"file": "taiga",
		"tooltip": "Taiga"
	},
	"tail": {
		"file": "tail",
		"tooltip": "Natural Weapon Form — Tail"
	},
	"tao_of_gentleness": {
		"file": "tao_of_gentleness",
		"tooltip": "Tao Of Gentleness"
	},
	"tao_of_ninjitsu": {
		"file": "tao_of_ninjitsu",
		"tooltip": "Tao Of Ninjitsu"
	},
	"tao_of_senjing_ganrao": {
		"file": "tao_of_senjing_ganrao",
		"tooltip": "Tao Of Senjing Ganrao"
	},
	"tao_of_the_blooming_fang": {
		"file": "tao_of_the_blooming_fang",
		"tooltip": "Tao Of The Blooming Fang"
	},
	"tao_of_the_cloudrunner": {
		"file": "tao_of_the_cloudrunner",
		"tooltip": "Tao Of The Cloudrunner"
	},
	"tao_of_the_courtesan": {
		"file": "tao_of_the_courtesan",
		"tooltip": "Tao Of The Courtesan"
	},
	"tao_of_the_dancing_spider": {
		"file": "tao_of_the_dancing_spider",
		"tooltip": "Tao Of The Dancing Spider"
	},
	"tao_of_the_dragon_warrior": {
		"file": "tao_of_the_dragon_warrior",
		"tooltip": "Tao Of The Dragon Warrior"
	},
	"tao_of_the_drunken_master": {
		"file": "tao_of_the_drunken_master",
		"tooltip": "Tao Of The Drunken Master"
	},
	"tao_of_the_painted_shell": {
		"file": "tao_of_the_painted_shell",
		"tooltip": "Tao Of The Painted Shell"
	},
	"tao_of_the_southern_star": {
		"file": "tao_of_the_southern_star",
		"tooltip": "Tao Of The Southern Star"
	},
	"tao_of_the_ten_thousand_limbs": {
		"file": "tao_of_the_ten_thousand_limbs",
		"tooltip": "Tao Of The Ten Thousand Limbs"
	},
	"tattoo_parlor": {
		"file": "tattoo_parlor",
		"tooltip": "Tattoo Parlor"
	},
	"tavern_pub_bar_restaurant": {
		"file": "tavern_pub_bar_restaurant",
		"tooltip": "Tavern Pub Bar Restaurant"
	},
	"technology_complex": {
		"file": "technology_complex",
		"tooltip": "Technology Complex"
	},
	"telepathy": {
		"file": "telepathy",
		"tooltip": "Telepathy"
	},
	"teleport": {
		"file": "teleport",
		"tooltip": "Teleport"
	},
	"temperature_chill": {
		"file": "temperature_chill",
		"tooltip": "Chill"
	},
	"temperature_cool": {
		"file": "temperature_cool",
		"tooltip": "Cool"
	},
	"temperature_frigid": {
		"file": "temperature_frigid",
		"tooltip": "Frigid"
	},
	"temperature_hot": {
		"file": "temperature_hot",
		"tooltip": "Hot"
	},
	"temperature_scorching": {
		"file": "temperature_scorching",
		"tooltip": "Scorching"
	},
	"temperature_temperate": {
		"file": "temperature_temperate",
		"tooltip": "Temperate"
	},
	"temperature_warm": {
		"file": "temperature_warm",
		"tooltip": "Warm"
	},
	"temple_church": {
		"file": "temple_church",
		"tooltip": "Temple Church"
	},
	"temporary_max_vitality_roll": {
		"file": "temporary_max_vitality_roll",
		"tooltip": "Temporary Max Vitality Roll"
	},
	"temporary_vitality_regeneration_roll": {
		"file": "temporary_vitality_regeneration_roll",
		"tooltip": "Temporary Vitality Regeneration Roll"
	},
	"temporary_vitality_roll": {
		"file": "temporary_vitality_roll",
		"tooltip": "Temporary Vitality Roll"
	},
	"terran": {
		"file": "terran",
		"tooltip": "Terran"
	},
	"territory": {
		"file": "territory",
		"tooltip": "Territory"
	},
	"theatre_concert_hall": {
		"file": "theatre_concert_hall",
		"tooltip": "Theatre Concert Hall"
	},
	"theme_park_entertainment_complex": {
		"file": "theme_park_entertainment_complex",
		"tooltip": "Theme Park Entertainment Complex"
	},
	"thieves_cant": {
		"file": "thieves_cant",
		"tooltip": "Thieves Cant"
	},
	"thirsty": {
		"file": "thirsty",
		"tooltip": "Thirsty"
	},
	"throwable_weapon_skill": {
		"file": "throwable_weapon_skill",
		"tooltip": "Throwable Weapon Skill"
	},
	"thunder": {
		"file": "thunder",
		"tooltip": "Thunder"
	},
	"timberyard": {
		"file": "timberyard",
		"tooltip": "Timberyard"
	},
	"tiny": {
		"file": "tiny",
		"tooltip": "Tiny"
	},
	"titanic": {
		"file": "titanic",
		"tooltip": "Titanic"
	},
	"tornado": {
		"file": "tornado",
		"tooltip": "Storm Wind"
	},
	"tower": {
		"file": "tower",
		"tooltip": "Tower"
	},
	"tower_guard": {
		"file": "tower_guard",
		"tooltip": "Tower Guard"
	},
	"tower_mage": {
		"file": "tower_mage",
		"tooltip": "Tower Mage"
	},
	"tower_shields": {
		"file": "tower_shields",
		"tooltip": "Tower Shields"
	},
	"tower_telecomms": {
		"file": "tower_telecomms",
		"tooltip": "Tower Telecomms"
	},
	"tower_wall": {
		"file": "tower_wall",
		"tooltip": "Tower Wall"
	},
	"tower_water": {
		"file": "tower_water",
		"tooltip": "Tower Water"
	},
	"town": {
		"file": "town",
		"tooltip": "Town"
	},
	"town_square": {
		"file": "town_square",
		"tooltip": "Town Square"
	},
	"trackers_brand": {
		"file": "trackers_brand",
		"tooltip": "Trackers Brand"
	},
	"trade_post": {
		"file": "trade_post",
		"tooltip": "Trade Post"
	},
	"trail_of_the_artillerist": {
		"file": "trail_of_the_artillerist",
		"tooltip": "Trail Of The Artillerist"
	},
	"trail_of_the_berserker": {
		"file": "trail_of_the_berserker",
		"tooltip": "Trail Of The Berserker"
	},
	"trail_of_the_broken_limits": {
		"file": "trail_of_the_broken_limits",
		"tooltip": "Trail Of The Broken Limits"
	},
	"trail_of_the_hallow_mind": {
		"file": "trail_of_the_hallow_mind",
		"tooltip": "Trail Of The Hallow Mind"
	},
	"trail_of_the_painbearer": {
		"file": "trail_of_the_painbearer",
		"tooltip": "Trail Of The Painbearer"
	},
	"trail_of_the_reaver": {
		"file": "trail_of_the_reaver",
		"tooltip": "Trail Of The Reaver"
	},
	"trail_of_the_shatterguard": {
		"file": "trail_of_the_shatterguard",
		"tooltip": "Trail Of The Shatterguard"
	},
	"trail_of_the_takedown": {
		"file": "trail_of_the_takedown",
		"tooltip": "Trail Of The Takedown"
	},
	"trail_of_the_untamed": {
		"file": "trail_of_the_untamed",
		"tooltip": "Trail Of The Untamed"
	},
	"train": {
		"file": "train",
		"tooltip": "Train"
	},
	"training": {
		"file": "training",
		"tooltip": "Training"
	},
	"training_in_bushido": {
		"file": "training_in_bushido",
		"tooltip": "Training In Bushido"
	},
	"training_in_fey_archery": {
		"file": "training_in_fey_archery",
		"tooltip": "Training In Fey Archery"
	},
	"training_in_juggernaut": {
		"file": "training_in_juggernaut",
		"tooltip": "Training In Juggernaut"
	},
	"training_in_precision": {
		"file": "training_in_precision",
		"tooltip": "Training In Precision"
	},
	"training_in_the_commander": {
		"file": "training_in_the_commander",
		"tooltip": "Training In The Commander"
	},
	"training_in_the_dragoon": {
		"file": "training_in_the_dragoon",
		"tooltip": "Training In The Dragoon"
	},
	"training_in_the_duelist": {
		"file": "training_in_the_duelist",
		"tooltip": "Training In The Duelist"
	},
	"training_in_the_gunslinger": {
		"file": "training_in_the_gunslinger",
		"tooltip": "Training In The Gunslinger"
	},
	"training_in_the_sentinel": {
		"file": "training_in_the_sentinel",
		"tooltip": "Training In The Sentinel"
	},
	"training_roll": {
		"file": "training_roll",
		"tooltip": "Training Roll"
	},
	"transportation_hub": {
		"file": "transportation_hub",
		"tooltip": "Transportation Hub"
	},
	"transportation_station": {
		"file": "transportation_station",
		"tooltip": "Transportation Station"
	},
	"trapped": {
		"file": "trapped",
		"tooltip": "Trapped"
	},
	"tremorsense": {
		"file": "tremorsense",
		"tooltip": "Tremorsense"
	},
	"tridents": {
		"file": "tridents",
		"tooltip": "Tridents"
	},
	"truesight": {
		"file": "truesight",
		"tooltip": "Truesight"
	},
	"truthsayer": {
		"file": "truthsayer",
		"tooltip": "Truthsayer"
	},
	"tundra": {
		"file": "tundra",
		"tooltip": "Tundra"
	},
	"two_handed_melee_weapon_skill": {
		"file": "two_handed_melee_weapon_skill",
		"tooltip": "Two-Handed Melee Weapon Skill"
	},
	"umbral": {
		"file": "umbral",
		"tooltip": "Umbral"
	},
	"unconscious": {
		"file": "unconscious",
		"tooltip": "Unconscious"
	},
	"undead": {
		"file": "undead",
		"tooltip": "Undead"
	},
	"underground": {
		"file": "underground",
		"tooltip": "Underground"
	},
	"underground_subterranean": {
		"file": "underground_subterranean",
		"tooltip": "Underground Subterranean"
	},
	"underground_vault": {
		"file": "underground_vault",
		"tooltip": "Underground Vault"
	},
	"underwater": {
		"file": "underwater",
		"tooltip": "Underwater"
	},
	"unimpeded": {
		"file": "unimpeded",
		"tooltip": "Unimpeded"
	},
	"universe": {
		"file": "universe",
		"tooltip": "Universe"
	},
	"university_educational_complex": {
		"file": "university_educational_complex",
		"tooltip": "University Educational Complex"
	},
	"unspecified_gender": {
		"file": "unspecified_gender",
		"tooltip": "Unspecified Gender"
	},
	"urban": {
		"file": "urban",
		"tooltip": "Urban"
	},
	"vale": {
		"file": "vale",
		"tooltip": "Vale"
	},
	"valley": {
		"file": "valley",
		"tooltip": "Valley"
	},
	"very_squeezed": {
		"file": "very_squeezed",
		"tooltip": "Very Squeezed"
	},
	"vessel_of_aegis": {
		"file": "vessel_of_aegis",
		"tooltip": "Vessel Of Aegis"
	},
	"vessel_of_cataclysm": {
		"file": "vessel_of_cataclysm",
		"tooltip": "Vessel Of Cataclysm"
	},
	"vessel_of_dispersion": {
		"file": "vessel_of_dispersion",
		"tooltip": "Vessel Of Dispersion"
	},
	"vessel_of_enhancement": {
		"file": "vessel_of_enhancement",
		"tooltip": "Vessel Of Enhancement"
	},
	"vessel_of_evolution": {
		"file": "vessel_of_evolution",
		"tooltip": "Vessel Of Evolution"
	},
	"vessel_of_restoration": {
		"file": "vessel_of_restoration",
		"tooltip": "Vessel Of Restoration"
	},
	"vessel_of_spirits": {
		"file": "vessel_of_spirits",
		"tooltip": "Vessel Of Spirits"
	},
	"vessel_of_stars": {
		"file": "vessel_of_stars",
		"tooltip": "Vessel Of Stars"
	},
	"village": {
		"file": "village",
		"tooltip": "Village"
	},
	"void": {
		"file": "void",
		"tooltip": "Void"
	},
	"volcano": {
		"file": "volcano",
		"tooltip": "Volcano"
	},
	"volcano_underwater": {
		"file": "volcano_underwater",
		"tooltip": "Volcano Underwater"
	},
	"vulnerable": {
		"file": "vulnerable",
		"tooltip": "Vulnerable"
	},
	"waist": {
		"file": "waist",
		"tooltip": "Waist"
	},
	"war_picks": {
		"file": "war_picks",
		"tooltip": "War Picks"
	},
	"ward": {
		"file": "ward",
		"tooltip": "Ward"
	},
	"warehouse_granary": {
		"file": "warehouse_granary",
		"tooltip": "Warehouse Granary"
	},
	"warhammers": {
		"file": "warhammers",
		"tooltip": "Warhammers"
	},
	"wasteland": {
		"file": "wasteland",
		"tooltip": "Wasteland"
	},
	"water_pump": {
		"file": "water_pump",
		"tooltip": "Water Pump"
	},
	"water_walk_effect": {
		"file": "water_walk_effect",
		"tooltip": "Water Walk Effect"
	},
	"waterfall": {
		"file": "waterfall",
		"tooltip": "Waterfall"
	},
	"weakened": {
		"file": "weakened",
		"tooltip": "Weakened"
	},
	"weapon_attack_roll_assistance_roll": {
		"file": "weapon_attack_roll_assistance_roll",
		"tooltip": "Weapon Attack Roll Assistance Roll"
	},
	"weapon_melee_attack_roll": {
		"file": "weapon_melee_attack_roll",
		"tooltip": "Weapon Melee Attack Roll"
	},
	"weapon_ranged_attack_roll": {
		"file": "weapon_ranged_attack_roll",
		"tooltip": "Weapon Ranged Attack Roll"
	},
	"weapon_size_colossal": {
		"file": "weapon",
		"tooltip": "Weapon Size: Colossal"
	},
	"weapon_size_gargantuan": {
		"file": "weapon",
		"tooltip": "Weapon Size: Gargantuan"
	},
	"weapon_size_huge": {
		"file": "weapon",
		"tooltip": "Weapon Size: Huge"
	},
	"weapon_size_large": {
		"file": "weapon",
		"tooltip": "Weapon Size: Large"
	},
	"weapon_size_tiny": {
		"file": "weapon",
		"tooltip": "Weapon Size: Tiny"
	},
	"weapon_size_titanic": {
		"file": "weapon",
		"tooltip": "Weapon Size: Titantic"
	},
	"weary": {
		"file": "weary",
		"tooltip": "Weary"
	},
	"weaving": {
		"file": "weaving",
		"tooltip": "Weaving"
	},
	"well": {
		"file": "well",
		"tooltip": "Well"
	},
	"well_bloodied": {
		"file": "well_bloodied",
		"tooltip": "Well Bloodied"
	},
	"well_large": {
		"file": "well_large",
		"tooltip": "Well Large"
	},
	"wenhe_stance": {
		"file": "wenhe_stance",
		"tooltip": "Wenhe Stance"
	},
	"wet": {
		"file": "wet",
		"tooltip": "Wet"
	},
	"wetland": {
		"file": "wetland",
		"tooltip": "Wetland"
	},
	"whips": {
		"file": "whips",
		"tooltip": "Whips"
	},
	"willpower": {
		"file": "willpower",
		"tooltip": "Willpower"
	},
	"wind_breeze": {
		"file": "wind_breeze",
		"tooltip": "Breeze"
	},
	"wind_still": {
		"file": "wind_still",
		"tooltip": "Still"
	},
	"windmill": {
		"file": "windmill",
		"tooltip": "Windmill"
	},
	"windy": {
		"file": "windy",
		"tooltip": "Strong Wind"
	},
	"winter": {
		"file": "winter",
		"tooltip": "Winter"
	},
	"withdraw": {
		"file": "withdraw",
		"tooltip": "Withdraw"
	},
	"withering": {
		"file": "withering",
		"tooltip": "Withering"
	},
	"woods": {
		"file": "woods",
		"tooltip": "Woods"
	},
	"woodworking": {
		"file": "woodworking",
		"tooltip": "Woodworking"
	},
	"workshop": {
		"file": "workshop",
		"tooltip": "Workshop"
	},
	"world": {
		"file": "world",
		"tooltip": "World"
	},
	"world_wonder": {
		"file": "world_wonder",
		"tooltip": "World Wonder"
	},
	"wormhole": {
		"file": "wormhole",
		"tooltip": "Wormhole"
	},
	"wounded": {
		"file": "wounded",
		"tooltip": "Wounded"
	},
	"yun_stance": {
		"file": "yun_stance",
		"tooltip": "Yun Stance"
	},
	"zithers": {
		"file": "zithers",
		"tooltip": "Zithers"
	}
};
